import React, { useState, useEffect, useRef, useCallback } from "react";
import { toast } from "sonner";
import MetaCampaigns from "./MetaCampaigns";
import Ico from './ui/Ico';

// ─── Metadados de Redes ────────────────────────────────────────────────────────
const NETWORK_META = {
  instagram: {
    id: "instagram",
    name: "Instagram",
    color: "#E4405F",
    bg: "#fdf2f8",
    icon: <Ico e="📸" bare />,
    channels: [
      { id: "feed", label: "Feed" },
      { id: "stories", label: "Stories" },
      { id: "reels", label: "Reels" },
    ],
  },
  facebook: {
    id: "facebook",
    name: "Facebook",
    color: "#1877F2",
    bg: "#eff6ff",
    icon: <Ico e="👥" bare />,
    channels: [
      { id: "feed", label: "Feed" },
      { id: "stories", label: "Stories" },
      { id: "reels", label: "Reels" },
    ],
  },
  linkedin: {
    id: "linkedin",
    name: "LinkedIn",
    color: "#0A66C2",
    bg: "#eff6ff",
    icon: <Ico e="💼" bare />,
    channels: [{ id: "feed", label: "Feed" }],
  },
  // twitter: {
  //   id: "twitter",
  //   name: "X (Twitter)",
  //   color: "#000000",
  //   bg: "#f9fafb",
  //   icon: "𝕏",
  //   channels: [{ id: "feed", label: "Post" }],
  // },
  // pinterest: {
  //   id: "pinterest",
  //   name: "Pinterest",
  //   color: "#E60023",
  //   bg: "#fff1f2",
  //   icon: "📌",
  //   channels: [{ id: "pin", label: "Pin" }],
  // },
  // youtube: {
  //   id: "youtube",
  //   name: "YouTube",
  //   color: "#FF0000",
  //   bg: "#fff1f2",
  //   icon: "▶️",
  //   channels: [
  //     { id: "video", label: "Vídeo" },
  //     { id: "shorts", label: "Shorts" },
  //   ],
  // },
};
const ALL_NETWORKS = Object.keys(NETWORK_META);

// ─── Ícones por canal/modalidade ───────────────────────────────────────────────
const CHANNEL_ICONS = {
  feed: (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5">
      <rect x="1" y="1" width="6" height="6" rx="1" />
      <rect x="9" y="1" width="6" height="6" rx="1" />
      <rect x="1" y="9" width="6" height="6" rx="1" />
      <rect x="9" y="9" width="6" height="6" rx="1" />
    </svg>
  ),
  stories: (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5">
      <rect x="4" y="0.5" width="8" height="15" rx="2" />
    </svg>
  ),
  reels: (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5">
      <circle
        cx="8"
        cy="8"
        r="7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <polygon points="6,5 12,8 6,11" />
    </svg>
  ),
  video: (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5">
      <rect x="1" y="3" width="9" height="10" rx="1.5" />
      <polygon points="11,5.5 15,8 11,10.5" />
    </svg>
  ),
  shorts: (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5">
      <rect
        x="3"
        y="0.5"
        width="10"
        height="15"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <polygon points="6,6 11,8 6,10" />
    </svg>
  ),
  post: (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5">
      <path d="M14 2H2a1 1 0 00-1 1v8a1 1 0 001 1h3l2 2 2-2h5a1 1 0 001-1V3a1 1 0 00-1-1z" />
    </svg>
  ),
  pin: (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5">
      <path d="M8 1a4 4 0 014 4c0 3-4 10-4 10S4 8 4 5a4 4 0 014-4zm0 2a2 2 0 100 4 2 2 0 000-4z" />
    </svg>
  ),
};

// ─── Campos avançados por rede ─────────────────────────────────────────────────
const ADVANCED_FIELDS = {
  instagram: [
    {
      id: "firstComment",
      label: "Primeiro comentário / Hashtags",
      type: "textarea",
      placeholder: "#hashtags ou texto fixado no 1º comentário",
      maxLength: 2200,
      hint: "Publicado automaticamente como 1º comentário",
    },
    {
      id: "location",
      label: "Localização",
      type: "text",
      placeholder: "Ex.: São Paulo, SP",
    },
    {
      id: "collaborators",
      label: "Colaboradores (Collab)",
      type: "text",
      placeholder: "@perfil1, @perfil2 (máx. 3)",
    },
    {
      id: "altText",
      label: "Texto alternativo (acessibilidade)",
      type: "text",
      placeholder: "Descreva a imagem para deficientes visuais",
      maxLength: 1000,
    },
    {
      id: "paidPartnership",
      label: "Parceria paga / Conteúdo patrocinado",
      type: "toggle",
      default: false,
    },
    {
      id: "shareToFeed",
      label: "Compartilhar Reels no feed",
      type: "toggle",
      default: true,
    },
    {
      id: "disableComments",
      label: "Desativar comentários",
      type: "toggle",
      default: false,
    },
  ],
  facebook: [
    {
      id: "firstComment",
      label: "Primeiro comentário",
      type: "textarea",
      placeholder: "Comentário automático após publicar",
      maxLength: 8000,
    },
    {
      id: "link",
      label: "Link anexado",
      type: "text",
      placeholder: "https://...",
    },
    {
      id: "targetAudience",
      label: "Audiência",
      type: "select",
      default: "EVERYONE",
      options: [
        { value: "EVERYONE", label: "Todos" },
        { value: "FRIENDS", label: "Amigos" },
        { value: "ONLY_ME", label: "Somente eu" },
      ],
    },
    {
      id: "feeling",
      label: "Sentimento/Atividade",
      type: "text",
      placeholder: "Ex.: me sentindo animado 🎉",
    },
  ],
  linkedin: [
    {
      id: "visibility",
      label: "Visibilidade",
      type: "select",
      default: "PUBLIC",
      options: [
        { value: "PUBLIC", label: "Público" },
        { value: "CONNECTIONS", label: "Apenas conexões" },
        { value: "LOGGED_IN", label: "Membros LinkedIn" },
      ],
    },
    {
      id: "firstComment",
      label: "Primeiro comentário",
      type: "textarea",
      placeholder: "Comentário automático após publicar",
      maxLength: 3000,
    },
    {
      id: "targetedAudience",
      label: "Público-alvo (segmentação)",
      type: "text",
      placeholder: "Ex.: profissionais de TI, São Paulo",
    },
    {
      id: "paidPartnership",
      label: "Conteúdo patrocinado",
      type: "toggle",
      default: false,
    },
  ],
  // twitter: [
  //   {
  //     id: "replySettings",
  //     label: "Quem pode responder",
  //     type: "select",
  //     default: "everyone",
  //     options: [
  //       { value: "everyone", label: "Todos" },
  //       { value: "following", label: "Quem você segue" },
  //       { value: "mentioned", label: "Apenas mencionados" },
  //     ],
  //   },
  //   {
  //     id: "thread",
  //     label: "Thread (tweets adicionais)",
  //     type: "textarea",
  //     placeholder: "Um tweet por linha (limitado a 280 chars cada)",
  //     hint: "Cada linha = um tweet da thread",
  //   },
  // ],
  // pinterest: [
  //   {
  //     id: "title",
  //     label: "Título do Pin",
  //     type: "text",
  //     placeholder: "Título atrativo",
  //     maxLength: 100,
  //     required: true,
  //   },
  //   {
  //     id: "destinationLink",
  //     label: "Link de destino",
  //     type: "text",
  //     placeholder: "https://seusite.com",
  //     hint: "URL para onde o pin direciona",
  //   },
  //   {
  //     id: "board",
  //     label: "Board (quadro)",
  //     type: "text",
  //     placeholder: "Nome exato do quadro",
  //     required: true,
  //   },
  //   {
  //     id: "section",
  //     label: "Seção do board",
  //     type: "text",
  //     placeholder: "Nome da seção (opcional)",
  //   },
  //   {
  //     id: "altText",
  //     label: "Texto alternativo",
  //     type: "text",
  //     placeholder: "Descreva a imagem",
  //     maxLength: 500,
  //   },
  // ],
  // youtube: [
  //   {
  //     id: "title",
  //     label: "Título do vídeo",
  //     type: "text",
  //     placeholder: "Título cativante (máx. 100 chars)",
  //     maxLength: 100,
  //     required: true,
  //     hint: "Obrigatório — afeta diretamente o ranqueamento",
  //   },
  //   {
  //     id: "description",
  //     label: "Descrição do vídeo",
  //     type: "textarea",
  //     placeholder: "Descrição completa, links, timestamps...",
  //     maxLength: 5000,
  //     hint: "Inclua palavras-chave nos primeiros 150 chars",
  //   },
  //   {
  //     id: "tags",
  //     label: "Tags / Palavras-chave",
  //     type: "text",
  //     placeholder: "tag1, tag2, tag3 (máx. 500 chars total)",
  //     hint: "Separe por vírgula",
  //   },
  //   {
  //     id: "category",
  //     label: "Categoria",
  //     type: "select",
  //     required: true,
  //     default: "22",
  //     options: [
  //       { value: "1", label: "Filmes e Animações" },
  //       { value: "2", label: "Automóveis e Veículos" },
  //       { value: "10", label: "Música" },
  //       { value: "15", label: "Animais de Estimação" },
  //       { value: "17", label: "Esportes" },
  //       { value: "19", label: "Viagens e Eventos" },
  //       { value: "20", label: "Jogos" },
  //       { value: "22", label: "Pessoas e Blogs" },
  //       { value: "23", label: "Comédia" },
  //       { value: "24", label: "Entretenimento" },
  //       { value: "25", label: "Notícias e Política" },
  //       { value: "26", label: "Como Fazer e Estilo" },
  //       { value: "27", label: "Educação" },
  //       { value: "28", label: "Ciência e Tecnologia" },
  //       { value: "29", label: "Organizações sem fins lucrativos" },
  //     ],
  //   },
  //   {
  //     id: "playlist",
  //     label: "Playlist",
  //     type: "text",
  //     placeholder: "Nome da playlist (opcional)",
  //   },
  //   {
  //     id: "privacy",
  //     label: "Privacidade",
  //     type: "select",
  //     default: "public",
  //     options: [
  //       { value: "public", label: "Público" },
  //       { value: "unlisted", label: "Não listado" },
  //       { value: "private", label: "Privado" },
  //     ],
  //   },
  //   {
  //     id: "madeForKids",
  //     label: "Conteúdo para crianças (COPPA)",
  //     type: "toggle",
  //     default: false,
  //     hint: "Obrigatório declarar — afeta monetização e comentários",
  //   },
  //   {
  //     id: "allowComments",
  //     label: "Permitir comentários",
  //     type: "toggle",
  //     default: true,
  //   },
  //   {
  //     id: "allowRatings",
  //     label: "Permitir avaliações (likes)",
  //     type: "toggle",
  //     default: true,
  //   },
  //   {
  //     id: "embeddable",
  //     label: "Permitir incorporação (embed)",
  //     type: "toggle",
  //     default: true,
  //   },
  //   {
  //     id: "notifySubscribers",
  //     label: "Notificar inscritos",
  //     type: "toggle",
  //     default: true,
  //   },
  // ],
};

function defaultAdvancedFor(net) {
  const result = {};
  for (const field of ADVANCED_FIELDS[net] || []) {
    if (field.default !== undefined) result[field.id] = field.default;
  }
  return result;
}

// ─── Logos SVG das Redes Sociais ───────────────────────────────────────────────
const NETWORK_LOGOS = {
  instagram: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <defs>
        <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%">
          <stop offset="0%" stopColor="#fdf497" />
          <stop offset="5%" stopColor="#fdf497" />
          <stop offset="45%" stopColor="#fd5949" />
          <stop offset="60%" stopColor="#d6249f" />
          <stop offset="90%" stopColor="#285AEB" />
        </radialGradient>
      </defs>
      <rect width="24" height="24" rx="5.5" fill="url(#ig-grad)" />
      <rect
        x="6.5"
        y="6.5"
        width="11"
        height="11"
        rx="3.5"
        stroke="white"
        strokeWidth="1.5"
        fill="none"
      />
      <circle
        cx="12"
        cy="12"
        r="2.8"
        stroke="white"
        strokeWidth="1.5"
        fill="none"
      />
      <circle cx="16.3" cy="7.7" r="0.9" fill="white" />
    </svg>
  ),
  facebook: (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <rect width="24" height="24" rx="5.5" fill="#1877F2" />
      <path
        d="M13.5 21v-7.5h2.25l.375-2.625H13.5v-1.5c0-.75.375-1.5 1.5-1.5H16.5V5.625S15.375 5.25 14.25 5.25c-2.25 0-3.75 1.5-3.75 3.75v1.875H8.25V13.5H10.5V21H13.5z"
        fill="white"
      />
    </svg>
  ),
  linkedin: (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <rect width="24" height="24" rx="4" fill="#0A66C2" />
      <path
        d="M7.5 10.5H5.25V18H7.5V10.5ZM6.375 9.375a1.3 1.3 0 100-2.6 1.3 1.3 0 000 2.6zM18.75 18h-2.25v-3.75c0-2.25-2.625-2.1-2.625 0V18H11.625V10.5H13.875v1.2C14.85 9.825 18.75 9.75 18.75 13.875V18z"
        fill="white"
      />
    </svg>
  ),
  meta: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="currentColor"
      class="meta"
      viewBox="0 0 30 30"
    >
      <rect width="30" height="30" rx="5.5" fill="#1877F2" />
      <g transform="translate(7, 7)">
        <path
          fill-rule="evenodd"
          d="M8.217 5.243C9.145 3.988 10.171 3 11.483 3 13.96 3 16 6.153 16.001 9.907c0 2.29-.986 3.725-2.757 3.725-1.543 0-2.395-.866-3.924-3.424l-.667-1.123-.118-.197a55 55 0 0 0-.53-.877l-1.178 2.08c-1.673 2.925-2.615 3.541-3.923 3.541C1.086 13.632 0 12.217 0 9.973 0 6.388 1.995 3 4.598 3q.477-.001.924.122c.31.086.611.22.913.407.577.359 1.154.915 1.782 1.714m1.516 2.224q-.378-.615-.727-1.133L9 6.326c.845-1.305 1.543-1.954 2.372-1.954 1.723 0 3.102 2.537 3.102 5.653 0 1.188-.39 1.877-1.195 1.877-.773 0-1.142-.51-2.61-2.87zM4.846 4.756c.725.1 1.385.634 2.34 2.001A212 212 0 0 0 5.551 9.3c-1.357 2.126-1.826 2.603-2.581 2.603-.777 0-1.24-.682-1.24-1.9 0-2.602 1.298-5.264 2.846-5.264q.137 0 .27.018"
          fill="white"
        />
      </g>
    </svg>
  ),
  // twitter: (
  //   <svg
  //     viewBox="0 0 24 24"
  //     xmlns="http://www.w3.org/2000/svg"
  //     className="w-full h-full"
  //   >
  //     <rect width="24" height="24" rx="5.5" fill="#000" />
  //     <path
  //       d="M13.38 10.985L17.818 6h-1.05l-3.862 4.312L9.74 6H6.375l4.657 6.512-4.657 5.238h1.051l4.074-4.568 3.25 4.568H18.25L13.38 10.985zm-1.44 1.615l-.472-.648L7.8 6.78H9.24l3.027 4.163.471.648 3.94 5.413h-1.44l-3.298-4.404z"
  //       fill="white"
  //     />
  //   </svg>
  // ),
  // pinterest: (
  //   <svg
  //     viewBox="0 0 24 24"
  //     xmlns="http://www.w3.org/2000/svg"
  //     className="w-full h-full"
  //   >
  //     <rect width="24" height="24" rx="5.5" fill="#E60023" />
  //     <path
  //       d="M12 3.75C7.44 3.75 3.75 7.44 3.75 12c0 3.45 2.1 6.45 5.1 7.8-.075-.675-.15-1.725.03-2.475.165-.675 1.11-4.5 1.11-4.5s-.285-.57-.285-1.41c0-1.32.765-2.31 1.71-2.31.81 0 1.2.6 1.2 1.32 0 .81-.51 2.01-.78 3.12-.225.93.465 1.68 1.38 1.68 1.65 0 2.925-1.74 2.925-4.245 0-2.22-1.59-3.765-3.87-3.765-2.64 0-4.185 1.98-4.185 4.02 0 .795.3 1.65.675 2.115a.27.27 0 01.06.255c-.069.285-.225.93-.255 1.065-.03.165-.12.195-.27.12-1.005-.465-1.635-1.935-1.635-3.12 0-2.535 1.845-4.875 5.31-4.875 2.79 0 4.965 1.98 4.965 4.635 0 2.76-1.74 4.98-4.155 4.98-.81 0-1.575-.42-1.83-.915l-.51 1.89c-.18.69-.675 1.56-1.005 2.085.75.225 1.545.345 2.37.345 4.56 0 8.25-3.69 8.25-8.25S16.56 3.75 12 3.75z"
  //       fill="white"
  //     />
  //   </svg>
  // ),
  // youtube: (
  //   <svg
  //     viewBox="0 0 24 24"
  //     xmlns="http://www.w3.org/2000/svg"
  //     className="w-full h-full"
  //   >
  //     <rect width="24" height="24" rx="5.5" fill="#FF0000" />
  //     <path
  //       d="M19.8 8.4a2.25 2.25 0 00-1.575-1.575C16.8 6.5 12 6.5 12 6.5s-4.8 0-6.225.375A2.25 2.25 0 004.2 8.4C3.825 9.825 3.825 12 3.825 12s0 2.175.375 3.6A2.25 2.25 0 005.775 17.2C7.2 17.5 12 17.5 12 17.5s4.8 0 6.225-.375A2.25 2.25 0 0019.8 15.6c.375-1.425.375-3.6.375-3.6s0-2.175-.375-3.6z"
  //       fill="white"
  //       fillOpacity="0.9"
  //     />
  //     <path d="M10.5 14.25l4.125-2.25L10.5 9.75v4.5z" fill="#FF0000" />
  //   </svg>
  // ),
};

const NetworkLogo = ({ networkId, size = 40 }) => {
  const logo = NETWORK_LOGOS[networkId];
  if (!logo) {
    const n = NETWORK_META[networkId];
    return <span style={{ fontSize: size * 0.55 }}>{n?.icon || <><Ico e="📱" /></>}</span>;
  }
  return <div style={{ width: size, height: size }}>{logo}</div>;
};

// ─── Helpers visuais ──────────────────────────────────────────────────────────
const Spinner = () => (
  <svg
    className="w-4 h-4 animate-spin inline-block"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
  </svg>
);

const NetworkBadge = ({ networkId, small }) => {
  const n = NETWORK_META[networkId];
  if (!n) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${small ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-xs"}`}
      style={{
        background: n.bg,
        color: n.color,
        border: `1px solid ${n.color}30`,
      }}
    >
      {n.icon} {!small && n.name}
    </span>
  );
};

const Toggle = ({ value, onChange }) => (
  <button
    type="button"
    role="switch"
    aria-checked={!!value}
    onClick={() => onChange(!value)}
    className={`w-10 h-5 rounded-full transition-colors relative flex-shrink-0 ${value ? "bg-blue-600" : "bg-gray-200"}`}
  >
    <span
      className={`absolute top-0.5 left-0.5 bg-white w-4 h-4 rounded-full transition-transform shadow ${value ? "translate-x-5" : "translate-x-0"}`}
    />
  </button>
);

const STATUS_MAP = {
  draft: { bg: "#f3f4f6", color: "#6b7280", label: "Rascunho" },
  rascunho: { bg: "#f3f4f6", color: "#6b7280", label: "Rascunho" },
  scheduled: { bg: "#eff6ff", color: "#2563eb", label: "Agendado" },
  agendado: { bg: "#eff6ff", color: "#2563eb", label: "Agendado" },
  published: { bg: "#f0fdf4", color: "#16a34a", label: "Publicado" },
  publicado: { bg: "#f0fdf4", color: "#16a34a", label: "Publicado" },
  failed: { bg: "#fef2f2", color: "#dc2626", label: "Falhou" },
  active: { bg: "#f0fdf4", color: "#16a34a", label: "Ativa" },
  ativa: { bg: "#f0fdf4", color: "#16a34a", label: "Ativa" },
  paused: { bg: "#fef9c3", color: "#ca8a04", label: "Pausada" },
  pausada: { bg: "#fef9c3", color: "#ca8a04", label: "Pausada" },
  completed: { bg: "#eff6ff", color: "#2563eb", label: "Concluída" },
  concluida: { bg: "#eff6ff", color: "#2563eb", label: "Concluída" },
};

const StatusBadge = ({ status }) => {
  const s = STATUS_MAP[status] || STATUS_MAP.draft;
  return (
    <span
      className="px-2 py-0.5 rounded-full text-xs font-semibold"
      style={{ background: s.bg, color: s.color }}
    >
      {s.label}
    </span>
  );
};

function RequirementStatusCard({ title, item }) {
  return (
    <div
      className={`rounded-2xl border p-4 ${item?.ready ? "border-emerald-200 bg-emerald-50/70" : "border-amber-200 bg-amber-50/80"}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-slate-900">{title}</p>
          <p className="mt-1 text-xs text-slate-500">{item?.label}</p>
        </div>
        <span
          className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-bold ${item?.ready ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}
        >
          {item?.ready ? "Pronto" : "Pendente"}
        </span>
      </div>
      <p
        className={`mt-3 text-xs leading-relaxed ${item?.ready ? "text-emerald-700" : "text-amber-700"}`}
      >
        {item?.ready
          ? "Este módulo está pronto para uso."
          : "Este módulo ainda depende de configuração para operar corretamente."}
      </p>
    </div>
  );
}

// ─── SavedLibrary inline (hashtags + assinaturas para o editor) ────────────────
function SavedLibraryInline({ api, onApply }) {
  const [hashtags, setHashtags] = useState([]);
  const [signatures, setSignatures] = useState([]);
  const [activeSection, setActiveSection] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [formName, setFormName] = useState("");
  const [formContent, setFormContent] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [hSel, setHSel] = useState("");
  const [sSel, setSSel] = useState("");

  const load = useCallback(() => {
    api
      .get("/nexohub/hashtag-sets")
      .then((r) => setHashtags(r.data || []))
      .catch(() => {});
    api
      .get("/nexohub/signatures")
      .then((r) => setSignatures(r.data || []))
      .catch(() => {});
  }, [api]);

  useEffect(() => {
    load();
  }, [load]);

  const openCreate = (section) => {
    setActiveSection(section);
    setEditItem(null);
    setFormName("");
    setFormContent("");
  };
  const openEdit = (section, item) => {
    setActiveSection(section);
    setEditItem(item);
    setFormName(item.name);
    setFormContent(item.content);
  };
  const closePanel = () => {
    setActiveSection(null);
    setEditItem(null);
  };

  const handleSave = async () => {
    if (!formName.trim() || !formContent.trim()) {
      toast.error("Preencha nome e conteúdo.");
      return;
    }
    setSaving(true);
    try {
      const ep =
        activeSection === "hashtags"
          ? "/nexohub/hashtag-sets"
          : "/nexohub/signatures";
      if (editItem)
        await api.put(`${ep}/${editItem.id}`, {
          name: formName.trim(),
          content: formContent.trim(),
        });
      else
        await api.post(ep, {
          name: formName.trim(),
          content: formContent.trim(),
        });
      toast.success(editItem ? "Atualizado!" : "Salvo!");
      load();
      closePanel();
    } catch {
      toast.error("Erro ao salvar.");
    }
    setSaving(false);
  };

  const handleDelete = async (section, id) => {
    if (!window.confirm("Excluir este item?")) return;
    setDeleting(id);
    try {
      const ep =
        section === "hashtags"
          ? `/nexohub/hashtag-sets/${id}`
          : `/nexohub/signatures/${id}`;
      await api.delete(ep);
      toast.success("Removido.");
      load();
    } catch {
      toast.error("Erro ao remover.");
    }
    setDeleting(null);
  };

  const applyItem = (items, id, setter) => {
    const item = items.find((i) => String(i.id) === id);
    if (item && onApply) {
      onApply(item.content);
      toast.success(`"${item.name}" aplicado.`);
    }
    setter("");
  };

  const renderList = (section, items) => (
    <div className="space-y-1.5">
      {items.length === 0 ? (
        <p className="text-xs text-gray-400 py-1 text-center">
          Nenhum salvo ainda.
        </p>
      ) : (
        items.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-2 p-2 rounded-lg border border-gray-100 bg-gray-50"
          >
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-gray-700 truncate">
                {item.name}
              </p>
              <p className="text-xs text-gray-400 truncate">{item.content}</p>
            </div>
            <div className="flex gap-1 flex-shrink-0">
              <button
                onClick={() => openEdit(section, item)}
                className="p-1 text-gray-400 hover:text-blue-600 transition-colors text-sm"
              >
                <Ico e="✏" bare />
              </button>
              <button
                onClick={() => handleDelete(section, item.id)}
                disabled={deleting === item.id}
                className="p-1 text-gray-400 hover:text-red-500 transition-colors text-sm"
              >
                {deleting === item.id ? <Spinner /> : <><Ico e="🗑" /></>}
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );

  return (
    <div className="space-y-3">
      <div>
        <div className="flex items-center mb-1.5">
          <span className="text-xs font-bold text-gray-500 uppercase tracking-wide">
            # Hashtag Sets
          </span>
          <button
            onClick={() => openCreate("hashtags")}
            className="ml-auto text-xs text-blue-600 hover:underline"
          >
            + Novo
          </button>
        </div>
        <div className="flex gap-2 mb-2">
          <select
            value={hSel}
            onChange={(e) => {
              setHSel(e.target.value);
              applyItem(hashtags, e.target.value, setHSel);
            }}
            className="flex-1 text-xs border border-gray-200 rounded-lg px-2 py-1.5 bg-white"
          >
            <option value="">Inserir conjunto de hashtags...</option>
            {hashtags.map((h) => (
              <option key={h.id} value={h.id}>
                {h.name}
              </option>
            ))}
          </select>
        </div>
        {renderList("hashtags", hashtags)}
      </div>

      <div>
        <div className="flex items-center mb-1.5">
          <span className="text-xs font-bold text-gray-500 uppercase tracking-wide">
            <Ico e="✍" />Assinaturas
          </span>
          <button
            onClick={() => openCreate("signatures")}
            className="ml-auto text-xs text-blue-600 hover:underline"
          >
            + Nova
          </button>
        </div>
        <div className="flex gap-2 mb-2">
          <select
            value={sSel}
            onChange={(e) => {
              setSSel(e.target.value);
              applyItem(signatures, e.target.value, setSSel);
            }}
            className="flex-1 text-xs border border-gray-200 rounded-lg px-2 py-1.5 bg-white"
          >
            <option value="">Inserir assinatura...</option>
            {signatures.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>
        {renderList("signatures", signatures)}
      </div>

      {activeSection && (
        <div className="border border-blue-200 bg-blue-50 rounded-xl p-3 space-y-2">
          <p className="text-xs font-bold text-blue-700">
            {editItem ? "Editar" : "Novo"}{" "}
            {activeSection === "hashtags"
              ? "Conjunto de Hashtags"
              : "Assinatura"}
          </p>
          <input
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
            placeholder={
              activeSection === "hashtags"
                ? "Ex.: Café especial"
                : "Ex.: Assinatura padrão"
            }
            className="w-full text-xs border border-blue-200 rounded-lg px-2 py-1.5 bg-white"
          />
          <textarea
            value={formContent}
            onChange={(e) => setFormContent(e.target.value)}
            placeholder={
              activeSection === "hashtags"
                ? "#cafe #especial #sustentavel"
                : "— Equipe NexoSynX 🚀"
            }
            className="w-full text-xs border border-blue-200 rounded-lg px-2 py-1.5 bg-white min-h-[50px] resize-none"
          />
          <div className="flex gap-2">
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-3 py-1.5 text-xs font-bold bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-60 flex items-center gap-1"
            >
              {saving && <Spinner />} {editItem ? "Salvar" : "Adicionar"}
            </button>
            <button
              onClick={closePanel}
              className="px-3 py-1.5 text-xs text-gray-500 hover:text-gray-700"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── TAB: Dashboard ────────────────────────────────────────────────────────────
function DashboardTab({ api, onNavigate }) {
  const [stats, setStats] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/nexohub/dashboard")
      .then((r) => {
        setStats(r.data.stats);
        setPosts(r.data.upcoming_posts || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api]);

  const statCards = [
    {
      label: "Posts Agendados",
      value: stats?.scheduled ?? 0,
      icon: <Ico e="📅" bare />,
      color: "#2563EB",
      sub: "próximos 30 dias",
    },
    {
      label: "Campanhas Ativas",
      value: stats?.campaigns ?? 0,
      icon: <Ico e="🚀" bare />,
      color: "#10b981",
      sub: "em andamento",
    },
    {
      label: "Contas Conectadas",
      value: stats?.accounts ?? 0,
      icon: <Ico e="🔗" bare />,
      color: "#8b5cf6",
      sub: "redes sincronizadas",
    },
    {
      label: "Posts Publicados",
      value: stats?.published ?? 0,
      icon: <Ico e="✅" bare />,
      color: "#f59e0b",
      sub: "histórico total",
    },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {statCards.map((c) => (
          <div
            key={c.label}
            className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100"
          >
            <div className="flex items-start justify-between">
              <div>
                <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">
                  {c.label}
                </p>
                <p className="text-2xl font-bold text-gray-900 mt-1">
                  {loading ? "—" : c.value}
                </p>
                {c.sub && (
                  <p className="text-xs text-gray-400 mt-0.5">{c.sub}</p>
                )}
              </div>
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center text-xl"
                style={{ background: c.color + "20" }}
              >
                {c.icon}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Radar de agendamentos */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-50 flex items-center justify-between">
          <h3 className="font-semibold text-gray-800">
            <Ico e="📡" />Radar de Agendamentos
          </h3>
          <button
            onClick={() => onNavigate("posts")}
            className="text-xs text-blue-600 hover:underline"
          >
            Ver todos →
          </button>
        </div>
        <div className="divide-y divide-gray-50">
          {loading ? (
            <div className="py-12 text-center text-gray-400">
              <Spinner />
            </div>
          ) : posts.length === 0 ? (
            <div className="py-12 text-center text-gray-400">
              <p className="text-3xl mb-2"><Ico e="📭" bare /></p>
              <p className="text-sm">Nenhum post agendado.</p>
              <button
                onClick={() => onNavigate("posts")}
                className="mt-3 text-xs text-blue-600 hover:underline"
              >
                + Criar primeiro post
              </button>
            </div>
          ) : (
            posts.map((p) => (
              <div
                key={p.id}
                className="px-6 py-3 flex items-center gap-4 hover:bg-gray-50 transition-colors"
              >
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-800 truncate text-sm">
                    {p.title || p.content?.slice(0, 50)}
                  </p>
                  <div className="flex items-center gap-2 mt-0.5">
                    <StatusBadge status={p.status} />
                    {p.scheduled_at && (
                      <span className="text-xs text-gray-400">
                        <Ico e="📅" bare />{" "}
                        {new Date(p.scheduled_at).toLocaleString("pt-BR", {
                          day: "2-digit",
                          month: "short",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex gap-1 flex-shrink-0">
                  {(p.networks || []).slice(0, 4).map((net) => (
                    <NetworkBadge key={net} networkId={net} small />
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Quick actions */}
      <div className="bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl p-6 text-white">
        <h3 className="font-bold text-lg mb-3"><Ico e="⚡" />Ações Rápidas</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {[
            { label: <><Ico e="📝" />Novo Post</>, tab: "posts" },
            { label: <><Ico e="✨" />Criar com IA</>, tab: "criarai" },
            { label: <><Ico e="🎨" />Brand Kit</>, tab: "criarai" },
            { label: "#️⃣ Biblioteca", tab: "biblioteca" },
          ].map((a) => (
            <button
              key={a.label}
              onClick={() => onNavigate(a.tab)}
              className="bg-white/20 hover:bg-white/30 transition-all rounded-xl px-3 py-2.5 text-sm font-semibold text-left backdrop-blur-sm"
            >
              {a.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── Formulário de Novo Post (full-page) ───────────────────────────────────────
function NewPostForm({ api, onBack, prefilledDate, editingPost }) {
  const isEditing = !!(editingPost && (editingPost.id || editingPost._id));
  const [selectedNetworks, setSelectedNetworks] = useState(
    () =>
      editingPost?.networks ||
      (editingPost?.network ? [editingPost.network] : []),
  );
  const [channels, setChannels] = useState(() => editingPost?.channels || {});
  const [advanced, setAdvanced] = useState(
    () => editingPost?.advanced_settings || {},
  );
  const [expandedAdv, setExpandedAdv] = useState([]);
  const [content, setContent] = useState(
    () => editingPost?.content || editingPost?.caption || "",
  );
  const [scheduledAt, setScheduledAt] = useState(() =>
    editingPost?.scheduled_at
      ? editingPost.scheduled_at.slice(0, 16)
      : prefilledDate || "",
  );
  const [mediaFiles, setMediaFiles] = useState([]);
  const [mediaUrl, setMediaUrl] = useState("");
  const [mediaUrlList, setMediaUrlList] = useState([]);

  const commitMediaUrls = (raw) => {
    const urls = String(raw || "")
      .split(/[\s,]+/)
      .map((u) => u.trim())
      .filter((u) => /^https?:\/\//i.test(u));
    if (urls.length) {
      setMediaUrlList((prev) =>
        Array.from(new Set([...prev, ...urls])).slice(0, 10),
      );
    }
    setMediaUrl("");
  };
  const [generatingCaption, setGeneratingCaption] = useState(false);
  const [submitting, setSubmitting] = useState(null);
  const fileRef = useRef(null);

  const [synklyAccounts, setSynklyAccounts] = useState([]);
  const [loadingSynklyAccounts, setLoadingSynklyAccounts] = useState(true);
  const [metaPublishingTargets, setMetaPublishingTargets] = useState({
    pages: [],
    instagram_accounts: [],
  });
  const [loadingMetaTargets, setLoadingMetaTargets] = useState(true);
  const [selectedMetaTargets, setSelectedMetaTargets] = useState(() => ({
    facebook:
      editingPost?.facebook_page_id ||
      editingPost?.published_targets?.facebook?.page_id ||
      "",
    instagram:
      editingPost?.instagram_page_id ||
      editingPost?.published_targets?.instagram?.page_id ||
      "",
  }));
  const [selectedAccountId, setSelectedAccountId] = useState(
    () => editingPost?.synkly_account_id || null,
  );

  useEffect(() => {
    let isMounted = true;
    api
      .get("/nexohub/meta/publishing-targets")
      .then((r) => {
        if (!isMounted) return;
        setMetaPublishingTargets({
          pages: Array.isArray(r.data?.pages) ? r.data.pages : [],
          instagram_accounts: Array.isArray(r.data?.instagram_accounts)
            ? r.data.instagram_accounts
            : [],
        });
      })
      .catch((err) => {
        console.error("[NexoHub] Erro ao buscar destinos Meta:", err);
        if (isMounted) {
          setMetaPublishingTargets({ pages: [], instagram_accounts: [] });
        }
      })
      .finally(() => {
        if (isMounted) setLoadingMetaTargets(false);
      });
    return () => {
      isMounted = false;
    };
  }, [api]);

  useEffect(() => {
    let isMounted = true;
    setLoadingSynklyAccounts(true);
    api
      .get("/synkly/accounts")
      .then((r) => {
        if (!isMounted) return;
        const data = Array.isArray(r.data) ? r.data : [];
        const tipoPorCanal = {
          meta: "meta",
          instagram: "instagram",
          whatsapp: "whatsapp",
          linkedin: "linkedin",
          facebook: "facebook",
        };

        const accounts = data.map((account) => ({
          ...account,
          tipo: tipoPorCanal[account.channel] || account.channel || "social",
        }));

        setSynklyAccounts(accounts);
        const otherNetworkAccounts = accounts.filter(
          (account) => !["facebook", "instagram"].includes(account.tipo),
        );
        if (otherNetworkAccounts.length > 0 && !selectedAccountId) {
          const matching = otherNetworkAccounts.find((a) =>
            selectedNetworks.includes(a.tipo),
          );
          if (matching) {
            setSelectedAccountId(
              matching.id || matching.externalId || matching.account_id,
            );
          } else if (otherNetworkAccounts.length === 1) {
            setSelectedAccountId(
              otherNetworkAccounts[0].id ||
                otherNetworkAccounts[0].externalId ||
                otherNetworkAccounts[0].account_id,
            );
          }
        }
      })
      .catch((err) => {
        console.error("[NexoHub] Erro ao buscar contas Synkly:", err);
        if (isMounted) setSynklyAccounts([]);
      })
      .finally(() => {
        if (isMounted) setLoadingSynklyAccounts(false);
      });
    return () => {
      isMounted = false;
    };
  }, [api]);

  const [linkedinTargets, setLinkedinTargets] = useState([]);
  const [loadingLinkedinTargets, setLoadingLinkedinTargets] = useState(true);
  const [linkedinTargetsError, setLinkedinTargetsError] = useState(false);
  const [selectedLinkedinTargetId, setSelectedLinkedinTargetId] = useState(
    () => editingPost?.linkedin_target_id || "",
  );

  useEffect(() => {
    let isMounted = true;
    api.get("/nexohub/linkedin/publishing-targets")
      .then((response) => {
        if (isMounted) setLinkedinTargets(Array.isArray(response.data?.targets) ? response.data.targets : []);
      })
      .catch(() => { if (isMounted) setLinkedinTargetsError(true); })
      .finally(() => { if (isMounted) setLoadingLinkedinTargets(false); });
    return () => { isMounted = false; };
  }, [api]);

  const selectedLinkedinConnection = synklyAccounts.find(
    (account) => String(account.id || account.externalId || account.account_id) === String(selectedAccountId)
      && (account.tipo || account.channel) === "linkedin",
  );
  const availableLinkedinTargets = linkedinTargets.filter(
    (target) => !selectedLinkedinConnection || String(target.accountId) === String(
      selectedLinkedinConnection.id || selectedLinkedinConnection.account_id || selectedLinkedinConnection.externalId,
    ),
  );
  const selectedLinkedinTarget = availableLinkedinTargets.find(
    (target) => target.id === selectedLinkedinTargetId,
  );

  const handleSelectAccount = (account) => {
    const accId = account.id || account.externalId || account.account_id;
    if (selectedAccountId === accId) {
      setSelectedAccountId(null);
    } else {
      setSelectedAccountId(accId);
      const accountType = account.tipo || account.channel;
      const tipo = accountType === "meta" ? "facebook" : accountType;
      if (tipo && ALL_NETWORKS.includes(tipo)) {
        if (!selectedNetworks.includes(tipo)) {
          setSelectedNetworks((prev) => [...prev, tipo]);
          setChannels((c) => ({
            ...c,
            [tipo]: NETWORK_META[tipo]?.channels?.[0]?.id || "feed",
          }));
          setAdvanced((a) => ({ ...a, [tipo]: defaultAdvancedFor(tipo) }));
        }
      }
    }
  };

  const toggleNetwork = (net) => {
    setSelectedNetworks((prev) => {
      if (prev.includes(net)) {
        setChannels((c) => {
          const { [net]: _, ...rest } = c;
          return rest;
        });
        setAdvanced((a) => {
          const { [net]: _, ...rest } = a;
          return rest;
        });
        setExpandedAdv((e) => e.filter((n) => n !== net));
        return prev.filter((n) => n !== net);
      }
      setChannels((c) => ({ ...c, [net]: NETWORK_META[net].channels[0].id }));
      setAdvanced((a) => ({ ...a, [net]: defaultAdvancedFor(net) }));
      return [...prev, net];
    });
  };

  const setChannel = (net, ch) => setChannels((c) => ({ ...c, [net]: ch }));
  const toggleAdvPanel = (net) =>
    setExpandedAdv((e) =>
      e.includes(net) ? e.filter((n) => n !== net) : [...e, net],
    );
  const setAdvField = (net, fieldId, value) =>
    setAdvanced((a) => ({
      ...a,
      [net]: { ...(a[net] || {}), [fieldId]: value },
    }));

  const handleFiles = async (files) => {
    if (!files) return;
    const remaining = 10 - mediaFiles.length;
    const toAdd = Array.from(files).slice(0, remaining);
    if (Array.from(files).length > remaining)
      toast.warning("Máximo de 10 arquivos por post.");
    const readers = toAdd.map(
      (file) =>
        new Promise((res) => {
          const reader = new FileReader();
          reader.onload = (e) =>
            res({
              name: file.name,
              dataUrl: e.target.result,
              isVideo: file.type.startsWith("video/"),
              file,
            });
          reader.readAsDataURL(file);
        }),
    );
    const results = await Promise.all(readers);
    setMediaFiles((m) => [...m, ...results]);
    if (fileRef.current) fileRef.current.value = "";
  };

  const handleGenerateCaption = async () => {
    if (!content.trim()) {
      toast.info("Escreva um tema para a IA gerar a legenda.");
      return;
    }
    setGeneratingCaption(true);
    try {
      const r = await api.post("/nexohub/ai/caption", {
        prompt: content,
        networks: selectedNetworks,
      });
      if (r.data.caption) {
        setContent(r.data.caption);
        toast.success("Legenda gerada com IA!");
      } else toast.error(r.data.error || "Erro ao gerar legenda.");
    } catch {
      toast.error("Falha ao conectar com a IA.");
    }
    setGeneratingCaption(false);
  };

  const applySaved = (text) =>
    setContent((prev) => (prev.trim() ? `${prev.trimEnd()}\n\n${text}` : text));

  // Criação de post verificado com logs detalhados da conta Synkly
  const submit = async (status) => {
    const chosenSynklyAccount = synklyAccounts.find(
      (a) => (a.id || a.externalId || a.account_id) === selectedAccountId,
    );
    const selectedFacebookTarget = metaPublishingTargets.pages.find(
      (target) =>
        String(target.page_id || target.id) ===
        String(selectedMetaTargets.facebook),
    );
    const selectedInstagramTarget =
      metaPublishingTargets.instagram_accounts.find(
        (target) =>
          String(target.page_id) === String(selectedMetaTargets.instagram),
      );

    // console.log("════════════════════════════════════════════════════════");
    // console.log("🚀 [NexoHub] CLIQUE EM LANÇAR / SALVAR POST");
    // console.log("📌 Status da Ação:", status);
    // console.log("🔑 ID Selecionado (selectedAccountId):", selectedAccountId || "(Nenhuma conta selecionada)");
    // console.log("👤 DADOS DA CONTA SYNKLY SELECIONADA:", chosenSynklyAccount || "⚠️ Nenhuma conta selecionada");
    // if (chosenSynklyAccount) {
    //   console.log("📋 Detalhes da Conta Synkly:");
    //   console.log("   • ID:", chosenSynklyAccount.id);
    //   console.log("   • Nome / Label:", chosenSynklyAccount.label || chosenSynklyAccount.name || chosenSynklyAccount.account_name);
    //   console.log("   • Canal Synkly:", chosenSynklyAccount.channel);
    //   console.log("   • Tipo (Rede):", chosenSynklyAccount.tipo);
    //   console.log("   • External ID:", chosenSynklyAccount.externalId);
    //   console.log("   • Status:", chosenSynklyAccount.status);
    //   console.log("   • Metadados:", chosenSynklyAccount.metadata);
    // }
    // console.log("════════════════════════════════════════════════════════");

    if (!content.trim()) {
      toast.error("O conteúdo é obrigatório.");
      return;
    }
    if (status === "scheduled" && !scheduledAt) {
      toast.error("Selecione data/hora para agendar.");
      return;
    }
    if (selectedNetworks.length === 0 && status !== "draft") {
      toast.error("Selecione ao menos uma rede.");
      return;
    }
    if (
      status !== "draft" &&
      selectedNetworks.includes("facebook") &&
      !selectedFacebookTarget
    ) {
      toast.error("Selecione a Página do Facebook que receberá a publicação.");
      return;
    }
    if (
      status !== "draft" &&
      selectedNetworks.includes("instagram") &&
      !selectedInstagramTarget
    ) {
      toast.error("Selecione a conta Instagram que receberá a publicação.");
      return;
    }
    if (status !== "draft" && selectedNetworks.includes("linkedin") && !selectedLinkedinTarget) {
      toast.error("Selecione o perfil ou a p\u00e1gina do LinkedIn que receber\u00e1 a publica\u00e7\u00e3o.");
      return;
    }
    setSubmitting(status);
    try {
      const payload = {
        title: content.trim().slice(0, 80),
        content: content.trim(),
        caption: content.trim(),
        networks: selectedNetworks,
        channels,
        // Stories/Reels are vertical-only; the backend rejects publishing them
        // without an explicit 9:16 confirmation, so it travels per-network here.
        advanced_settings: Object.fromEntries(
          selectedNetworks
            .map((n) => {
              const settings = channels[n] === "stories" || channels[n] === "reels"
                ? { ...(advanced[n] || {}), aspect_ratio: "9:16" }
                : advanced[n];
              return [n, settings];
            })
            .filter(([, settings]) => settings && Object.keys(settings).length > 0),
        ),
        status,
        scheduled_at: scheduledAt || null,
        media: mediaFiles.map((m) => m.name),
        synkly_account_id: selectedAccountId || null,
        synkly_account_name:
          chosenSynklyAccount?.label || chosenSynklyAccount?.name || null,
        linkedin_target_id: selectedLinkedinTarget?.id || null,
        linkedin_account_id: selectedLinkedinTarget?.accountId || null,
        linkedin_organization_urn: selectedLinkedinTarget?.organizationUrn || null,
        linkedin_target_name: selectedLinkedinTarget?.name || null,
        facebook_page_id: selectedMetaTargets.facebook || null,
        facebook_synkly_account_id:
          selectedFacebookTarget?.synkly_account_id || null,
        instagram_page_id: selectedMetaTargets.instagram || null,
        instagram_synkly_account_id:
          selectedInstagramTarget?.synkly_account_id || null,
      };

      // console.log("📦 [NexoHub] Payload preparado para salvar:", payload);
      // console.log("🔍 [NexoHub] Conta incluída no payload de salvamento:", {
      //   synkly_account_id: payload.synkly_account_id,
      //   synkly_account_name: payload.synkly_account_name,
      //   conta_selecionada: chosenSynklyAccount || null,
      // });

      let savedPostId = editingPost?.id || editingPost?._id || null;
      if (isEditing) {
        await api.put(
          `/nexohub/posts/${editingPost.id || editingPost._id}`,
          payload,
        );
        toast.success("Post atualizado!");
      } else {
        // console.log("[NexoHub] Salvando post local antes da publicação...", {
        //   networks: payload.networks,
        //   synkly_account_id: payload.synkly_account_id,
        //   media_count: payload.media.length,
        // });
        const savedPostResponse = await api.post("/nexohub/posts", payload);
        const nexohubPostId = savedPostResponse?.data?.id || savedPostResponse?.data?._id;
        // console.log("[NexoHub] Post local salvo com sucesso.");
      }
      if (status === "published") {
        try {
            const publishPayload = {
              ...payload,
              nexohub_post_id: nexohubPostId,
              synkly_account_id: selectedAccountId || null,
              synkly_account_name: chosenSynklyAccount?.label || chosenSynklyAccount?.name || null,
              media_urls: mediaFiles
                .map((m) => m.dataUrl)
                .filter(
                  (url) => typeof url === "string" && /^https?:\/\//i.test(url),
                ),
            };
            const extraMediaUrls = [
              ...mediaUrlList,
              ...mediaUrl
                .split(/[\s,]+/)
                .map((url) => url.trim())
                .filter((url) => /^https?:\/\//i.test(url)),
            ];
            if (extraMediaUrls.length) {
              publishPayload.media_urls = Array.from(
                new Set([...publishPayload.media_urls, ...extraMediaUrls]),
              ).slice(0, 10);
            }

            // console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
            // console.log("🌐 [NexoHub] INICIANDO PUBLICAÇÃO VIA SYNKLY");
            // console.log("🎯 Conta Synkly selecionada:", chosenSynklyAccount || "(Nenhuma conta vinculada)");
            // console.log("🆔 synkly_account_id no publishPayload:", publishPayload.synkly_account_id);
            // console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");

            if (selectedNetworks.includes("linkedin")) {
              try {
              publishPayload.linkedin_account_id = selectedLinkedinTarget.accountId;
              publishPayload.linkedin_organization_urn = selectedLinkedinTarget.organizationUrn || null;
              publishPayload.linkedin_target_name = selectedLinkedinTarget.name;

              const linkedinSettings = advanced.linkedin || {};
              const visibilitySetting = String(
                linkedinSettings.visibility || "",
              ).toUpperCase();
              if (visibilitySetting === "CONNECTIONS") {
                publishPayload.linkedin_visibility = "connections";
              } else if (visibilitySetting) {
                publishPayload.linkedin_visibility = "anyone";
              }
              if (publishPayload.media_urls?.length) {
                publishPayload.linkedin_image_urls = publishPayload.media_urls;
              }
              const linkedinPayload = {
                accountId: publishPayload.linkedin_account_id,
                text: publishPayload.content,
                visibility: publishPayload.linkedin_visibility || "anyone",
                imageUrls: publishPayload.linkedin_image_urls || [],
                nexohub_post_id: savedPostId,
              };
              if (publishPayload.linkedin_organization_urn) {
                linkedinPayload.organizationUrn =
                  publishPayload.linkedin_organization_urn;
              }
              await api.post("/nexohub/linkedin/post", linkedinPayload);
              toast.success("Post publicado no LinkedIn!");
              } catch (linkedinError) {
                console.error(
                  "[NexoHub] Erro ao publicar no LinkedIn:",
                  linkedinError,
                );
                const detail = linkedinError?.response?.data?.detail;
                toast.error(
                  typeof detail === "string"
                    ? detail
                    : linkedinError?.message ||
                      "Falha ao publicar no LinkedIn.",
                );
              }
            }

            if (selectedNetworks.includes("facebook")) {
              if (
                !publishPayload.facebook_page_id &&
                chosenSynklyAccount &&
                (chosenSynklyAccount.tipo === "facebook" ||
                  chosenSynklyAccount.channel === "meta")
              ) {
                if (
                  chosenSynklyAccount.metadata?.adAccountId ||
                  chosenSynklyAccount.metadata?.ad_account_id
                ) {
                  publishPayload.facebook_ad_account_id =
                    chosenSynklyAccount.metadata?.adAccountId ||
                    chosenSynklyAccount.metadata?.ad_account_id;
                }
                if (
                  chosenSynklyAccount.metadata?.pageId ||
                  chosenSynklyAccount.metadata?.page_id
                ) {
                  publishPayload.facebook_page_id =
                    chosenSynklyAccount.metadata?.pageId ||
                    chosenSynklyAccount.metadata?.page_id;
                }
                if (
                  !publishPayload.facebook_page_id &&
                  chosenSynklyAccount.externalId
                ) {
                  publishPayload.facebook_page_id =
                    chosenSynklyAccount.externalId;
                }
                // console.log("[NexoHub] Alvos Facebook preliminares da conta Synkly:", {
                //   facebook_page_id: publishPayload.facebook_page_id,
                //   facebook_ad_account_id: publishPayload.facebook_ad_account_id,
                //   conta: chosenSynklyAccount.label || chosenSynklyAccount.name,
                // });
              }

              if (!publishPayload.facebook_page_id) {
                // console.log("[NexoHub] Buscando alvos Meta para Facebook via /nexohub/meta/publishing-targets...");
                try {
                  const metaTargetsResp = await api.get(
                    "/nexohub/meta/publishing-targets",
                  );
                  // console.log("[NexoHub] Dados recebidos de publishing-targets:", metaTargetsResp?.data);
                  const pages = metaTargetsResp.data?.pages || [];
                  const adAccounts = metaTargetsResp.data?.ad_accounts || [];

                  if (!publishPayload.facebook_page_id && pages.length > 0) {
                    publishPayload.facebook_page_id =
                      pages[0].id || pages[0].page_id || pages[0].externalId;
                  }

                  if (
                    !publishPayload.facebook_ad_account_id &&
                    adAccounts.length > 0
                  ) {
                    const matchedAdAccount = chosenSynklyAccount
                      ? adAccounts.find((ad) => {
                          const accountLabel = String(
                            chosenSynklyAccount.label ||
                              chosenSynklyAccount.name ||
                              "",
                          )
                            .split("—")[0]
                            .trim()
                            .toLowerCase();
                          const adName = String(ad.name || "")
                            .trim()
                            .toLowerCase();
                          return (
                            (adName &&
                              accountLabel &&
                              (adName === accountLabel ||
                                adName.startsWith(accountLabel) ||
                                accountLabel.startsWith(adName))) ||
                            ad.id === chosenSynklyAccount.id ||
                            ad.adAccountId === chosenSynklyAccount.externalId
                          );
                        })
                      : null;
                    const selectedAd = matchedAdAccount || adAccounts[0];
                    publishPayload.facebook_ad_account_id =
                      selectedAd.adAccountId ||
                      selectedAd.id ||
                      selectedAd.account_id ||
                      selectedAd.externalId;
                    // console.log("[NexoHub] Conta de anúncios Meta selecionada:", {
                    //   matched: !!matchedAdAccount,
                    //   name: selectedAd.name,
                    //   adAccountId: publishPayload.facebook_ad_account_id,
                    // });
                  }

                  if (!publishPayload.facebook_page_id) {
                    console.warn(
                      "[NexoHub] Nenhuma página ou conta de anúncios Meta encontrada.",
                      {
                        pageId: publishPayload.facebook_page_id,
                        adAccountId: publishPayload.facebook_ad_account_id,
                        data: metaTargetsResp?.data,
                      },
                    );
                    throw new Error(
                      "Nenhuma Página do Facebook ou Conta de Anúncios Meta foi encontrada no Synkly.",
                    );
                  }

                  // console.log("[NexoHub] Alvos Meta selecionados do Synkly:", {
                  //   facebook_page_id: publishPayload.facebook_page_id,
                  //   facebook_ad_account_id: publishPayload.facebook_ad_account_id,
                  // });
                } catch (metaError) {
                  console.error(
                    "[NexoHub] Erro ao buscar alvos Meta:",
                    metaError,
                  );
                  throw metaError;
                }
              }
            }

            if (selectedNetworks.includes("instagram")) {
              if (selectedInstagramTarget) {
                publishPayload.instagram_account_id =
                  selectedInstagramTarget.id || selectedInstagramTarget.page_id;
                // console.log("[NexoHub] Usando conta Instagram selecionada pelo usuário:", {
                //   instagram_account_id: publishPayload.instagram_account_id,
                //   label: chosenSynklyAccount.label || chosenSynklyAccount.name,
                // });
              }
              const hasValidImage = publishPayload.media_urls?.some(
                (url) =>
                  url.startsWith("http://") || url.startsWith("https://"),
              );
              if (!hasValidImage) {
                throw new Error(
                  "O Instagram exige ao menos uma imagem com URL pública (HTTPS) para publicar.",
                );
              }
            }

            // console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
            // console.log("🚀 [NexoHub] DISPARANDO PUBLICAÇÃO REAL COM CONTA SYNKLY:");
            // console.log("👤 Conta Selecionada:", chosenSynklyAccount || "(Nenhuma selecionada)");
            // console.log("📦 Payload Final de Publicação:", publishPayload);
            // console.log("📊 Resumo dos IDs Vinculados:", {
            //   synkly_account_id: publishPayload.synkly_account_id,
            //   synkly_account_name: publishPayload.synkly_account_name,
            //   linkedin_account_id: publishPayload.linkedin_account_id || null,
            //   facebook_page_id: publishPayload.facebook_page_id || null,
            //   facebook_ad_account_id: publishPayload.facebook_ad_account_id || null,
            //   instagram_account_id: publishPayload.instagram_account_id || null,
            // });
            // console.log("━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
            // console.log("[NexoHub] Chamando POST /nexohub/posts/publish...");

            const nonLinkedinNetworks = selectedNetworks.filter(
              (network) => network !== "linkedin",
            );

            // Publicação no LinkedIn via rotas dedicadas do NexoHub (#Linkedin Novo)
            if (
              selectedNetworks.includes("linkedin") &&
              publishPayload.linkedin_account_id
            ) {
              const linkedinPayload = {
                accountId: publishPayload.linkedin_account_id,
                text: content.trim(),
                nexohub_post_id: nexohubPostId,
              };
              if (publishPayload.linkedin_organization_urn) {
                linkedinPayload.organizationUrn =
                  publishPayload.linkedin_organization_urn;
              }
              if (publishPayload.linkedin_visibility) {
                linkedinPayload.visibility = publishPayload.linkedin_visibility;
              }
              if (publishPayload.linkedin_image_urls?.length) {
                linkedinPayload.imageUrls = publishPayload.linkedin_image_urls;
              }
              // console.log("[NexoHub] Publicando no LinkedIn via /nexohub/linkedin/post:", linkedinPayload);
              await api.post("/nexohub/linkedin/post", linkedinPayload);
            }

            // Demais redes (Facebook / Instagram / TikTok) seguem pelo fluxo Meta/TikTok
            if (nonLinkedinNetworks.length > 0) {
              const metaPublishPayload = {
                ...publishPayload,
                networks: nonLinkedinNetworks,
              };
              const publishResponse = await api.post(
                "/nexohub/posts/publish",
                metaPublishPayload,
              );
              // console.log("[NexoHub] Resposta da API /nexohub/posts/publish:", {
              //   status: publishResponse?.status,
              //   data: publishResponse?.data,
              // });
              toast.success("Post publicado nos canais Meta selecionados! ");
            }
          } catch (publishError) {
            console.error(
              "[NexoHub] Erro ao publicar no canal real:",
              publishError,
            );
            console.error("[NexoHub] Dados do erro da API Synkly:", {
              status: publishError?.response?.status,
              data: publishError?.response?.data,
              message: publishError?.message,
            });
            const errorDetail = publishError?.response?.data?.detail;
            const errorMessage =
              typeof errorDetail === "string"
                ? errorDetail
                : errorDetail?.error ||
                  publishError?.response?.data?.error ||
                  publishError?.message ||
                  "Post salvo, mas a publicação real falhou.";
            toast.error(errorMessage);
          }
        } else {
          const labels = {
            draft: "Rascunho salvo!",
            scheduled: "Post agendado! 📅",
          };
          toast.success(labels[status] || "Salvo!");
        }
      onBack();
    } catch (saveError) {
      // console.error('[NexoHub] Erro ao salvar o post:', saveError);
      // console.error('[NexoHub] Detalhes do erro ao salvar:', {
      //   status: saveError?.response?.status,
      //   data: saveError?.response?.data,
      //   message: saveError?.message,
      // });
      toast.error("Erro ao salvar o post.");
    }
    setSubmitting(null);
  };

  const previewNet = selectedNetworks[0];
  const previewMeta = previewNet ? NETWORK_META[previewNet] : null;
  const otherSynklyAccounts = synklyAccounts.filter(
    (account) =>
      !["facebook", "instagram"].includes(account.tipo || account.channel),
  );

  return (
    <div>
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 mb-6 transition-colors"
      >
        ← Voltar para Posts
      </button>
      {isEditing && (
        <p className="text-xs font-bold text-blue-600 uppercase tracking-wide mb-3">
          <Ico e="✏" />Editando post
        </p>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-6 items-start">
        {/* Coluna principal */}
        <div className="space-y-5">
          {/* Seleção de contas do Synkly */}
          <section className="bg-white rounded-2xl border border-gray-100 p-5">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-blue-600 animate-pulse" />
                <h3 className="text-xs font-bold uppercase tracking-wider text-blue-600">
                  Contas e destinos de publicação
                </h3>
              </div>
              {selectedAccountId && (
                <div className="flex items-center gap-2">
                  <span className="text-xs font-semibold text-emerald-600 bg-emerald-50 px-2.5 py-1 rounded-full border border-emerald-200">
                    ✓ Conta selecionada
                  </span>
                  <button
                    type="button"
                    onClick={() => setSelectedAccountId(null)}
                    className="text-[11px] text-gray-400 hover:text-gray-600 underline"
                  >
                    Limpar
                  </button>
                </div>
              )}
            </div>

            <div className="teste">
              {loadingSynklyAccounts ? (
                <div className="py-8 text-center text-sm text-gray-500 flex items-center justify-center gap-2">
                  <Spinner /> Carregando contas do Synkly...
                </div>
              ) : otherSynklyAccounts.length === 0 &&
                metaPublishingTargets.pages.length === 0 &&
                metaPublishingTargets.instagram_accounts.length === 0 ? (
                <div className="text-center py-6 border border-dashed border-gray-200 rounded-xl text-gray-500 text-sm">
                  <p className="font-medium">
                    Nenhuma conta conectada no Synkly
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    Conecte suas contas em Redes Sociais / Integrações Gerais.
                  </p>
                </div>
              ) : otherSynklyAccounts.length > 0 ? (
                <div
                  id="networks-grid"
                  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
                >
                  {otherSynklyAccounts.map((account, index) => {
                    const tipo = account.tipo || account.channel || "social";
                    const network = NETWORK_META[tipo] || {
                      color: tipo === "meta" ? "#0866FF" : "#64748B",
                      channels: [
                        {
                          id: "feed",
                          label: tipo === "meta" ? "Conta Meta" : "Conta",
                        },
                      ],
                    };
                    const nome =
                      account.label ||
                      account.name ||
                      account.account_name ||
                      account.username ||
                      account.externalId ||
                      account.id ||
                      "Conta conectada";
                    const accId =
                      account.id ||
                      account._id ||
                      account.externalId ||
                      `${tipo}-${index}`;
                    const isSelected =
                      selectedAccountId ===
                      (account.id || account.externalId || account.account_id);

                    return (
                      <div
                        key={accId}
                        onClick={() => handleSelectAccount(account)}
                        className={`relative flex flex-col justify-between rounded-2xl p-5 overflow-hidden shadow-md cursor-pointer transition-all ${
                          isSelected
                            ? "ring-4 ring-blue-500 scale-[1.02] shadow-xl"
                            : "opacity-85 hover:opacity-100 hover:scale-[1.01]"
                        }`}
                        style={{
                          background: `linear-gradient(145deg, ${network.color}ee, ${network.color}88)`,
                          minHeight: "200px",
                        }}
                      >
                        <div className="relative z-10 flex items-start justify-between gap-3">
                          <div className="flex items-start gap-3 min-w-0">
                            <div className="w-12 h-12 rounded-2xl bg-white shadow-md flex items-center justify-center text-2xl flex-shrink-0">
                              {NETWORK_META[tipo] || NETWORK_LOGOS[tipo] ? (
                                <NetworkLogo networkId={tipo} size={30} />
                              ) : (
                                <><Ico e="🔗" /></>
                              )}
                            </div>
                            <div className="min-w-0">
                              <p className="text-white font-bold text-sm truncate">
                                {nome}
                              </p>
                              {(account.username ||
                                account.account_username) && (
                                <p className="text-white/75 text-[11px] truncate">
                                  @
                                  {account.username || account.account_username}
                                </p>
                              )}
                            </div>
                          </div>

                          {isSelected && (
                            <span className="w-6 h-6 rounded-full bg-white text-blue-600 flex items-center justify-center text-xs font-bold shadow flex-shrink-0">
                              ✓
                            </span>
                          )}
                        </div>

                        <div className="relative z-10 mt-3 flex items-center justify-between">
                          <span className="inline-flex items-center gap-1.5 bg-white/20 border border-white/30 text-white text-[10px] font-bold px-2.5 py-1 rounded-full">
                            <span className="w-1.5 h-1.5 rounded-full bg-emerald-300 animate-pulse" />
                            {isSelected
                              ? "Selecionada para Post"
                              : "Sincronizado"}
                          </span>
                        </div>

                        <div className="relative z-10 mt-3 flex flex-wrap gap-1">
                          {(network.channels || []).map((channel) => (
                            <span
                              key={channel.id}
                              className="inline-flex items-center gap-1 bg-white/15 border border-white/25 text-white text-[10px] font-bold px-2 py-0.5 rounded-full"
                            >
                              <span className="text-white/80">
                                {CHANNEL_ICONS[channel.id] || "•"}
                              </span>
                              {channel.label}
                            </span>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
            
            {selectedNetworks.includes("linkedin") && (
              <div className="mt-5">
                <label htmlFor="linkedin-publishing-target" className="text-xs font-bold text-gray-600 block mb-1.5">
                  Perfil ou página do LinkedIn
                </label>
                <select
                  id="linkedin-publishing-target"
                  value={selectedLinkedinTarget?.id || ""}
                  onChange={(event) => setSelectedLinkedinTargetId(event.target.value)}
                  disabled={loadingLinkedinTargets || availableLinkedinTargets.length === 0}
                  className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60"
                >
                  <option value="">
                    {loadingLinkedinTargets ? "Carregando contas..."
                      : linkedinTargetsError ? "Erro ao carregar contas do LinkedIn"
                      : availableLinkedinTargets.length ? "Selecione um perfil ou p\u00e1gina"
                      : "Nenhum perfil ou p\u00e1gina dispon\u00edvel"}
                  </option>
                  {availableLinkedinTargets.map((target) => (
                    <option key={target.id} value={target.id}>
                      {target.name}{target.type === "organization" ? " (P\u00e1gina empresarial)" : ""}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* select conta meta */}
            <div id="select-conta-meta">
              {selectedNetworks.some((network) =>
                ["facebook", "instagram"].includes(network),
              ) && (
                <div
                  id="select-conta-meta"
                  className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5"
                >
                  {selectedNetworks.includes("facebook") && (
                    <div>
                      <label
                        htmlFor="facebook-publishing-target"
                        className="text-xs font-bold text-gray-600 block mb-1.5"
                      >
                        Página do Facebook
                      </label>
                      <select
                        id="facebook-publishing-target"
                        value={selectedMetaTargets.facebook}
                        onChange={(event) =>
                          setSelectedMetaTargets((targets) => ({
                            ...targets,
                            facebook: event.target.value,
                          }))
                        }
                        disabled={
                          loadingMetaTargets ||
                          metaPublishingTargets.pages.length === 0
                        }
                        className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60"
                      >
                        <option value="">
                          {loadingMetaTargets
                            ? "Carregando Páginas..."
                            : metaPublishingTargets.pages.length
                              ? "Selecione uma Página"
                              : "Nenhuma Página conectada"}
                        </option>
                        {metaPublishingTargets.pages.map((page) => (
                          <option
                            key={page.page_id || page.id}
                            value={page.page_id || page.id}
                          >
                            {page.name || page.label || page.page_id || page.id}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {selectedNetworks.includes("instagram") && (
                    <div>
                      <label
                        htmlFor="instagram-publishing-target"
                        className="text-xs font-bold text-gray-600 block mb-1.5"
                      >
                        Conta do Instagram
                      </label>
                      <select
                        id="instagram-publishing-target"
                        value={selectedMetaTargets.instagram}
                        onChange={(event) =>
                          setSelectedMetaTargets((targets) => ({
                            ...targets,
                            instagram: event.target.value,
                          }))
                        }
                        disabled={
                          loadingMetaTargets ||
                          metaPublishingTargets.instagram_accounts.length === 0
                        }
                        className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60"
                      >
                        <option value="">
                          {loadingMetaTargets
                            ? "Carregando contas..."
                            : metaPublishingTargets.instagram_accounts.length
                              ? "Selecione uma conta"
                              : "Nenhuma conta conectada"}
                        </option>
                        {metaPublishingTargets.instagram_accounts.map(
                          (account) => (
                            <option
                              key={account.page_id}
                              value={account.page_id}
                            >
                              {account.username
                                ? `@${account.username}`
                                : account.name || account.page_id}
                            </option>
                          ),
                        )}
                      </select>
                    </div>
                  )}
                </div>
              )}
            </div>
          
          </section>

          {/* Seleção de redes — estilo mLabs: cada sub-tipo é um botão próprio */}
          <section className="bg-white rounded-2xl border border-gray-100 p-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full bg-blue-600 animate-pulse" />
              <h3 className="text-xs font-bold uppercase tracking-wider text-blue-600">
                Selecione os canais
              </h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {ALL_NETWORKS.map((net) => {
                const m = NETWORK_META[net];
                return m.channels.map((ch) => {
                  const isActive =
                    selectedNetworks.includes(net) && channels[net] === ch.id;
                  return (
                    <button
                      key={`${net}-${ch.id}`}
                      title={`${m.name} — ${ch.label}`}
                      onClick={() => {
                        if (isActive) {
                          setSelectedNetworks((prev) =>
                            prev.filter((n) => n !== net),
                          );
                          setChannels((c) => {
                            const nc = { ...c };
                            delete nc[net];
                            return nc;
                          });
                          setAdvanced((a) => {
                            const na = { ...a };
                            delete na[net];
                            return na;
                          });
                          setExpandedAdv((e) => e.filter((n) => n !== net));
                        } else {
                          if (!selectedNetworks.includes(net)) {
                            setSelectedNetworks((prev) => [...prev, net]);
                            setAdvanced((a) => ({
                              ...a,
                              [net]: defaultAdvancedFor(net),
                            }));
                            const hasRequired = (
                              ADVANCED_FIELDS[net] || []
                            ).some((f) => f.required);
                            if (hasRequired)
                              setExpandedAdv((e) =>
                                e.includes(net) ? e : [...e, net],
                              );
                          }
                          setChannels((c) => ({ ...c, [net]: ch.id }));
                        }
                      }}
                      className={`flex flex-col items-center gap-1.5 px-3 py-2.5 rounded-2xl border-2 transition-all min-w-[64px] ${
                        isActive
                          ? "border-blue-500 bg-blue-600 shadow-lg scale-105"
                          : "border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm"
                      }`}
                    >
                      {/* Ícone da rede */}
                      <div
                        className={`w-9 h-9 rounded-xl flex items-center justify-center shadow-sm ${isActive ? "bg-white/20" : "bg-gray-50 border border-gray-100"}`}
                      >
                        <NetworkLogo networkId={net} size={22} />
                      </div>
                      {/* Ícone do canal */}
                      <span
                        className={`${isActive ? "text-white" : "text-gray-400"}`}
                      >
                        {CHANNEL_ICONS[ch.id]}
                      </span>
                      {/* Label */}
                      <span
                        className={`text-[10px] font-bold leading-none text-center ${isActive ? "text-white" : "text-gray-500"}`}
                      >
                        {ch.label}
                      </span>
                    </button>
                  );
                });
              })}
            </div>
            {selectedNetworks.length > 0 && (
              <p className="mt-3 text-xs text-gray-400 font-medium">
                {selectedNetworks.length} rede(s) selecionada(s):{" "}
                {selectedNetworks
                  .map((n) => `${NETWORK_META[n].name} (${channels[n] || ""})`)
                  .join(", ")}
              </p>
            )}
          </section>

          {/* Editor de conteúdo */}
          <section className="bg-white rounded-2xl border border-gray-100 p-5">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-blue-600 animate-pulse" />
                <h3 className="text-xs font-bold uppercase tracking-wider text-blue-600">
                  Conteúdo
                </h3>
              </div>
              <button
                onClick={handleGenerateCaption}
                disabled={generatingCaption}
                className="flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-lg border border-purple-200 text-purple-600 bg-purple-50 hover:bg-purple-100 transition-colors disabled:opacity-60"
              >
                {generatingCaption ? <Spinner /> : <><Ico e="✨" /></>} Gerar com IA
              </button>
            </div>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Escreva o conteúdo ou descreva o tema para a IA gerar..."
              className="w-full min-h-[160px] resize-none text-sm border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50"
            />
            <div className="flex justify-end mt-1">
              <span className="text-xs text-gray-400 font-mono bg-gray-100 px-2 py-0.5 rounded">
                {content.length} chars
              </span>
            </div>

            {/* Blocos salvos */}
            <div className="mt-4 pt-4 border-t border-gray-100">
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3">
                <Ico e="💾" />Blocos Salvos
              </p>
              <SavedLibraryInline api={api} onApply={applySaved} />
            </div>

            {/* URLs públicas para publicação */}
            <div className="mt-4 pt-4 border-t border-gray-100">
              <div className="flex items-center justify-between mb-2">
                <p className="text-xs font-bold text-gray-600 uppercase tracking-wide">
                  <Ico e="🖼" />Mídia pública
                </p>
              </div>
              {mediaUrlList.length > 0 && (
                <div className="mt-3 grid grid-cols-4 gap-2">
                  {mediaUrlList.map((url) => (
                    <div
                      key={url}
                      className="relative aspect-square rounded-lg overflow-hidden border border-gray-200 bg-gray-50"
                    >
                      <img
                        src={url}
                        alt="Mídia do post"
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.currentTarget.style.opacity = "0.2";
                        }}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setMediaUrlList((prev) => prev.filter((u) => u !== url))
                        }
                        className="absolute top-1 right-1 w-5 h-5 rounded-full bg-black/60 text-white text-xs leading-5"
                        title="Remover"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
              <input
                type="text"
                value={mediaUrl}
                onChange={(e) => setMediaUrl(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === ",") {
                    e.preventDefault();
                    commitMediaUrls(mediaUrl);
                  }
                }}
                onPaste={(e) => {
                  const text = e.clipboardData.getData("text");
                  if (/^https?:\/\//i.test(text.trim())) {
                    e.preventDefault();
                    commitMediaUrls(text);
                  }
                }}
                onBlur={() => commitMediaUrls(mediaUrl)}
                placeholder="Cole uma URL de imagem e pressione Enter; repita para adicionar mais"
                className="mt-3 w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <p className="mt-1 text-xs text-gray-400">
                TikTok e Meta precisam acessar URLs HTTP/HTTPS públicas;
                arquivos locais e base64 não funcionam.
              </p>
            </div>
          </section>

          {/* Configurações avançadas por rede */}
          {selectedNetworks.some(
            (n) => (ADVANCED_FIELDS[n] || []).length > 0,
          ) && (
            <section className="bg-white rounded-2xl border border-gray-100 p-5">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-gray-400" />
                <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500">
                  Configurações Avançadas
                </h3>
              </div>
              <div className="space-y-3">
                {selectedNetworks.map((net) => {
                  const fields = ADVANCED_FIELDS[net] || [];
                  if (!fields.length) return null;
                  const m = NETWORK_META[net];
                  const isExpanded = expandedAdv.includes(net);
                  const hasRequired = fields.some((f) => f.required);
                  const missingRequired = fields.filter(
                    (f) => f.required && !advanced[net]?.[f.id],
                  );
                  return (
                    <div
                      key={net}
                      className={`rounded-xl border overflow-hidden ${hasRequired ? "border-amber-200" : "border-gray-200"}`}
                    >
                      <button
                        onClick={() => toggleAdvPanel(net)}
                        className={`w-full flex items-center justify-between px-4 py-3 transition-colors text-left ${hasRequired ? "bg-amber-50 hover:bg-amber-100" : "bg-gray-50 hover:bg-gray-100"}`}
                      >
                        <div className="flex items-center gap-2">
                          <NetworkLogo networkId={net} size={18} />
                          <span className="font-bold text-sm text-gray-700">
                            {m.name}
                          </span>
                          {missingRequired.length > 0 && (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold text-amber-700 bg-amber-100 border border-amber-200 px-2 py-0.5 rounded-full">
                              <Ico e="⚠" bare />{missingRequired.length} obrigatório
                              {missingRequired.length > 1 ? "s" : ""} pendente
                              {missingRequired.length > 1 ? "s" : ""}
                            </span>
                          )}
                          {hasRequired && missingRequired.length === 0 && (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-0.5 rounded-full">
                              ✓ Completo
                            </span>
                          )}
                        </div>
                        <span
                          className={`transition-transform text-xs ${isExpanded ? "rotate-180" : ""} ${hasRequired ? "text-amber-500" : "text-gray-400"}`}
                        >
                          ▾
                        </span>
                      </button>
                      {isExpanded && (
                        <div className="p-4  bg-white">
                          {fields.map((field) => (
                            <div key={field.id} className="space-y-1.5">
                              <div className="flex items-center gap-1.5">
                                <label className="text-xs font-bold text-gray-600">
                                  {field.label}
                                </label>
                                {field.required && (
                                  <span className="text-[9px] font-bold text-white bg-red-500 px-1.5 py-0.5 rounded uppercase tracking-wide">
                                    Obrigatório
                                  </span>
                                )}
                              </div>
                              {field.hint && (
                                <p className="text-[11px] text-gray-400 leading-snug">
                                  {field.hint}
                                </p>
                              )}
                              {field.type === "text" && (
                                <div className="relative">
                                  <input
                                    type="text"
                                    placeholder={field.placeholder}
                                    maxLength={field.maxLength}
                                    value={advanced[net]?.[field.id] || ""}
                                    onChange={(e) =>
                                      setAdvField(net, field.id, e.target.value)
                                    }
                                    className={`w-full text-sm border rounded-lg px-3 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 ${field.required && !advanced[net]?.[field.id] ? "border-amber-300 bg-amber-50/30" : "border-gray-200"}`}
                                  />
                                  {field.maxLength &&
                                    advanced[net]?.[field.id] && (
                                      <span className="absolute right-2 bottom-2 text-[10px] text-gray-400">
                                        {
                                          (advanced[net]?.[field.id] || "")
                                            .length
                                        }
                                        /{field.maxLength}
                                      </span>
                                    )}
                                </div>
                              )}
                              {field.type === "textarea" && (
                                <div className="relative">
                                  <textarea
                                    placeholder={field.placeholder}
                                    maxLength={field.maxLength}
                                    value={advanced[net]?.[field.id] || ""}
                                    onChange={(e) =>
                                      setAdvField(net, field.id, e.target.value)
                                    }
                                    className={`w-full text-sm border rounded-lg px-3 py-2 bg-gray-50 min-h-[80px] resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 ${field.required && !advanced[net]?.[field.id] ? "border-amber-300 bg-amber-50/30" : "border-gray-200"}`}
                                  />
                                  {field.maxLength && (
                                    <span className="absolute right-2 bottom-2 text-[10px] text-gray-400">
                                      {(advanced[net]?.[field.id] || "").length}
                                      /{field.maxLength}
                                    </span>
                                  )}
                                </div>
                              )}
                              {field.type === "select" && (
                                <select
                                  value={
                                    advanced[net]?.[field.id] ||
                                    field.default ||
                                    ""
                                  }
                                  onChange={(e) =>
                                    setAdvField(net, field.id, e.target.value)
                                  }
                                  className={`w-full text-sm border rounded-lg px-3 py-2 bg-gray-50 h-9 focus:outline-none focus:ring-2 focus:ring-blue-500 ${field.required && !advanced[net]?.[field.id] ? "border-amber-300" : "border-gray-200"}`}
                                >
                                  {(field.options || []).map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              )}
                              {field.type === "toggle" && (
                                <div className="flex items-center gap-2">
                                  <Toggle
                                    value={
                                      advanced[net]?.[field.id] !== undefined
                                        ? !!advanced[net]?.[field.id]
                                        : field.default || false
                                    }
                                    onChange={(v) =>
                                      setAdvField(net, field.id, v)
                                    }
                                  />
                                  <span className="text-xs text-gray-500">
                                    {(
                                      advanced[net]?.[field.id] !== undefined
                                        ? !!advanced[net]?.[field.id]
                                        : field.default || false
                                    )
                                      ? "Ativado"
                                      : "Desativado"}
                                  </span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </section>
          )}
        </div>

        {/* Painel lateral */}
        <div className="space-y-5">
          <section className="bg-white rounded-2xl border border-gray-100 p-5 sticky top-6">
            <h3 className="font-bold text-gray-800 mb-4"><Ico e="⚡" />Lançamento</h3>
            {mediaUrlList.length > 0 && (
              <div className="mb-4 rounded-xl overflow-hidden border border-gray-200 bg-gray-50">
                <img
                  src={mediaUrlList[0]}
                  alt="Preview da imagem do post"
                  className="w-full max-h-56 object-cover"
                  onError={(event) => {
                    event.currentTarget.style.display = "none";
                  }}
                />
              </div>
            )}
            <div className="">
              <div>
                <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1.5">
                  Agendar para
                </label>
                <input
                  type="datetime-local"
                  value={scheduledAt}
                  onChange={(e) => setScheduledAt(e.target.value)}
                  className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="pt-3 border-t border-gray-100 space-y-2">
                <button
                  onClick={() => submit("scheduled")}
                  disabled={
                    !!submitting ||
                    !scheduledAt ||
                    !content.trim() ||
                    selectedNetworks.length === 0
                  }
                  className="w-full py-3 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-colors"
                >
                  {submitting === "scheduled" ? <Spinner /> : <><Ico e="📅" /></>} Agendar
                </button>
                <div className="grid grid-cols-2 gap-2">
                  <button
                    onClick={() => submit("draft")}
                    disabled={!!submitting || !content.trim()}
                    className="py-2.5 border border-gray-200 text-gray-600 text-sm font-semibold rounded-xl hover:bg-gray-50 disabled:opacity-50 flex items-center justify-center gap-1.5 transition-colors"
                  >
                    {submitting === "draft" ? <Spinner /> : <><Ico e="💾" /></>} Rascunho
                  </button>
                  <button
                    onClick={() => submit("published")}
                    disabled={
                      !!submitting ||
                      !content.trim() ||
                      selectedNetworks.length === 0
                    }
                    className="py-2.5 border border-green-300 text-green-600 text-sm font-semibold rounded-xl hover:bg-green-50 disabled:opacity-50 flex items-center justify-center gap-1.5 transition-colors"
                  >
                    {submitting === "published" ? <Spinner /> : <><Ico e="🚀" /></>} Lançar
                  </button>
                </div>
              </div>
            </div>

            {/* Preview visual */}
            {previewMeta && content && (
              <div className="mt-5 pt-4 border-t border-gray-100">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3">
                  Preview Visual
                </p>
                <div className="rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                  <div className="px-3 py-2.5 border-b border-gray-100 flex items-center gap-2.5 bg-gray-50">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center bg-white shadow-sm border border-gray-100 p-1">
                      <NetworkLogo networkId={previewNet} size={20} />
                    </div>
                    <div>
                      <p className="text-xs font-bold text-gray-700">
                        Sua Conta
                      </p>
                      <p className="text-xs text-gray-400">
                        {previewMeta.name}
                      </p>
                    </div>
                  </div>
                  {mediaFiles.length > 0 && !mediaFiles[0].isVideo && (
                    <div className="aspect-square bg-gray-100 overflow-hidden">
                      <img
                        src={mediaFiles[0].dataUrl}
                        alt=""
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  <div className="px-3 py-3 text-xs text-gray-700 whitespace-pre-wrap line-clamp-5">
                    {content}
                  </div>
                  <div className="px-3 py-2 border-t border-gray-100 flex items-center gap-3 text-gray-300 text-sm">
                    <span>♥</span>
                    <span><Ico e="💬" bare /></span>
                    <span>↗</span>
                    <span className="ml-auto"><Ico e="🔖" bare /></span>
                  </div>
                </div>
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}

// ─── Calendário de Posts ───────────────────────────────────────────────────────
const CAL_MONTHS = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];
const CAL_DAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
// const ONLY_SCHEDULING_NETS = ["pinterest"];

function CalendarView({ posts, onNewPost }) {
  const [calDate, setCalDate] = useState(() => {
    const d = new Date();
    d.setDate(1);
    return d;
  });
  const year = calDate.getFullYear();
  const month = calDate.getMonth();
  const today = new Date();

  const firstDow = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const byDay = {};
  posts.forEach((p) => {
    if (!p.scheduled_at) return;
    const d = new Date(p.scheduled_at);
    if (d.getFullYear() !== year || d.getMonth() !== month) return;
    const k = d.getDate();
    if (!byDay[k]) byDay[k] = [];
    byDay[k].push({ ...p, _d: d });
  });

  const cells = [];
  for (let i = 0; i < firstDow; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const isToday = (d) =>
    d === today.getDate() &&
    month === today.getMonth() &&
    year === today.getFullYear();

  const STATUS_COLOR = {
    scheduled: "#F59E0B",
    agendado: "#F59E0B",
    published: "#10B981",
    publicado: "#10B981",
    draft: "#94A3B8",
    rascunho: "#94A3B8",
    failed: "#EF4444",
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
      {/* Cal Header */}
      <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
        <div className="flex items-center gap-1">
          <button
            onClick={() => setCalDate(new Date(year, month - 1, 1))}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <svg
              className="w-4 h-4 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <span className="font-bold text-gray-800 text-sm min-w-[148px] text-center">
            {CAL_MONTHS[month]} {year}
          </span>
          <button
            onClick={() => setCalDate(new Date(year, month + 1, 1))}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <svg
              className="w-4 h-4 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
          <button
            onClick={() => setCalDate(new Date())}
            className="ml-1 text-xs px-3 py-1 border border-gray-200 rounded-lg text-gray-500 hover:bg-gray-50 font-semibold"
          >
            Hoje
          </button>
        </div>
        <div className="hidden sm:flex items-center gap-4 text-[11px] text-gray-400 font-medium">
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-amber-400 inline-block" />
            Agendado
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-emerald-400 inline-block" />
            Publicado
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-slate-300 inline-block" />
            Rascunho
          </span>
        </div>
      </div>

      {/* Day-of-week row */}
      <div className="grid grid-cols-7 bg-gray-50/80 border-b border-gray-100">
        {CAL_DAYS.map((d) => (
          <div
            key={d}
            className="py-2 text-center text-[10px] font-bold text-gray-400 uppercase tracking-wider"
          >
            {d}
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="grid grid-cols-7">
        {cells.map((day, idx) => (
          <div
            key={idx}
            className={`min-h-[88px] border-b border-r border-gray-50 p-1.5 relative group ${!day ? "bg-gray-50/40" : ""} ${day && isToday(day) ? "bg-blue-50/50" : ""}`}
          >
            {day && (
              <>
                <div
                  className={`w-6 h-6 flex items-center justify-center rounded-full text-[11px] font-bold mb-1 ${isToday(day) ? "bg-blue-600 text-white" : "text-gray-500"}`}
                >
                  {day}
                </div>
                <div className="space-y-0.5">
                  {(byDay[day] || []).slice(0, 3).map((p, pi) => {
                    const net = p.networks?.[0] || p.network || "instagram";
                    return (
                      <div
                        key={pi}
                        className="flex items-center gap-1 bg-white border border-gray-100 rounded px-1 py-0.5 shadow-sm hover:border-blue-300 hover:shadow transition-all cursor-pointer"
                      >
                        <span
                          className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                          style={{
                            background: STATUS_COLOR[p.status] || "#94A3B8",
                          }}
                        />
                        <span className="inline-flex w-3.5 h-3.5 flex-shrink-0">
                          <NetworkLogo networkId={net} size={14} />
                        </span>
                        <span className="text-[10px] font-semibold text-gray-600 truncate leading-none">
                          {p._d.toLocaleTimeString("pt-BR", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </span>
                      </div>
                    );
                  })}
                  {(byDay[day]?.length || 0) > 3 && (
                    <p className="text-[9px] font-bold text-gray-400 pl-1">
                      +{byDay[day].length - 3} mais
                    </p>
                  )}
                </div>
                <button
                  onClick={() => onNewPost(day, month, year)}
                  className="absolute bottom-1 right-1 w-5 h-5 items-center justify-center text-gray-300 hover:text-blue-500 hover:bg-blue-50 rounded text-sm font-bold transition-colors hidden group-hover:flex"
                >
                  +
                </button>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function PostsTab({ api }) {
  const [view, setView] = useState("list");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [deleting, setDeleting] = useState(null);
  const [deletingAll, setDeletingAll] = useState(false);
  const [prefilledDate, setPrefilledDate] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const loadPosts = useCallback(() => {
    setLoading(true);
    api
      .get("/nexohub/posts")
      .then((r) => setPosts(r.data || []))
      .catch((error) => {
        console.error("[NexoHub] Erro ao carregar posts:", error);
        setPosts([]);
        toast.error("Não foi possível carregar os posts.");
      })
      .finally(() => setLoading(false));
  }, [api]);

  useEffect(() => {
    if (view !== "new") loadPosts();
  }, [loadPosts, view]);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Excluir "${title || "este post"}"?`)) return;
    setDeleting(id);
    try {
      const res = await api.delete(`/nexohub/posts/${id}`);
      if (res.data?.message) toast.warning(res.data.message);
      else toast.success("Post excluído.");
      loadPosts();
    } catch (error) {
      const errorData = error?.response?.data;
      const detail = errorData?.detail;
      const errorMessage = [
        detail?.error?.message,
        detail?.message,
        detail?.error,
        errorData?.error?.message,
        errorData?.error,
        detail,
      ].find((value) => typeof value === "string" && value.trim());
      toast.error(errorMessage || "Erro ao excluir.");
    }
    setDeleting(null);
  };

  const handleDeleteAllLocal = async () => {
    if (posts.length === 0 || deletingAll) return;
    const confirmed = window.confirm(
      "Excluir permanentemente todos os posts locais do seu usuário? Isso inclui rascunhos, agendados e publicados, mas não apaga publicações das redes sociais.",
    );
    if (!confirmed) return;

    setDeletingAll(true);
    try {
      const response = await api.delete("/nexohub/posts/bulk-delete");
      toast.success(
        `${response.data?.deleted_count ?? posts.length} post(s) local(is) excluído(s).`,
      );
      loadPosts();
    } catch (error) {
      console.error("[NexoHub] Erro ao excluir posts locais:", error);
      toast.error(
        error?.response?.data?.detail || "Erro ao excluir os posts locais.",
      );
    } finally {
      setDeletingAll(false);
    }
  };

  const handleNewFromCalendar = (day, month, year) => {
    const d = new Date(year, month, day, 9, 0);
    setPrefilledDate(d.toISOString().slice(0, 16));
    setEditingPost(null);
    setView("new");
  };

  const handleEdit = (post) => {
    setEditingPost(post);
    setPrefilledDate(null);
    setView("new");
  };

  const FILTERS = [
    { id: "all", label: "Todos" },
    { id: "sent", label: "Enviados" },
    { id: "processing", label: "Em processo" },
    { id: "unpublished", label: "Não publicados" },
    { id: "draft", label: "Rascunhos" },
    { id: "scheduled", label: "Agendados" },
    { id: "published", label: "Publicados" },
    { id: "failed", label: "Falhas" },
  ];

  const filtered =
    filter === "all"
      ? posts
      : posts.filter(
          (p) =>
            p.status === filter ||
            (filter === "sent" &&
              ["published", "publicado", "sent", "enviado"].includes(
                p.status,
              )) ||
            (filter === "processing" &&
              ["processing", "sending", "pending", "em_processo"].includes(
                p.status,
              )) ||
            (filter === "unpublished" &&
              ["draft", "rascunho", "unpublished", "não publicado"].includes(
                p.status,
              )) ||
            (filter === "draft" && p.status === "rascunho") ||
            (filter === "scheduled" && p.status === "agendado") ||
            (filter === "published" && p.status === "publicado"),
        );

  if (view === "new")
    return (
      <NewPostForm
        api={api}
        prefilledDate={prefilledDate}
        editingPost={editingPost}
        onBack={() => {
          setPrefilledDate(null);
          setEditingPost(null);
          setView("list");
          loadPosts();
        }}
      />
    );

  return (
    <div className="">
      {/* Header: toggle + filtros + novo post */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2 flex-wrap">
          {/* List / Calendar toggle */}
          <div className="flex items-center bg-gray-100 rounded-xl p-1 gap-0.5">
            <button
              onClick={() => setView("list")}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-lg transition-all ${view === "list" ? "bg-white shadow-sm text-gray-800" : "text-gray-500 hover:text-gray-700"}`}
            >
              <svg
                className="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 10h16M4 14h16M4 18h16"
                />
              </svg>
              Lista
            </button>
            <button
              onClick={() => setView("calendar")}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-lg transition-all ${view === "calendar" ? "bg-white shadow-sm text-gray-800" : "text-gray-500 hover:text-gray-700"}`}
            >
              <svg
                className="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              Calendário
            </button>
          </div>
          {/* Filtros (só na lista) */}
          {view === "list" &&
            FILTERS.map((f) => (
              <button
                key={f.id}
                onClick={() => setFilter(f.id)}
                className={`px-3 py-1.5 text-xs font-semibold rounded-full border transition-all ${filter === f.id ? "bg-blue-600 text-white border-blue-600" : "bg-white text-gray-500 border-gray-200 hover:border-blue-300"}`}
              >
                {f.label}
              </button>
            ))}
        </div>
        <div className="flex items-center gap-2">
          {(process.env.NODE_ENV === "development" ||
            ["localhost", "127.0.0.1"].includes(window.location.hostname)) && (
            <button
              onClick={handleDeleteAllLocal}
              disabled={posts.length === 0 || deletingAll || loading}
              className="px-3 py-2 border border-red-200 text-red-600 text-xs font-semibold rounded-xl hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              title="Apaga apenas os posts locais; não remove posts das redes sociais"
            >
              {deletingAll ? <Spinner /> : <><Ico e="🗑" /></>} Limpar posts locais
            </button>
          )}
          <button
            onClick={() => {
              setPrefilledDate(null);
              setEditingPost(null);
              setView("new");
            }}
            className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors flex items-center gap-1.5"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 4v16m8-8H4"
              />
            </svg>
            Novo Post
          </button>
        </div>
      </div>

      {/* Calendário */}
      {view === "calendar" &&
        (loading ? (
          <div className="py-12 text-center text-gray-400">
            <Spinner />
          </div>
        ) : (
          <CalendarView posts={posts} onNewPost={handleNewFromCalendar} />
        ))}

      {/* Lista */}
      {view === "list" &&
        (loading ? (
          <div className="py-12 text-center text-gray-400">
            <Spinner />
          </div>
        ) : filtered.length === 0 ? (
          <div className="py-16 text-center">
            <p className="text-4xl mb-3"><Ico e="📭" bare /></p>
            <p className="text-gray-500 mb-4">Nenhum post encontrado.</p>
            <button
              onClick={() => setView("new")}
              className="px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700"
            >
              Criar primeiro post
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            {filtered.map((p) => (
              <div
                key={p.id || p._id}
                onClick={() => handleEdit(p)}
                className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow flex items-start gap-4 cursor-pointer"
              >
                {p.image_url || (p.media && p.media.length > 0) ? (
                  <div className="w-16 h-16 rounded-xl bg-gray-100 flex items-center justify-center text-2xl shrink-0">
                    <Ico e="🖼" bare />
                  </div>
                ) : (
                  <div className="w-16 h-16 rounded-xl bg-gray-100 flex items-center justify-center text-2xl shrink-0">
                    <Ico e="📝" bare />
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="font-semibold text-gray-800 truncate text-sm">
                      {p.title || p.caption?.slice(0, 50) || "Sem título"}
                    </span>
                    <StatusBadge status={p.status} />
                  </div>
                  <p className="text-sm text-gray-500 line-clamp-2 mb-2">
                    {p.content || p.caption}
                  </p>
                  <div className="flex items-center gap-3 flex-wrap">
                    {p.scheduled_at && (
                      <span className="text-xs text-gray-400">
                        <Ico e="📅" bare />{" "}
                        {new Date(p.scheduled_at).toLocaleString("pt-BR", {
                          day: "2-digit",
                          month: "short",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    )}
                    <div className="flex gap-1 flex-wrap">
                      {(p.networks || [p.network])
                        .filter(Boolean)
                        .map((net) => (
                          <NetworkBadge key={net} networkId={net} small />
                        ))}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(p);
                    }}
                    className="p-2 text-gray-400 hover:text-blue-600 transition-colors"
                  >
                    <Ico e="✏" bare />
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(p.id || p._id, p.title);
                    }}
                    disabled={deleting === (p.id || p._id)}
                    className="p-2 text-gray-400 hover:text-red-500 transition-colors"
                  >
                    {deleting === (p.id || p._id) ? <Spinner /> : <><Ico e="🗑" /></>}
                  </button>
                </div>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
}

// ─── TAB: Campanhas ────────────────────────────────────────────────────────────
const FORMAT_TYPES = [
  { id: "image", label: "Imagens Estáticas", color: "#3B82F6" },
  { id: "carousel", label: "Carrosséis", color: "#8B5CF6" },
  { id: "slideshow", label: "Slideshows Dinâmicos", color: "#EC4899" },
  { id: "aiVideo", label: "Vídeos Gerados (IA)", color: "#F59E0B" },
];
const FORMAT_META = {
  image: { label: "Imagem", color: "#3B82F6", bg: "#eff6ff", icon: <Ico e="🖼" bare /> },
  carousel: { label: "Carrossel", color: "#8B5CF6", bg: "#f5f3ff", icon: <Ico e="🎠" bare /> },
  slideshow: {
    label: "Slideshow",
    color: "#EC4899",
    bg: "#fdf2f8",
    icon: <Ico e="📽" bare />,
  },
  aiVideo: { label: "Vídeo IA", color: "#F59E0B", bg: "#fffbeb", icon: <Ico e="🤖" bare /> },
};

function fmtDate(d) {
  if (!d) return "";
  try {
    return new Date(d + "T12:00:00")
      .toLocaleDateString("pt-BR", { day: "2-digit", month: "short" })
      .toUpperCase();
  } catch {
    return d;
  }
}

function fmtDateTime(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return d;
  }
}

function getSoundStreamUrl(api, sound) {
  const base = (api.defaults?.baseURL || "").replace(/\/api$/, "");
  return `${base}/api/nexohub/sounds/file/${encodeURIComponent(sound?.filename || "")}`;
}

async function downloadSoundAsset(api, sound) {
  if (!sound?.filename) {
    throw new Error("Arquivo de áudio indisponível.");
  }

  const response = await api.get(
    `/nexohub/sounds/file/${encodeURIComponent(sound.filename)}`,
    {
      responseType: "blob",
    },
  );
  const contentType = String(
    response.headers?.["content-type"] || "",
  ).toLowerCase();
  if (contentType.includes("text/html")) {
    throw new Error("Resposta inválida ao baixar o áudio.");
  }

  const blob = new Blob([response.data], { type: contentType || "audio/mpeg" });
  const objectUrl = URL.createObjectURL(blob);
  const extension = sound.filename.includes(".")
    ? sound.filename.split(".").pop()
    : "mp3";
  const baseName =
    (sound.name || "audio").trim().replace(/[^\w.-]+/g, "_") || "audio";
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = `${baseName}.${extension}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

function FormatBadge({ format }) {
  const meta = FORMAT_META[format] || {
    label: format || "Formato",
    color: "#64748b",
    bg: "#f8fafc",
    icon: <Ico e="🧩" bare />,
  };
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold"
      style={{
        background: meta.bg,
        color: meta.color,
        border: `1px solid ${meta.color}30`,
      }}
    >
      <span>{meta.icon}</span>
      {meta.label}
    </span>
  );
}

function CampaignDetailView({ api, campaign, onBack, onNewCampaign }) {
  const [details, setDetails] = useState(campaign);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const campaignId = campaign?.id || campaign?._id;

  const load = useCallback(() => {
    if (!campaignId) return;
    setLoading(true);
    Promise.all([
      api.get(`/nexohub/campaigns/${campaignId}`),
      api.get(`/nexohub/campaigns/${campaignId}/posts`),
    ])
      .then(([campaignRes, postsRes]) => {
        setDetails(campaignRes.data || campaign);
        setPosts(postsRes.data || []);
      })
      .catch(() => {
        toast.error("Não foi possível carregar os criativos desta campanha.");
      })
      .finally(() => setLoading(false));
  }, [api, campaign, campaignId]);

  useEffect(() => {
    load();
  }, [load]);

  const formatCounts = posts.reduce((acc, post) => {
    const key = post.format || "image";
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <button
            onClick={onBack}
            className="flex items-center gap-1.5 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-3"
          >
            ← Retornar ao Centro de Campanhas
          </button>
          <div className="inline-flex items-center gap-1.5 bg-blue-100 text-blue-700 text-xs font-bold px-3 py-1 rounded-full mb-3">
            <span><Ico e="🧠" bare /></span> Detalhe da Campanha
          </div>
          <h2 className="text-2xl font-bold text-gray-900">
            {details?.name || "Campanha"}
          </h2>
          <p className="text-sm text-gray-400 mt-1">
            Visualização dos rascunhos e da direção criativa gerada pelo motor
            de IA.
          </p>
        </div>
        <button
          onClick={onNewCampaign}
          className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-purple-600 to-blue-500 text-white text-sm font-bold rounded-xl hover:opacity-90 transition-all shadow-md flex-shrink-0"
        >
          <span><Ico e="✨" bare /></span> Nova campanha
        </button>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
          <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">
            Rascunhos vinculados
          </p>
          <p className="text-2xl font-bold text-gray-900 mt-1">
            {loading ? "—" : posts.length}
          </p>
        </div>
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
          <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">
            Planejados
          </p>
          <p className="text-2xl font-bold text-gray-900 mt-1">
            {details?.planned_posts ?? 0}
          </p>
        </div>
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
          <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">
            Período
          </p>
          <p className="text-sm font-bold text-gray-900 mt-1">
            {fmtDate(details?.start_date)}{" "}
            {details?.end_date ? `– ${fmtDate(details?.end_date)}` : ""}
          </p>
        </div>
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
          <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">
            Redes
          </p>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {(details?.networks || []).map((net) => (
              <NetworkBadge key={net} networkId={net} small />
            ))}
          </div>
        </div>
      </div>

      {(details?.ai_plan?.campaign_summary ||
        details?.ai_plan?.creative_direction ||
        details?.generation_note) && (
        <div className="bg-white rounded-2xl border border-gray-100 p-5 shadow-sm">
          <h3 className="font-semibold text-gray-800 mb-4">Plano criativo</h3>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="rounded-xl border border-slate-100 bg-slate-50 px-4 py-3">
              <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-1">
                Resumo
              </p>
              <p className="text-sm text-slate-700">
                {details?.ai_plan?.campaign_summary || "—"}
              </p>
            </div>
            <div className="rounded-xl border border-slate-100 bg-slate-50 px-4 py-3">
              <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-1">
                Direção criativa
              </p>
              <p className="text-sm text-slate-700">
                {details?.ai_plan?.creative_direction || "—"}
              </p>
            </div>
            <div className="rounded-xl border border-slate-100 bg-slate-50 px-4 py-3">
              <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500 mb-1">
                CTA principal
              </p>
              <p className="text-sm text-slate-700">
                {details?.ai_plan?.primary_cta || "—"}
              </p>
            </div>
          </div>
          {details?.generation_note && (
            <p className="mt-4 text-xs text-slate-500">
              {details.generation_note}
            </p>
          )}
        </div>
      )}

      {Object.keys(formatCounts).length > 0 && (
        <div className="bg-white rounded-2xl border border-gray-100 p-5 shadow-sm">
          <h3 className="font-semibold text-gray-800 mb-4">
            Distribuição gerada
          </h3>
          <div className="flex flex-wrap gap-2">
            {Object.entries(formatCounts).map(([format, count]) => (
              <span
                key={format}
                className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-3 py-1.5 text-xs font-semibold text-gray-700"
              >
                <FormatBadge format={format} />
                {count}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-50 flex items-center justify-between">
          <h3 className="font-semibold text-gray-800">Criativos gerados</h3>
          <span className="text-xs text-gray-400">
            {loading ? "carregando..." : `${posts.length} item(ns)`}
          </span>
        </div>
        {loading ? (
          <div className="py-16 text-center text-gray-400">
            <Spinner />
          </div>
        ) : posts.length === 0 ? (
          <div className="py-16 text-center text-gray-400">
            <p className="text-3xl mb-2"><Ico e="📭" bare /></p>
            <p className="text-sm">
              Esta campanha não possui rascunhos vinculados ainda.
            </p>
          </div>
        ) : (
          <div className="divide-y divide-gray-50">
            {posts.map((post) => (
              <div
                key={post.id || post._id}
                className="px-6 py-5 hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-2">
                      <p className="font-semibold text-gray-900">
                        {post.title || "Criativo sem título"}
                      </p>
                      <StatusBadge status={post.status} />
                      <FormatBadge format={post.format} />
                    </div>
                    <div className="flex items-center gap-2 flex-wrap mb-3">
                      {(post.networks || [post.network])
                        .filter(Boolean)
                        .map((net) => (
                          <NetworkBadge key={net} networkId={net} small />
                        ))}
                      {post.scheduled_at && (
                        <span className="text-xs text-gray-400">
                          <Ico e="📅" bare />{fmtDateTime(post.scheduled_at)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {post.goal && (
                  <p className="text-xs font-semibold uppercase tracking-wide text-blue-600 mb-2">
                    Objetivo: {post.goal}
                  </p>
                )}
                {post.content && (
                  <p className="text-sm text-gray-600 whitespace-pre-wrap leading-relaxed">
                    {post.content}
                  </p>
                )}
                {post.suggested_visual && (
                  <div className="mt-3 rounded-xl border border-purple-100 bg-purple-50 px-3 py-2">
                    <p className="text-[11px] font-bold uppercase tracking-wider text-purple-600 mb-1">
                      Direção visual
                    </p>
                    <p className="text-sm text-purple-800">
                      {post.suggested_visual}
                    </p>
                  </div>
                )}
                {(post.hashtags || []).length > 0 && (
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {post.hashtags.map((tag, idx) => (
                      <span
                        key={`${post.id || post._id}-${idx}`}
                        className="rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-600"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function CampanhasTab({ api }) {
  const [view, setView] = useState("list");
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(null);
  const [editing, setEditing] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    api
      .get("/nexohub/campaigns")
      .then((r) => setCampaigns(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api]);

  useEffect(() => {
    if (view === "list") load();
  }, [load, view]);

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Excluir campanha "${name}"?`)) return;
    setDeleting(id);
    try {
      await api.delete(`/nexohub/campaigns/${id}`);
      toast.success("Campanha excluída.");
      load();
    } catch {
      toast.error("Erro ao excluir.");
    }
    setDeleting(null);
  };

  if (view === "new")
    return (
      <NewCampaignForm
        api={api}
        editing={editing}
        onBack={() => {
          setEditing(null);
          setView("list");
          load();
        }}
      />
    );
  if (view === "detail")
    return (
      <CampaignDetailView
        api={api}
        campaign={selectedCampaign}
        onBack={() => {
          setSelectedCampaign(null);
          setView("list");
          load();
        }}
        onNewCampaign={() => {
          setEditing(null);
          setView("new");
        }}
      />
    );

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 bg-purple-100 text-purple-700 text-xs font-bold px-3 py-1 rounded-full mb-3">
            <span>✦</span> Motores de IA
          </div>
          <h2 className="text-2xl font-bold text-gray-900">
            Centro de Campanhas
          </h2>
          <p className="text-sm text-gray-400 mt-1">
            Painel de controle para orquestração massiva de conteúdo sintético.
          </p>
        </div>
        <button
          onClick={() => setView("new")}
          className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-purple-600 to-blue-500 text-white text-sm font-bold rounded-xl hover:opacity-90 transition-all shadow-md flex-shrink-0"
        >
          <span><Ico e="✨" bare /></span> Inicializar Motor IA
        </button>
      </div>

      {loading ? (
        <div className="py-16 text-center">
          <Spinner />
        </div>
      ) : campaigns.length === 0 ? (
        <div className="py-20 text-center bg-white rounded-2xl border border-gray-100">
          <div className="w-16 h-16 bg-purple-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl"><Ico e="🚀" bare /></span>
          </div>
          <p className="font-bold text-gray-700 mb-1">Nenhuma campanha ainda</p>
          <p className="text-sm text-gray-400 mb-5">
            Inicialize o motor IA para orquestrar sua primeira campanha.
          </p>
          <button
            onClick={() => setView("new")}
            className="px-5 py-2.5 bg-gradient-to-r from-purple-600 to-blue-500 text-white text-sm font-bold rounded-xl hover:opacity-90 shadow-md"
          >
            <Ico e="✨" />Inicializar Motor IA
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {campaigns.map((c) => {
            const nets = c.networks || [];
            const visible = nets.slice(0, 5);
            const extra = nets.length - visible.length;
            return (
              <div
                key={c.id || c._id}
                onClick={() => {
                  setSelectedCampaign(c);
                  setView("detail");
                }}
                className="bg-white rounded-2xl border border-gray-100 p-5 shadow-sm hover:shadow-lg transition-all cursor-pointer group"
              >
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <span
                      className="inline-block text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full border mb-2
                      bg-amber-50 text-amber-700 border-amber-200"
                    >
                      {c.status === "active"
                        ? "Pronta para revisão"
                        : c.status === "draft"
                          ? "Rascunho"
                          : c.status || "Ativa"}
                    </span>
                    <p className="font-bold text-gray-900 text-base leading-tight">
                      {c.name || "Campanha sem nome"}
                    </p>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(c.id || c._id, c.name);
                    }}
                    disabled={deleting === (c.id || c._id)}
                    className="p-1.5 text-gray-200 hover:text-red-400 transition-colors flex-shrink-0 opacity-0 group-hover:opacity-100"
                  >
                    {deleting === (c.id || c._id) ? (
                      <Spinner />
                    ) : (
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6"
                        />
                      </svg>
                    )}
                  </button>
                </div>

                {c.briefing && (
                  <p className="text-xs text-gray-400 line-clamp-2 mb-4 leading-relaxed">
                    {c.briefing}
                  </p>
                )}

                <div className="flex items-center gap-3 text-xs text-gray-400 mb-4">
                  {c.start_date && c.end_date && (
                    <div className="flex items-center gap-1.5">
                      <svg
                        className="w-3.5 h-3.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <span>
                        {fmtDate(c.start_date)} – {fmtDate(c.end_date)}
                      </span>
                    </div>
                  )}
                  {c.posts_per_day && (
                    <div className="flex items-center gap-1">
                      <svg
                        className="w-3.5 h-3.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 6h16M4 10h16M4 14h16M4 18h16"
                        />
                      </svg>
                      <span>
                        {c.posts_per_day *
                          Math.max(
                            1,
                            Math.round(
                              (new Date(c.end_date) - new Date(c.start_date)) /
                                86400000,
                            ),
                          )}{" "}
                        ativos
                      </span>
                    </div>
                  )}
                </div>

                {c.generated_posts_count || c.planned_posts ? (
                  <div className="mb-4 rounded-xl border border-slate-100 bg-slate-50 px-3 py-2">
                    <p className="text-[11px] font-semibold text-slate-700">
                      {c.generated_posts_count || 0} rascunho
                      {(c.generated_posts_count || 0) !== 1 ? "s" : ""} gerado
                      {(c.generated_posts_count || 0) !== 1 ? "s" : ""}
                      {c.planned_posts
                        ? ` de ${c.planned_posts} planejado${c.planned_posts !== 1 ? "s" : ""}`
                        : ""}
                    </p>
                    {c.generation_note && (
                      <p className="mt-1 text-[11px] leading-relaxed text-slate-500">
                        {c.generation_note}
                      </p>
                    )}
                  </div>
                ) : null}

                <div className="flex items-center gap-1.5">
                  {visible.map((n) => (
                    <div
                      key={n}
                      className="w-7 h-7 rounded-full bg-white shadow border border-gray-100 flex items-center justify-center p-0.5"
                    >
                      <NetworkLogo networkId={n} size={18} />
                    </div>
                  ))}
                  {extra > 0 && (
                    <div className="w-7 h-7 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-bold text-gray-500">
                      +{extra}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const DIST_TYPES = [
  { id: "image", label: "Imagem Estática", color: "#3B82F6", icon: <Ico e="🖼" bare /> },
  { id: "carousel", label: "Carrossel", color: "#8B5CF6", icon: <Ico e="🎠" bare /> },
  { id: "slideshow", label: "Slideshow", color: "#EC4899", icon: <Ico e="📽" bare /> },
  { id: "aiVideo", label: "Vídeo IA", color: "#F59E0B", icon: <Ico e="🤖" bare /> },
];

function DistributionSliders({ value, onChange }) {
  const total = Object.values(value).reduce((s, v) => s + v, 0);
  const handleSlider = (key, raw) => {
    const newVal = Math.max(0, Math.min(100, parseInt(raw) || 0));
    const diff = newVal - value[key];
    const others = DIST_TYPES.map((t) => t.id).filter((k) => k !== key);
    const othersTotal = others.reduce((s, k) => s + value[k], 0);
    const next = { ...value, [key]: newVal };
    if (othersTotal > 0) {
      let remaining = diff;
      others.forEach((k, i) => {
        const share =
          i === others.length - 1
            ? remaining
            : Math.round((value[k] / othersTotal) * diff);
        next[k] = Math.max(0, value[k] - share);
        remaining -= value[k] - next[k];
      });
    }
    const sum = Object.values(next).reduce((s, v) => s + v, 0);
    if (sum !== 100) {
      const adj = others.find((k) => next[k] > 0) || others[0];
      next[adj] = Math.max(0, next[adj] + (100 - sum));
    }
    onChange(next);
  };
  return (
    <div className="space-y-3">
      {DIST_TYPES.map((t) => (
        <div key={t.id}>
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs font-semibold text-gray-600 flex items-center gap-1.5">
              <span>{t.icon}</span>
              {t.label}
            </span>
            <span
              className="text-xs font-bold tabular-nums"
              style={{ color: t.color }}
            >
              {value[t.id]}%
            </span>
          </div>
          <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="absolute inset-y-0 left-0 rounded-full transition-all"
              style={{ width: `${value[t.id]}%`, background: t.color }}
            />
          </div>
          <input
            type="range"
            min={0}
            max={100}
            value={value[t.id]}
            onChange={(e) => handleSlider(t.id, e.target.value)}
            className="w-full mt-1 accent-blue-600 h-1 cursor-pointer"
          />
        </div>
      ))}
      <div
        className={`text-xs font-bold text-right ${total === 100 ? "text-emerald-600" : "text-red-500"}`}
      >
        Total: {total}%{" "}
        {total === 100
          ? "✓"
          : `(ajuste ${100 - total > 0 ? "+" : ""}${100 - total}%)`}
      </div>
    </div>
  );
}

function BrandKitMiniCard({ api }) {
  const [kit, setKit] = useState(null);
  useEffect(() => {
    api
      .get("/nexohub/brand-kit")
      .then((r) => setKit(r.data))
      .catch(() => {});
  }, [api]);
  if (!kit || !kit.company_name) return null;
  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 flex items-center gap-4">
      <div className="flex gap-1.5 flex-shrink-0">
        {[kit.primary_color, kit.secondary_color, kit.accent_color].map(
          (c, i) => (
            <div
              key={i}
              className="w-5 h-5 rounded-full border border-white shadow-sm ring-1 ring-gray-200"
              style={{ background: c }}
              title={c}
            />
          ),
        )}
      </div>
      <div className="min-w-0">
        <p className="text-xs font-bold text-gray-700 truncate">
          {kit.company_name}
        </p>
        {kit.tagline && (
          <p className="text-[10px] text-gray-400 truncate">{kit.tagline}</p>
        )}
      </div>
      {kit.font && (
        <span className="ml-auto text-[10px] font-bold text-gray-400 uppercase tracking-wide flex-shrink-0 bg-white px-2 py-0.5 rounded border border-gray-200">
          {kit.font}
        </span>
      )}
    </div>
  );
}

function NewCampaignForm({ api, onBack, editing }) {
  const logoRef = useRef(null);
  const anchorRef = useRef(null);

  useEffect(() => {
    if (editing) {
      setName(editing.name || "");
      setBriefing(editing.briefing || "");
      setSelectedNetworks(editing.networks || []);
      setStartDate(editing.start_date || "");
      setEndDate(editing.end_date || "");
      setPostsPerDay(editing.posts_per_day || 2);
      if (editing.content_distribution)
        setDistribution(editing.content_distribution);
      if (editing.brand_kit) setBk((s) => ({ ...s, ...editing.brand_kit }));
    }
  }, [editing]);

  // Brand Kit state
  const [bk, setBk] = useState({
    company_name: "",
    website: "",
    tagline: "",
    primary_color: "#2563EB",
    secondary_color: "#0EA5E9",
    accent_color: "#FF2D78",
    font: "poppins",
  });
  const [analyzeUrl, setAnalyzeUrl] = useState("");
  const [analyzing, setAnalyzing] = useState(false);
  const [savingBk, setSavingBk] = useState(false);
  const [logoDataUrl, setLogoDataUrl] = useState(null);

  // Campaign state
  const [name, setName] = useState("");
  const [briefing, setBriefing] = useState("");
  const [selectedNetworks, setSelectedNetworks] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [postsPerDay, setPostsPerDay] = useState(2);
  const [distribution, setDistribution] = useState({
    image: 20,
    carousel: 30,
    slideshow: 35,
    aiVideo: 15,
  });
  const [anchors, setAnchors] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api
      .get("/nexohub/brand-kit")
      .then((r) => {
        if (r.data?.id) setBk((s) => ({ ...s, ...r.data }));
      })
      .catch(() => {});
  }, [api]);

  const setBkField = (k, v) => setBk((s) => ({ ...s, [k]: v }));
  const safeColor = (c) => (/^#([0-9a-fA-F]{6})$/.test(c) ? c : "#000000");

  const handleAnalyze = async () => {
    if (!analyzeUrl.trim()) {
      toast.error("Cole o endereço do site.");
      return;
    }
    setAnalyzing(true);
    try {
      const r = await api.post("/nexohub/brand-kit/analyze", {
        url: analyzeUrl.trim(),
      });
      if (r.data) {
        setBk((s) => ({
          ...s,
          primary_color: r.data.primary_color || s.primary_color,
          secondary_color: r.data.secondary_color || s.secondary_color,
          accent_color: r.data.accent_color || s.accent_color,
          tagline: r.data.tagline || s.tagline,
          website: r.data.website || s.website,
        }));
        toast.success("Site analisado! Revise as cores e salve.");
      }
    } catch {
      toast.error("Não foi possível analisar o site.");
    }
    setAnalyzing(false);
  };

  const handleSaveBk = async () => {
    setSavingBk(true);
    try {
      await api.post("/nexohub/brand-kit", bk);
      toast.success("Brand Kit salvo! ");
    } catch {
      toast.error("Erro ao salvar Brand Kit.");
    }
    setSavingBk(false);
  };

  const handleLogo = (files) => {
    if (!files?.length) return;
    const r = new FileReader();
    r.onload = (e) => setLogoDataUrl(e.target.result);
    r.readAsDataURL(files[0]);
  };

  const handleAnchors = async (files) => {
    if (!files) return;
    const toAdd = Array.from(files).slice(0, 6 - anchors.length);
    const readers = toAdd.map(
      (f) =>
        new Promise((res) => {
          const reader = new FileReader();
          reader.onload = (e) =>
            res({ name: f.name, dataUrl: e.target.result });
          reader.readAsDataURL(f);
        }),
    );
    setAnchors((a) => [...a, ...[]]);
    const results = await Promise.all(readers);
    setAnchors((a) => [...a, ...results]);
    if (anchorRef.current) anchorRef.current.value = "";
  };

  const toggleNetwork = (net) =>
    setSelectedNetworks((p) =>
      p.includes(net) ? p.filter((n) => n !== net) : [...p, net],
    );

  const distTotal = Object.values(distribution).reduce((s, v) => s + v, 0);

  const handleDist = (key, raw) => {
    const newVal = Math.max(0, Math.min(100, parseInt(raw) || 0));
    const diff = newVal - distribution[key];
    const others = Object.keys(distribution).filter((k) => k !== key);
    const othersTotal = others.reduce((s, k) => s + distribution[k], 0);
    const next = { ...distribution, [key]: newVal };
    if (othersTotal > 0) {
      let rem = diff;
      others.forEach((k, i) => {
        const share =
          i === others.length - 1
            ? rem
            : Math.round((distribution[k] / othersTotal) * diff);
        next[k] = Math.max(0, distribution[k] - share);
        rem -= distribution[k] - next[k];
      });
    }
    const sum = Object.values(next).reduce((s, v) => s + v, 0);
    if (sum !== 100) {
      const adj = others.find((k) => next[k] > 0) || others[0];
      next[adj] = Math.max(0, next[adj] + (100 - sum));
    }
    setDistribution(next);
  };

  const submit = async () => {
    if (!briefing.trim()) {
      toast.error("Briefing é obrigatório.");
      return;
    }
    if (selectedNetworks.length === 0) {
      toast.error("Selecione ao menos uma rede.");
      return;
    }
    if (!startDate || !endDate) {
      toast.error("Defina o período da campanha.");
      return;
    }
    if (distTotal !== 100) {
      toast.error("O Balanço de Formatos deve somar 100%.");
      return;
    }
    setSubmitting(true);
    try {
      const r = await api.post("/nexohub/campaigns", {
        name:
          name.trim() || `Campanha ${new Date().toLocaleDateString("pt-BR")}`,
        briefing: briefing.trim(),
        networks: selectedNetworks,
        start_date: startDate,
        end_date: endDate,
        posts_per_day: postsPerDay,
        content_distribution: distribution,
        brand_kit: bk,
        status: "active",
        generate_with_ai: true,
      });
      const postsCreated = r?.data?.posts_created || 0;
      const plannedPosts = r?.data?.planned_posts || 0;
      toast.success(
        `Campanha criada com ${postsCreated} rascunho${postsCreated !== 1 ? "s" : ""}${plannedPosts ? ` para ${plannedPosts} postagens planejadas` : ""}.`,
      );
      onBack();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao inicializar o motor.");
    }
    setSubmitting(false);
  };

  return (
    <div className="space-y-5 max-w-2xl">
      {/* Cabeçalho */}
      <div className="flex items-center justify-between">
        <button
          onClick={onBack}
          className="flex items-center gap-1.5 text-xs text-gray-400 hover:text-gray-600 transition-colors"
        >
          ← Retornar ao Centro de Campanhas
        </button>
        <button
          onClick={onBack}
          className="w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors text-lg"
        >
          ✕
        </button>
      </div>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-blue-500 rounded-xl flex items-center justify-center shadow-md flex-shrink-0">
          <span className="text-white text-lg"><Ico e="✨" bare /></span>
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-900">
            Inicializar Motor IA
          </h2>
          <p className="text-xs text-gray-400">
            Defina os vetores da campanha e permita que nossa IA orquestre os
            disparos.
          </p>
        </div>
      </div>

      {/* 1. Identificação */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <label className="text-xs font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2 mb-3">
          <span className="w-2 h-2 rounded-full bg-gray-300" /> Identificação
          (opcional)
        </label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ex.: Operação Black Friday 2026"
          className="w-full text-sm border border-gray-200 rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-400"
        />
      </div>

      {/* 2. Brand Kit */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5 ">
        <div>
          <label className="text-xs font-bold text-purple-600 uppercase tracking-widest flex items-center gap-2 mb-0.5">
            <span className="w-2 h-2 rounded-full bg-purple-500" /> Brand Kit
          </label>
          <p className="text-xs text-gray-400">
            Logo, cores e fonte do Perfil Principal. Aplicados automaticamente
            aos criativos gerados.
          </p>
        </div>

        {/* Analisar site */}
        <div className="rounded-xl border border-purple-100 bg-gradient-to-r from-purple-50 to-blue-50 p-4">
          <p className="text-xs font-bold text-purple-700 uppercase tracking-wider mb-1">
            ✦ Analisar Site do Cliente
          </p>
          <p className="text-xs text-gray-500 mb-3">
            Cole o link do site e a IA extrai identidade visual — logo, cores e
            slogan automaticamente.
          </p>
          <div className="flex gap-2">
            <div className="flex-1 flex items-center gap-2 border border-purple-200 rounded-lg bg-white px-3">
              <span className="text-gray-400"><Ico e="🌐" bare /></span>
              <input
                value={analyzeUrl}
                onChange={(e) => setAnalyzeUrl(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleAnalyze()}
                placeholder="www.seusite.com.br"
                className="flex-1 text-sm py-2.5 bg-transparent focus:outline-none"
              />
            </div>
            <button
              onClick={handleAnalyze}
              disabled={analyzing}
              className="px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-500 text-white text-sm font-bold rounded-lg disabled:opacity-60 flex items-center gap-1.5 flex-shrink-0"
            >
              {analyzing ? <Spinner /> : <><Ico e="✨" /></>} Analisar
            </button>
          </div>
        </div>

        {/* Logo + Cores */}
        <div className="flex gap-4 items-start">
          {/* Logo */}
          <div className="flex flex-col items-center gap-1.5 flex-shrink-0">
            <div
              className="w-[72px] h-[72px] rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center overflow-hidden cursor-pointer hover:border-purple-400 transition-colors"
              onClick={() => logoRef.current?.click()}
            >
              {logoDataUrl ? (
                <img
                  src={logoDataUrl}
                  alt="Logo"
                  className="w-full h-full object-contain"
                />
              ) : (
                <span className="text-3xl"><Ico e="🏷" bare /></span>
              )}
            </div>
            <button
              onClick={() => logoRef.current?.click()}
              className="text-xs font-semibold text-gray-500 flex items-center gap-1 hover:text-purple-600 transition-colors"
            >
              ↑ Enviar
            </button>
            {logoDataUrl && (
              <button
                onClick={() => setLogoDataUrl(null)}
                className="text-[10px] text-red-400 hover:text-red-600"
              >
                Remover
              </button>
            )}
            <input
              ref={logoRef}
              type="file"
              className="hidden"
              accept="image/*"
              onChange={(e) => handleLogo(e.target.files)}
            />
          </div>

          {/* Cores */}
          <div className="flex-1 space-y-3">
            <div className="grid grid-cols-3 gap-2">
              {[
                { label: "Cor Primária", field: "primary_color" },
                { label: "Cor Secundária", field: "secondary_color" },
                { label: "Cor de Destaque", field: "accent_color" },
              ].map(({ label, field }) => (
                <div key={field}>
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block mb-1">
                    {label}
                  </span>
                  <div className="flex items-center gap-1.5 border border-gray-200 rounded-lg px-2 py-1.5 bg-white">
                    <input
                      type="color"
                      value={safeColor(bk[field])}
                      onChange={(e) => setBkField(field, e.target.value)}
                      className="w-5 h-5 rounded cursor-pointer p-0 border-0 flex-shrink-0"
                    />
                    <input
                      type="text"
                      maxLength={7}
                      value={bk[field]}
                      onChange={(e) => setBkField(field, e.target.value)}
                      className="flex-1 text-xs font-mono uppercase bg-transparent focus:outline-none min-w-0"
                    />
                  </div>
                </div>
              ))}
            </div>
            <div>
              <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block mb-1">
                Fonte da Marca
              </span>
              <select
                value={bk.font || "poppins"}
                onChange={(e) => setBkField("font", e.target.value)}
                className="w-full text-xs border border-gray-200 rounded-lg px-2 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-purple-400"
              >
                <option value="poppins">Poppins — moderna e limpa</option>
                <option value="anton">Anton (impacto, manchete)</option>
                <option value="inter">Inter — minimalista técnica</option>
                <option value="montserrat">
                  Montserrat — elegante corporativa
                </option>
              </select>
            </div>
          </div>
        </div>

        {/* Website + Slogan */}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block mb-1">
              Website
            </span>
            <input
              value={bk.website || ""}
              onChange={(e) => setBkField("website", e.target.value)}
              placeholder="www.seusite.com.br"
              className="w-full text-xs border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-400"
            />
          </div>
          <div>
            <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block mb-1">
              Slogan
            </span>
            <input
              value={bk.tagline || ""}
              onChange={(e) => setBkField("tagline", e.target.value)}
              placeholder="Sua frase de marca"
              className="w-full text-xs border border-gray-200 rounded-lg px-3 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-400"
            />
          </div>
        </div>

        <button
          onClick={handleSaveBk}
          disabled={savingBk}
          className="w-full py-2.5 bg-gradient-to-r from-purple-600 to-blue-500 text-white text-sm font-bold rounded-xl hover:opacity-90 disabled:opacity-60 flex items-center justify-center gap-2"
        >
          {savingBk ? <Spinner /> : <><Ico e="✨" /></>} Salvar Brand Kit
        </button>
      </div>

      {/* 3. Vetor de Comunicação */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <label className="text-xs font-bold text-blue-600 uppercase tracking-widest flex items-center gap-2 mb-1">
          <span className="w-2 h-2 rounded-full bg-blue-500" /> Vetor de
          Comunicação (Briefing) <span className="text-red-400">*</span>
        </label>
        <p className="text-xs text-gray-400 mb-3">
          Alimente o modelo com dados sobre produto, tom de voz, público alvo e
          restrições operacionais.
        </p>
        <textarea
          value={briefing}
          onChange={(e) => setBriefing(e.target.value)}
          placeholder="Ex.: Lançamento da coleção de outono focado em sustentabilidade. O tom deve ser moderno, leve e engajar o público jovem. Usar emojis limitados e incluir sempre a hashtag #OutonoSustentavel."
          className="w-full text-sm border border-gray-200 rounded-xl px-4 py-3 bg-gray-50 min-h-[120px] resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      {/* 4. Nós de Destino */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <label className="text-xs font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2 mb-3">
          <span className="text-purple-500 text-base">✦</span> Nós de Destino{" "}
          <span className="text-red-400">*</span>
        </label>
        <div className="grid grid-cols-4 sm:grid-cols-7 gap-2">
          {ALL_NETWORKS.map((net) => {
            const m = NETWORK_META[net];
            const active = selectedNetworks.includes(net);
            return (
              <button
                key={net}
                onClick={() => toggleNetwork(net)}
                title={m.name}
                className={`flex flex-col items-center justify-center gap-1 py-3 rounded-xl border-2 transition-all ${
                  active
                    ? "border-blue-400 bg-blue-50 shadow-sm"
                    : "border-gray-100 bg-gray-50 opacity-50 hover:opacity-80"
                }`}
              >
                <NetworkLogo networkId={net} size={28} />
                <span className="text-[9px] font-semibold text-gray-500 leading-none">
                  {m.name.split(" ")[0]}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* 5. Janela Operacional */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <label className="text-xs font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2 mb-4">
          <span className="text-blue-400"><Ico e="📅" bare /></span> Janela Operacional
        </label>
        <div className="grid grid-cols-3 gap-4">
          <div>
            <span className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1.5">
              Início <span className="text-red-400">*</span>
            </span>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <div>
            <span className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1.5">
              Término <span className="text-red-400">*</span>
            </span>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <div>
            <span className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1.5">
              Frequência (disparos/dia)
            </span>
            <input
              type="number"
              min={1}
              max={10}
              value={postsPerDay}
              onChange={(e) =>
                setPostsPerDay(
                  Math.max(1, Math.min(10, parseInt(e.target.value) || 1)),
                )
              }
              className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
        </div>
      </div>

      {/* 6. Balanço de Formatos */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <div className="flex items-center justify-between mb-4">
          <label className="text-xs font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2">
            <span><Ico e="⚖" bare /></span> Balanço de Formatos
          </label>
          <span
            className={`text-xs font-bold px-3 py-1 rounded-full ${distTotal === 100 ? "bg-purple-100 text-purple-700" : "bg-red-100 text-red-600"}`}
          >
            CARGA: {distTotal}%
          </span>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {FORMAT_TYPES.map((t) => (
            <div
              key={t.id}
              className="bg-gray-50 rounded-xl p-3 border border-gray-100"
            >
              <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-2 leading-tight">
                {t.label}
              </p>
              <div className="flex items-baseline gap-0.5 mb-2">
                <input
                  type="number"
                  min={0}
                  max={100}
                  value={distribution[t.id]}
                  onChange={(e) => handleDist(t.id, e.target.value)}
                  className="w-12 text-2xl font-bold text-gray-800 bg-transparent focus:outline-none"
                />
                <span className="text-sm font-bold text-gray-400">%</span>
              </div>
              <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden mb-1">
                <div
                  className="h-full rounded-full transition-all"
                  style={{
                    width: `${distribution[t.id]}%`,
                    background: t.color,
                  }}
                />
              </div>
              <input
                type="range"
                min={0}
                max={100}
                value={distribution[t.id]}
                onChange={(e) => handleDist(t.id, e.target.value)}
                className="w-full h-1 cursor-pointer"
                style={{ accentColor: t.color }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* 7. Ancoragem Visual */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <label className="text-xs font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2 mb-1">
          <span className="w-2 h-2 rounded-full bg-gray-300" /> Ancoragem Visual
          (opcional)
        </label>
        <p className="text-xs text-gray-400 mb-4">
          Forneça até 6 ativos visuais para guiar o motor de geração de imagens
          da IA.
        </p>
        <div className="flex flex-wrap gap-3">
          {anchors.map((a, idx) => (
            <div
              key={idx}
              className="relative w-20 h-20 rounded-xl overflow-hidden border border-gray-200 group"
            >
              <img
                src={a.dataUrl}
                alt={a.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <button
                  onClick={() =>
                    setAnchors((a) => a.filter((_, i) => i !== idx))
                  }
                  className="bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
                >
                  ✕
                </button>
              </div>
            </div>
          ))}
          {anchors.length < 6 && (
            <button
              onClick={() => anchorRef.current?.click()}
              className="w-20 h-20 rounded-xl border-2 border-dashed border-gray-200 flex flex-col items-center justify-center gap-1 text-gray-400 hover:border-purple-400 hover:text-purple-500 transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M12 4v16m8-8H4"
                />
              </svg>
              <span className="text-[10px] font-bold uppercase">Anexar</span>
            </button>
          )}
          <input
            ref={anchorRef}
            type="file"
            className="hidden"
            multiple
            accept="image/*,video/*"
            onChange={(e) => handleAnchors(e.target.files)}
          />
        </div>
      </div>

      {/* Executar */}
      <div className="rounded-2xl border border-blue-100 bg-blue-50 px-4 py-3">
        <p className="text-sm font-semibold text-blue-900">
          O que acontece ao executar
        </p>
        <p className="mt-1 text-xs leading-relaxed text-blue-700">
          A IA cria a campanha, monta o plano criativo e gera automaticamente
          rascunhos de posts para revisão no módulo de posts.
        </p>
      </div>

      <button
        onClick={submit}
        disabled={submitting}
        className="w-full py-4 bg-gradient-to-r from-purple-600 to-blue-500 text-white font-bold rounded-2xl hover:opacity-90 disabled:opacity-60 text-base flex items-center justify-center gap-3 shadow-lg transition-all"
      >
        {submitting ? (
          <>
            <Spinner /> Inicializando motor...
          </>
        ) : (
          <>
            <span className="text-lg"><Ico e="✨" bare /></span> Executar Geração de Campanha
          </>
        )}
      </button>
    </div>
  );
}

// ─── TAB: Contas Sociais ───────────────────────────────────────────────────────
function ContasSociaisTab({ api }) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formNet, setFormNet] = useState("instagram");
  const [formData, setFormData] = useState({
    account_name: "",
    account_username: "",
    access_token: "",
  });
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [redesSociais, setRedesSociais] = useState({});

  const load = useCallback(() => {
    setLoading(true);
    api
      .get("/nexohub/accounts")
      .then((r) => setAccounts(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api]);

  useEffect(() => {
    load();
  }, [load]);

  const getRedesSociais = useCallback(() => {
    setRedesSociais({});

    api
      .get("/synkly/accounts")
      .then((r) => {
        const data = Array.isArray(r.data) ? r.data : [];
        const tipoPorCanal = {
          meta: "facebook",
          instagram: "instagram",
          whatsapp: "whatsapp",
          linkedin: "linkedin",
          facebook: "facebook",
        };

        const accounts = data.map((account) => ({
          ...account,
          tipo: tipoPorCanal[account.channel] || account.channel || "social",
        }));

        setRedesSociais({ accounts });
      })
      .catch((error) => {
        console.error("Erro ao buscar contas de redes sociais:", error);
        setRedesSociais({ accounts: [] });
      });
  }, [api]);

  useEffect(() => {
    getRedesSociais();
  }, [getRedesSociais]);

  const connectedMap = new Map(accounts.map((a) => [a.network, a]));
  const contasRedesConectadas = Array.isArray(redesSociais.accounts)
    ? redesSociais.accounts
    : [];
  const totalRedesConectadas = new Set([
    ...accounts.map((account) => account.network),
    ...contasRedesConectadas.map((account) => account.tipo),
  ]).size;

  const handleConnect = async () => {
    if (!formData.account_name.trim() || !formData.access_token.trim()) {
      toast.error("Nome da conta e token são obrigatórios.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/nexohub/accounts", { network: formNet, ...formData });
      toast.success(`${NETWORK_META[formNet]?.name}conectado! `);
      setShowForm(false);
      setFormData({ account_name: "", account_username: "", access_token: "" });
      load();
    } catch {
      toast.error("Erro ao conectar conta.");
    }
    setSaving(false);
  };

  const handleDisconnect = async (id, name) => {
    if (!window.confirm(`Desconectar "${name}"?`)) return;
    setDeleting(id);
    try {
      await api.delete(`/nexohub/accounts/${id}`);
      toast.success("Conta desconectada.");
      load();
    } catch {
      toast.error("Erro ao desconectar.");
    }
    setDeleting(null);
  };

  return (
    <div className="space-y-5">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-0.5">
            NexoHub
          </p>
          <h3 className="font-bold text-gray-800 text-lg flex items-center gap-2">
            Contas sociais do perfil
            <span className="text-base"><Ico e="⭐" bare /></span>
          </h3>
          <p className="text-xs text-gray-400 mt-0.5">
            {totalRedesConectadas} de {ALL_NETWORKS.length} redes conectadas
          </p>
        </div>
        {/* <button
          onClick={() => setShowForm(true)}
          className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors flex items-center gap-1.5"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 4v16m8-8H4"
            />
          </svg>
          Conectar Conta
        </button> */}
      </div>

      {/* {showForm && (
        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-5 ">
          <p className="text-sm font-bold text-blue-700">Conectar Nova Conta</p>
          <div>
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1.5">
              Rede Social
            </label>
            <div className="flex flex-wrap gap-2">
              {ALL_NETWORKS.map((net) => {
                const m = NETWORK_META[net];
                return (
                  <button
                    key={net}
                    onClick={() => setFormNet(net)}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-bold transition-all ${formNet === net ? "border-blue-500 bg-blue-600 text-white" : "border-gray-200 text-gray-500 bg-white hover:bg-gray-50"}`}
                  >
                    {m.icon} {m.name}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1">
                Nome da Conta
              </label>
              <input
                value={formData.account_name}
                onChange={(e) =>
                  setFormData((f) => ({ ...f, account_name: e.target.value }))
                }
                placeholder="Ex.: Minha Marca"
                className="w-full text-sm border border-blue-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1">
                Username
              </label>
              <input
                value={formData.account_username}
                onChange={(e) =>
                  setFormData((f) => ({
                    ...f,
                    account_username: e.target.value,
                  }))
                }
                placeholder="@usuario"
                className="w-full text-sm border border-blue-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
          <div>
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1">
              Token de Acesso
            </label>
            <input
              type="password"
              value={formData.access_token}
              onChange={(e) =>
                setFormData((f) => ({ ...f, access_token: e.target.value }))
              }
              placeholder="Access token da API"
              className="w-full text-sm border border-blue-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleConnect}
              disabled={saving}
              className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 disabled:opacity-60 flex items-center gap-2"
            >
              {saving && <Spinner />} Conectar
            </button>
            <button
              onClick={() => setShowForm(false)}
              className="px-4 py-2 text-gray-500 text-sm hover:text-gray-700"
            >
              Cancelar
            </button>
          </div>
        </div>
      )} */}

      {loading ? (
        <div className="py-12 text-center">
          <Spinner />
        </div>
      ) : (
        <div
          id="networks-grid"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
        >
          {contasRedesConectadas.map((account, index) => {
            const tipo = account.tipo || account.channel || "social";
            const network = NETWORK_META[tipo] || {
              color: "#64748B",
              channels: [{ id: "feed", label: "Conta" }],
            };
            const nome =
              account.label ||
              account.name ||
              account.account_name ||
              account.username ||
              account.externalId ||
              account.id ||
              "Conta conectada";

            return (
              <div
                key={
                  account.id ||
                  account._id ||
                  account.externalId ||
                  `${tipo}-${index}`
                }
                className="relative flex flex-col justify-between rounded-2xl p-5 overflow-hidden shadow-md"
                style={{
                  background: `linear-gradient(145deg, ${network.color}ee, ${network.color}88)`,
                  minHeight: "200px",
                }}
              >
                <div className="relative z-10 flex items-start gap-3">
                  <div className="w-12 h-12 rounded-2xl bg-white shadow-md flex items-center justify-center text-2xl flex-shrink-0">
                    {NETWORK_META[tipo] ? (
                      <NetworkLogo networkId={tipo} size={30} />
                    ) : (
                      <><Ico e="🔗" /></>
                    )}
                  </div>
                  <div className="min-w-0">
                    <p className="text-white font-bold text-sm truncate">
                      {nome}
                    </p>
                    {(account.username || account.account_username) && (
                      <p className="text-white/75 text-[11px] truncate">
                        @{account.username || account.account_username}
                      </p>
                    )}
                  </div>
                </div>

                <div className="relative z-10 mt-3">
                  <span className="inline-flex items-center gap-1.5 bg-white/20 border border-white/30 text-white text-[10px] font-bold px-2.5 py-1 rounded-full">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-300 animate-pulse" />
                    Sincronizado
                  </span>
                </div>

                <div className="relative z-10 mt-3 flex flex-wrap gap-1">
                  {(network.channels || []).map((channel) => (
                    <span
                      key={channel.id}
                      className="inline-flex items-center gap-1 bg-white/15 border border-white/25 text-white text-[10px] font-bold px-2 py-0.5 rounded-full"
                    >
                      <span className="text-white/80">
                        {CHANNEL_ICONS[channel.id] || "•"}
                      </span>
                      {channel.label}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
          {ALL_NETWORKS.map((net) => {
            const m = NETWORK_META[net];
            const account = connectedMap.get(net);
            if (account) {
              const onlyScheduling = ONLY_SCHEDULING_NETS.includes(net);
              return (
                <div
                  key={net}
                  className="relative flex flex-col justify-between rounded-2xl p-5 overflow-hidden shadow-md"
                  style={{
                    background: `linear-gradient(145deg, ${m.color}ee, ${m.color}88)`,
                    minHeight: "200px",
                  }}
                >
                  {/* Top row: logo + gear/delete */}
                  <div className="relative z-10 flex items-start justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-2xl bg-white shadow-md flex items-center justify-center p-2 flex-shrink-0">
                        <NetworkLogo networkId={net} size={30} />
                      </div>
                      <div>
                        <p className="text-white font-bold text-sm leading-tight truncate max-w-[110px]">
                          {account.account_name}
                        </p>
                        {account.account_username && (
                          <p className="text-white/75 text-[11px] truncate">
                            @{account.account_username}
                          </p>
                        )}
                      </div>
                    </div>
                    <button
                      onClick={() =>
                        handleDisconnect(
                          account.id || account._id,
                          account.account_name,
                        )
                      }
                      disabled={deleting === (account.id || account._id)}
                      className="p-2 text-white/70 hover:text-white bg-white/10 hover:bg-white/25 rounded-xl transition-colors border border-white/20 flex-shrink-0"
                    >
                      {deleting === (account.id || account._id) ? (
                        <Spinner />
                      ) : (
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                        </svg>
                      )}
                    </button>
                  </div>

                  {/* Middle: stats placeholder / somente agendamento */}
                  <div className="relative z-10 mt-3">
                    {onlyScheduling ? (
                      <div className="inline-flex items-center gap-1.5 bg-black/20 border border-white/20 text-white/90 text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide">
                        <Ico e="📅" />Somente Agendamento
                      </div>
                    ) : (
                      <div className="inline-flex items-center gap-1.5 bg-white/20 border border-white/30 text-white text-[10px] font-bold px-2.5 py-1 rounded-full">
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-300 animate-pulse" />{" "}
                        Sincronizado
                      </div>
                    )}
                  </div>

                  {/* Bottom: channel modality chips */}
                  <div className="relative z-10 mt-3 flex flex-wrap gap-1">
                    {m.channels.map((ch) => (
                      <span
                        key={ch.id}
                        className="inline-flex items-center gap-1 bg-white/15 border border-white/25 text-white text-[10px] font-bold px-2 py-0.5 rounded-full"
                      >
                        <span className="text-white/80">
                          {CHANNEL_ICONS[ch.id]}
                        </span>
                        {ch.label}
                      </span>
                    ))}
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      )}
    </div>
  );
}

// ─── TAB: Brand Kit ────────────────────────────────────────────────────────────
function BrandKitTab({ api }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);
  const [analyzeUrl, setAnalyzeUrl] = useState("");
  const [state, setState] = useState({
    company_name: "",
    website: "",
    tagline: "",
    primary_color: "#2563EB",
    secondary_color: "#0EA5E9",
    accent_color: "#FF2D78",
    font: "poppins",
  });

  useEffect(() => {
    api
      .get("/nexohub/brand-kit")
      .then((r) => {
        if (r.data && r.data.id) setState((s) => ({ ...s, ...r.data }));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api]);

  const set = (key, value) => setState((s) => ({ ...s, [key]: value }));

  const handleAnalyze = async () => {
    const url = analyzeUrl.trim();
    if (!url) {
      toast.error("Cole o endereço do site.");
      return;
    }
    setAnalyzing(true);
    try {
      const r = await api.post("/nexohub/brand-kit/analyze", { url });
      if (r.data) {
        setState((s) => ({
          ...s,
          primary_color: r.data.primary_color || s.primary_color,
          secondary_color: r.data.secondary_color || s.secondary_color,
          accent_color: r.data.accent_color || s.accent_color,
          tagline: r.data.tagline || s.tagline,
          website: r.data.website || s.website,
        }));
        toast.success("Site analisado! Revise as cores e salve.");
      }
    } catch {
      toast.error("Não foi possível analisar o site.");
    }
    setAnalyzing(false);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.post("/nexohub/brand-kit", state);
      toast.success("Brand Kit salvo! ");
    } catch {
      toast.error("Erro ao salvar.");
    }
    setSaving(false);
  };

  const ColorField = ({ label, field }) => {
    const safeColor = /^#([0-9a-fA-F]{6})$/.test(state[field])
      ? state[field]
      : "#000000";
    return (
      <div className="flex flex-col gap-1.5">
        <span className="text-xs font-bold text-gray-500 uppercase tracking-wider">
          {label}
        </span>
        <div className="flex items-center gap-2">
          <input
            type="color"
            value={safeColor}
            onChange={(e) => set(field, e.target.value)}
            className="h-10 w-12 rounded-lg border border-gray-200 cursor-pointer p-1 bg-white flex-shrink-0"
          />
          <input
            type="text"
            maxLength={7}
            placeholder="#RRGGBB"
            value={state[field]}
            onChange={(e) => set(field, e.target.value)}
            className="flex-1 text-sm border border-gray-200 rounded-lg px-3 py-2 font-mono uppercase bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
    );
  };

  if (loading)
    return (
      <div className="py-12 text-center">
        <Spinner />
      </div>
    );

  return (
    <div className="space-y-5 max-w-2xl">
      {/* Analisar site */}
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl border border-blue-200 p-5">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-lg"><Ico e="🔮" bare /></span>
          <h3 className="text-sm font-bold text-blue-700">
            Analisar Site do Cliente
          </h3>
        </div>
        <p className="text-xs text-gray-500 mb-3">
          A IA extrai cores e slogan automaticamente.
        </p>
        <div className="flex gap-2">
          <input
            value={analyzeUrl}
            onChange={(e) => setAnalyzeUrl(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleAnalyze()}
            placeholder="https://sitedocliente.com.br"
            className="flex-1 text-sm border border-blue-200 rounded-lg px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={handleAnalyze}
            disabled={analyzing}
            className="px-4 py-2 bg-blue-600 text-white text-sm font-bold rounded-lg hover:bg-blue-700 disabled:opacity-60 flex items-center gap-2 flex-shrink-0"
          >
            {analyzing ? <Spinner /> : <><Ico e="🔮" /></>} Analisar
          </button>
        </div>
      </div>

      {/* Identidade */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5 ">
        <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wide">
          <Ico e="🏷" />Identidade da Marca
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1.5">
              Nome da empresa
            </label>
            <input
              value={state.company_name || ""}
              onChange={(e) => set("company_name", e.target.value)}
              placeholder="NexoSynX CRM"
              className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1.5">
              Website
            </label>
            <input
              value={state.website || ""}
              onChange={(e) => set("website", e.target.value)}
              placeholder="seusite.com.br"
              className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div>
          <label className="text-xs font-bold text-gray-500 uppercase tracking-wide block mb-1.5">
            Slogan / Tagline
          </label>
          <input
            value={state.tagline || ""}
            onChange={(e) => set("tagline", e.target.value)}
            maxLength={120}
            placeholder="Sua frase de marca"
            className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Paleta */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5 ">
        <div className="flex items-center justify-between">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wide">
            <Ico e="🎨" />Paleta de Cores
          </h3>
          <div className="flex gap-1.5">
            {["primary_color", "secondary_color", "accent_color"].map((f) => (
              <div
                key={f}
                className="w-6 h-6 rounded-full border-2 border-white shadow-sm"
                style={{ background: state[f] }}
              />
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <ColorField label="Cor primária" field="primary_color" />
          <ColorField label="Cor secundária" field="secondary_color" />
          <ColorField label="Destaque" field="accent_color" />
        </div>
      </div>

      {/* Fonte */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wide mb-3">
          <Ico e="✍" />Fonte da Marca
        </h3>
        <select
          value={state.font || "poppins"}
          onChange={(e) => set("font", e.target.value)}
          className="w-full text-sm border border-gray-200 rounded-lg px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="poppins">Poppins — moderna e limpa</option>
          <option value="anton">Anton — impacto e manchete</option>
          <option value="inter">Inter — minimalista técnica</option>
          <option value="montserrat">Montserrat — elegante corporativa</option>
        </select>
      </div>

      {/* Preview */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wide mb-3">
          <Ico e="👁" />Preview
        </h3>
        <div className="rounded-xl overflow-hidden border border-gray-100">
          <div
            className="h-16 flex items-center justify-center"
            style={{ background: state.primary_color }}
          >
            <span className="text-white font-bold text-xl">
              {state.company_name || "Sua Marca"}
            </span>
          </div>
          <div className="p-4 flex gap-2 flex-wrap">
            <span
              className="px-3 py-1 rounded-full text-xs text-white font-bold"
              style={{ background: state.primary_color }}
            >
              Primária
            </span>
            <span
              className="px-3 py-1 rounded-full text-xs text-white font-bold"
              style={{ background: state.secondary_color }}
            >
              Secundária
            </span>
            <span
              className="px-3 py-1 rounded-full text-xs text-white font-bold"
              style={{ background: state.accent_color }}
            >
              Destaque
            </span>
          </div>
          {state.tagline && (
            <p className="px-4 pb-4 text-sm text-gray-500 italic">
              "{state.tagline}"
            </p>
          )}
        </div>
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        className="w-full py-3.5 bg-blue-600 text-white font-bold rounded-2xl hover:bg-blue-700 disabled:opacity-60 flex items-center justify-center gap-2 transition-colors"
      >
        {saving ? <Spinner /> : <><Ico e="✨" /></>} Salvar Brand Kit
      </button>
    </div>
  );
}

// ─── TAB: Biblioteca (Hashtags + Assinaturas) ─────────────────────────────────
function BibliotecaTab({ api }) {
  const [section, setSection] = useState("hashtags");
  const [hashtags, setHashtags] = useState([]);
  const [signatures, setSignatures] = useState([]);
  const [sounds, setSounds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editItem, setEditItem] = useState(null);
  const [formName, setFormName] = useState("");
  const [formContent, setFormContent] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [playingId, setPlayingId] = useState(null);
  const audioRef = useRef(null);

  const load = useCallback(() => {
    setLoading(true);
    Promise.all([
      api.get("/nexohub/hashtag-sets").then((r) => setHashtags(r.data || [])),
      api.get("/nexohub/signatures").then((r) => setSignatures(r.data || [])),
      api.get("/nexohub/sounds").then((r) => setSounds(r.data || [])),
    ])
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api]);

  useEffect(() => {
    load();
  }, [load]);

  const items =
    section === "hashtags"
      ? hashtags
      : section === "signatures"
        ? signatures
        : sounds;
  const endpoint =
    section === "hashtags" ? "/nexohub/hashtag-sets" : "/nexohub/signatures";

  const getAudioUrl = (sound) => getSoundStreamUrl(api, sound);

  const handleDownloadSound = async (sound) => {
    try {
      await downloadSoundAsset(api, sound);
    } catch (e) {
      toast.error(e?.message || "Erro ao baixar áudio.");
    }
  };

  const togglePlay = (sound) => {
    if (playingId === sound.id) {
      audioRef.current?.pause();
      setPlayingId(null);
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
      }
      const a = new Audio(getAudioUrl(sound));
      audioRef.current = a;
      a.play().catch(() => toast.error("Erro ao reproduzir áudio."));
      setPlayingId(sound.id);
      a.onended = () => setPlayingId(null);
    }
  };

  const openCreate = () => {
    setEditItem(null);
    setFormName("");
    setFormContent("");
    setShowForm(true);
  };
  const openEdit = (item) => {
    setEditItem(item);
    setFormName(item.name);
    setFormContent(item.content);
    setShowForm(true);
  };
  const closeForm = () => {
    setShowForm(false);
    setEditItem(null);
  };

  const handleSave = async () => {
    if (!formName.trim() || !formContent.trim()) {
      toast.error("Preencha nome e conteúdo.");
      return;
    }
    setSaving(true);
    try {
      if (editItem)
        await api.put(`${endpoint}/${editItem.id}`, {
          name: formName.trim(),
          content: formContent.trim(),
        });
      else
        await api.post(endpoint, {
          name: formName.trim(),
          content: formContent.trim(),
        });
      toast.success(editItem ? "Atualizado!" : "Salvo!");
      load();
      closeForm();
    } catch {
      toast.error("Erro ao salvar.");
    }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Excluir este item?")) return;
    setDeleting(id);
    try {
      if (section === "sons") {
        await api.delete(`/nexohub/sounds/${id}`);
        setSounds((s) => s.filter((x) => x.id !== id));
      } else {
        await api.delete(`${endpoint}/${id}`);
        load();
      }
      toast.success("Removido.");
    } catch {
      toast.error("Erro ao remover.");
    }
    setDeleting(null);
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex bg-gray-100 p-1 rounded-xl gap-1">
          {[
            { id: "hashtags", label: "# Hashtag Sets" },
            { id: "signatures", label: <><Ico e="✍" />Assinaturas</> },
            { id: "sons", label: <><Ico e="🎵" />Sons</> },
          ].map((s) => (
            <button
              key={s.id}
              onClick={() => {
                setSection(s.id);
                setShowForm(false);
              }}
              className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all ${section === s.id ? "bg-white text-blue-600 shadow-sm" : "text-gray-500 hover:text-gray-700"}`}
            >
              {s.label}
            </button>
          ))}
        </div>
        {section !== "sons" && (
          <button
            onClick={openCreate}
            className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors"
          >
            + {section === "hashtags" ? "Novo Set" : "Nova Assinatura"}
          </button>
        )}
      </div>

      {showForm && (
        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-5 space-y-3">
          <p className="text-sm font-bold text-blue-700">
            {editItem ? "Editar" : "Novo"}{" "}
            {section === "hashtags" ? "Conjunto de Hashtags" : "Assinatura"}
          </p>
          <input
            value={formName}
            onChange={(e) => setFormName(e.target.value)}
            placeholder={
              section === "hashtags"
                ? "Ex.: Café especial"
                : "Ex.: Assinatura padrão"
            }
            className="w-full text-sm border border-blue-200 rounded-lg px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <textarea
            value={formContent}
            onChange={(e) => setFormContent(e.target.value)}
            placeholder={
              section === "hashtags"
                ? "#cafe #especial #sustentavel"
                : "— Equipe NexoSynX 🚀"
            }
            className="w-full text-sm border border-blue-200 rounded-lg px-3 py-3 bg-white min-h-[80px] resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <div className="flex gap-2">
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-4 py-2 bg-blue-600 text-white text-sm font-bold rounded-lg hover:bg-blue-700 disabled:opacity-60 flex items-center gap-2"
            >
              {saving && <Spinner />}{" "}
              {editItem ? "Salvar alterações" : "Adicionar"}
            </button>
            <button
              onClick={closeForm}
              className="px-4 py-2 text-gray-500 text-sm hover:text-gray-700"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {loading ? (
        <div className="py-12 text-center">
          <Spinner />
        </div>
      ) : items.length === 0 ? (
        <div className="py-16 text-center">
          <p className="text-3xl mb-3">
            {section === "hashtags" ? "#️⃣" : section === "sons" ? <><Ico e="🎵" /></> : <><Ico e="✍" /></>}
          </p>
          <p className="text-gray-500 mb-4">
            {section === "sons"
              ? "Nenhum jingle gerado ainda."
              : "Nenhum item salvo ainda."}
          </p>
          {section !== "sons" && (
            <button
              onClick={openCreate}
              className="px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700"
            >
              Criar primeiro
            </button>
          )}
          {section === "sons" && (
            <p className="text-xs text-gray-400">
              Vá em "Sounds" para gerar jingles com IA
            </p>
          )}
        </div>
      ) : section === "sons" ? (
        <div className="space-y-3">
          {sounds.map((s) => (
            <div
              key={s.id}
              className={`rounded-2xl border p-4 transition-all ${playingId === s.id ? "border-violet-300 bg-violet-50" : "bg-white border-gray-100 hover:shadow-md"}`}
            >
              <div className="flex items-center gap-3">
                <button
                  onClick={() => togglePlay(s)}
                  className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${playingId === s.id ? "bg-violet-600 text-white shadow-md" : "bg-violet-50 border border-violet-200 text-violet-600 hover:bg-violet-100"}`}
                >
                  {playingId === s.id ? <><Ico e="⏸" /></> : "▶"}
                </button>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-gray-800 truncate">
                    {s.name || "Jingle"}
                  </p>
                  <p className="text-xs text-gray-400 truncate">{s.prompt}</p>
                  <div className="flex gap-2 mt-1">
                    <span className="text-[10px] font-bold text-violet-600 bg-violet-100 px-2 py-0.5 rounded-full">
                      {s.duration}s
                    </span>
                    {s.instrumental && (
                      <span className="text-[10px] font-semibold text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
                        Instrumental
                      </span>
                    )}
                    {s.campaign_id && (
                      <span className="text-[10px] font-semibold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full">
                        Campanha
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex gap-1 flex-shrink-0 items-center">
                  <button
                    onClick={() => handleDownloadSound(s)}
                    className="p-2 text-gray-400 hover:text-blue-600 transition-colors text-lg leading-none"
                    title="Download"
                  >
                    ↓
                  </button>
                  <button
                    onClick={() => handleDelete(s.id)}
                    disabled={deleting === s.id}
                    className="p-2 text-gray-400 hover:text-red-500 transition-colors"
                  >
                    {deleting === s.id ? <Spinner /> : <><Ico e="🗑" /></>}
                  </button>
                </div>
              </div>
              {playingId === s.id && (
                <div className="mt-2 flex items-center gap-2 pl-12">
                  <div className="flex gap-0.5 items-end h-4">
                    {[...Array(10)].map((_, i) => (
                      <div
                        key={i}
                        className="w-1 bg-violet-500 rounded-full animate-pulse"
                        style={{
                          height: `${25 + Math.sin(i * 0.7) * 50}%`,
                          animationDelay: `${i * 0.08}s`,
                        }}
                      />
                    ))}
                  </div>
                  <span className="text-xs text-violet-600 font-semibold">
                    Reproduzindo...
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow flex items-start gap-4"
            >
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-800 mb-1">{item.name}</p>
                <p className="text-sm text-gray-500 break-words whitespace-pre-wrap line-clamp-3">
                  {item.content}
                </p>
              </div>
              <div className="flex gap-1 flex-shrink-0">
                <button
                  onClick={() => openEdit(item)}
                  className="p-2 text-gray-400 hover:text-blue-600 transition-colors"
                >
                  <Ico e="✏" bare />
                </button>
                <button
                  onClick={() => handleDelete(item.id)}
                  disabled={deleting === item.id}
                  className="p-2 text-gray-400 hover:text-red-500 transition-colors"
                >
                  {deleting === item.id ? <Spinner /> : <><Ico e="🗑" /></>}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── TAB: Vídeo IA ─────────────────────────────────────────────────────────────
const VIDEO_STYLES = [
  { id: "cinematic", label: "Cinematográfico" },
  { id: "dynamic", label: "Dinâmico / Rápido" },
  { id: "minimal", label: "Minimalista" },
  { id: "luxury", label: "Luxo / Premium" },
  { id: "vibrant", label: "Vibrante / Colorido" },
];

const VIDEO_NETWORKS = [
  { id: "instagram", label: "Instagram Reels", aspect: "9:16" },
  // { id: "youtube_shorts", label: "YouTube Shorts", aspect: "9:16" },
  // { id: "youtube", label: "YouTube", aspect: "16:9" },
  { id: "linkedin", label: "LinkedIn", aspect: "16:9" },
  { id: "facebook", label: "Facebook", aspect: "16:9" },
];

function VideoStatusBadge({ status }) {
  const map = {
    generating: {
      bg: "bg-amber-50",
      text: "text-amber-700",
      border: "border-amber-200",
      label: <><Ico e="⏳" />Gerando...</>,
    },
    ready: {
      bg: "bg-green-50",
      text: "text-green-700",
      border: "border-green-200",
      label: <><Ico e="✅" />Pronto</>,
    },
    failed: {
      bg: "bg-red-50",
      text: "text-red-700",
      border: "border-red-200",
      label: <><Ico e="❌" />Falhou</>,
    },
  };
  const s = map[status] || map.failed;
  return (
    <span
      className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full border ${s.bg} ${s.text} ${s.border}`}
    >
      {s.label}
    </span>
  );
}

function VideoCard({ video, api, onReady }) {
  const [status, setStatus] = useState(video.status || "generating");
  const [videoUrl, setVideoUrl] = useState(video.video_url || null);
  const [visualPrompt, setVisualPrompt] = useState(video.visual_prompt || null);
  const [showPrompt, setShowPrompt] = useState(false);
  const pollingRef = useRef(null);
  const id = video.id || video._id;

  useEffect(() => {
    if (status === "generating" && id) {
      pollingRef.current = setInterval(async () => {
        try {
          const r = await api.get(`/nexohub/videos/${id}`);
          const d = r.data;
          if (d.status !== "generating") {
            setStatus(d.status);
            if (d.video_url) {
              setVideoUrl(d.video_url);
              onReady && onReady();
            }
            clearInterval(pollingRef.current);
          }
        } catch {}
      }, 6000);
    }
    return () => clearInterval(pollingRef.current);
  }, [id, status]);

  const aspect =
    video.aspect_ratio === "16:9" ? "aspect-video" : "aspect-[9/16]";

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
      {/* Video / placeholder */}
      <div
        className={`w-full ${status === "ready" ? "" : "bg-gradient-to-br from-purple-900 to-blue-900"} flex items-center justify-center relative`}
        style={status === "ready" ? {} : { minHeight: "200px" }}
      >
        {status === "ready" && videoUrl ? (
          <video
            src={videoUrl}
            controls
            loop
            playsInline
            className="w-full max-h-[360px] object-contain bg-black"
          />
        ) : status === "generating" ? (
          <div className="flex flex-col items-center gap-3 py-10 px-6 text-white">
            <div className="w-12 h-12 rounded-full border-4 border-purple-300 border-t-white animate-spin" />
            <p className="text-sm font-semibold">Gerando vídeo com IA...</p>
            <p className="text-xs text-purple-300 text-center">
              Wan2.1 está renderizando seus frames. Pode levar 1–3 min.
            </p>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-2 py-10 text-white/60">
            <span className="text-4xl"><Ico e="❌" bare /></span>
            <p className="text-sm">Geração falhou</p>
          </div>
        )}
      </div>

      {/* Info */}
      <div className="p-4 space-y-2">
        <div className="flex items-start justify-between gap-2">
          <p className="font-semibold text-gray-800 text-sm leading-snug line-clamp-2 flex-1">
            {video.title || video.prompt || "Vídeo"}
          </p>
          <VideoStatusBadge status={status} />
        </div>

        <div className="flex items-center gap-3 text-xs text-gray-400">
          {video.network && (
            <span className="flex items-center gap-1">
              <NetworkLogo
                networkId={
                  video.network === "youtube_shorts" ? "youtube" : video.network
                }
                size={12}
              />
              {VIDEO_NETWORKS.find((n) => n.id === video.network)?.label ||
                video.network}
            </span>
          )}
          {video.aspect_ratio && (
            <span className="font-mono bg-gray-100 px-1.5 py-0.5 rounded">
              {video.aspect_ratio}
            </span>
          )}
        </div>

        {visualPrompt && (
          <div>
            <button
              onClick={() => setShowPrompt((s) => !s)}
              className="text-xs text-purple-500 hover:text-purple-700 font-semibold flex items-center gap-1"
            >
              {showPrompt ? "▲" : "▼"} Prompt visual gerado pela IA
            </button>
            {showPrompt && (
              <p className="text-xs text-gray-500 mt-1.5 bg-gray-50 rounded-lg px-3 py-2 leading-relaxed border border-gray-100 italic">
                {visualPrompt}
              </p>
            )}
          </div>
        )}

        {status === "ready" && videoUrl && (
          <a
            href={videoUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-800"
          >
            <svg
              className="w-3.5 h-3.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            Download MP4
          </a>
        )}
      </div>
    </div>
  );
}

function VideoIATab({ api }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [prompt, setPrompt] = useState("");
  const [network, setNetwork] = useState("instagram");
  const [style, setStyle] = useState("cinematic");
  const [generating, setGenerating] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const load = useCallback(() => {
    api
      .get("/nexohub/videos")
      .then((r) =>
        setVideos(
          (r.data || []).filter(
            (v) =>
              v.fal_model ||
              v.status === "generating" ||
              v.status === "ready" ||
              v.video_url,
          ),
        ),
      )
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api]);

  useEffect(() => {
    load();
  }, [load]);

  const handleGenerate = async () => {
    if (!prompt.trim()) {
      toast.error("Descreva o vídeo que deseja gerar.");
      return;
    }
    setGenerating(true);
    try {
      const r = await api.post("/nexohub/ai/video-fal", {
        prompt: prompt.trim(),
        network,
        style,
      });
      toast.success("Motor de vídeo ativado! Renderizando com Wan2.1… ");
      setPrompt("");
      setShowForm(false);
      // Prepend the new video optimistically
      setVideos((prev) => [
        {
          id: r.data.id,
          title: prompt.trim().slice(0, 70),
          prompt: prompt.trim(),
          visual_prompt: r.data.visual_prompt,
          network,
          aspect_ratio:
            VIDEO_NETWORKS.find((n) => n.id === network)?.aspect || "9:16",
          style,
          status: "generating",
          fal_model: "fal-ai/wan/v2/t2v-480p",
          created_at: new Date().toISOString(),
        },
        ...prev,
      ]);
    } catch (e) {
      const msg =
        e?.response?.data?.detail || "Erro ao iniciar geração de vídeo.";
      toast.error(msg);
    }
    setGenerating(false);
  };

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 bg-purple-100 text-purple-700 text-xs font-bold px-3 py-1 rounded-full mb-3">
            <span>✦</span> Powered by Wan2.1 · fal.ai
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Vídeo com IA</h2>
          <p className="text-sm text-gray-400 mt-1">
            Gere vídeos reais para redes sociais em 1–3 minutos.
          </p>
        </div>
        <button
          onClick={() => setShowForm((s) => !s)}
          className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-purple-600 to-blue-500 text-white text-sm font-bold rounded-xl hover:opacity-90 shadow-md flex-shrink-0"
        >
          <Ico e="🎬" />Novo Vídeo
        </button>
      </div>

      {/* Form */}
      {showForm && (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 ">
          <h3 className="font-bold text-gray-800 text-sm">
            <Ico e="✨" />Configurar Geração de Vídeo
          </h3>

          {/* Prompt */}
          <div>
            <label className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1.5">
              Brief do vídeo <span className="text-red-400">*</span>
            </label>
            <textarea
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder="Ex.: Vídeo de lançamento de tênis esportivo. Movimento rápido, paleta azul e laranja, energia jovem. Mostrar produto em close e em uso."
              className="w-full text-sm border border-gray-200 rounded-xl px-4 py-3 bg-gray-50 min-h-[100px] resize-none focus:outline-none focus:ring-2 focus:ring-purple-400"
            />
          </div>

          {/* Network + Style */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1.5">
                Rede Social
              </label>
              <select
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
                className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-400"
              >
                {VIDEO_NETWORKS.map((n) => (
                  <option key={n.id} value={n.id}>
                    {n.label} ({n.aspect})
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1.5">
                Estilo Visual
              </label>
              <select
                value={style}
                onChange={(e) => setStyle(e.target.value)}
                className="w-full text-sm border border-gray-200 rounded-xl px-3 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-400"
              >
                {VIDEO_STYLES.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Cost note */}
          <div className="flex items-start gap-2 bg-blue-50 border border-blue-100 rounded-xl px-4 py-3">
            <span className="text-blue-400 text-base flex-shrink-0">ℹ️</span>
            <p className="text-xs text-blue-700">
              Cada vídeo custa ~$0.04–0.08 na sua conta fal.ai (Wan2.1 · 480p ·
              5s). A IA converte seu brief em prompt visual em inglês
              automaticamente.
            </p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={handleGenerate}
              disabled={generating || !prompt.trim()}
              className="flex-1 py-3 bg-gradient-to-r from-purple-600 to-blue-500 text-white font-bold rounded-xl hover:opacity-90 disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {generating ? (
                <>
                  <Spinner /> Enviando para fal.ai...
                </>
              ) : (
                <><Ico e="🎬" />Gerar Vídeo Real</>
              )}
            </button>
            <button
              onClick={() => setShowForm(false)}
              className="px-4 py-3 border border-gray-200 rounded-xl text-sm text-gray-500 hover:bg-gray-50"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Video list */}
      {loading ? (
        <div className="py-16 text-center">
          <Spinner />
        </div>
      ) : videos.length === 0 ? (
        <div className="py-20 text-center bg-white rounded-2xl border border-gray-100">
          <div className="w-16 h-16 bg-purple-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl"><Ico e="🎬" bare /></span>
          </div>
          <p className="font-bold text-gray-700 mb-1">
            Nenhum vídeo gerado ainda
          </p>
          <p className="text-sm text-gray-400 mb-5">
            Crie seu primeiro vídeo real com IA generativa.
          </p>
          <button
            onClick={() => setShowForm(true)}
            className="px-5 py-2.5 bg-gradient-to-r from-purple-600 to-blue-500 text-white text-sm font-bold rounded-xl hover:opacity-90 shadow-md"
          >
            <Ico e="🎬" />Criar Primeiro Vídeo
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {videos.map((v) => (
            <VideoCard
              key={v.id || v._id}
              video={v}
              api={api}
              onReady={() => toast.success("Vídeo pronto!")}
            />
          ))}
        </div>
      )}
    </div>
  );
}

// ─── TAB: Sounds (Gerador de Jingles) ─────────────────────────────────────────
const PTBR_VOICES = [
  { id: "pt-BR-FranciscaNeural", label: "Francisca — Feminina, calorosa" },
  { id: "pt-BR-AntonioNeural", label: "Antônio — Masculino, profissional" },
  { id: "pt-BR-ThalitaNeural", label: "Thalita — Feminina, jovem" },
  { id: "pt-BR-DonatoNeural", label: "Donato — Masculino, grave" },
];

function SoundsTab({ api }) {
  const [sounds, setSounds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [playingId, setPlayingId] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [mode, setMode] = useState("jingle"); // 'jingle' | 'narration'
  const audioRef = useRef(null);

  const [form, setForm] = useState({
    name: "",
    prompt: "",
    duration: 30,
    instrumental: true,
  });
  const setF = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const [narForm, setNarForm] = useState({
    name: "",
    text: "",
    voice: "pt-BR-FranciscaNeural",
    music_id: "",
    music_volume: 0.3,
  });
  const setNF = (k, v) => setNarForm((f) => ({ ...f, [k]: v }));

  const [improvingScript, setImprovingScript] = useState(false);
  const [showImprovePicker, setShowImprovePicker] = useState(false);
  const IMPROVE_DURATIONS = [15, 30, 60, 90];

  const improveScript = async (durationSeconds) => {
    if (!narForm.text.trim()) {
      toast.error("Escreva o texto antes de melhorar.");
      return;
    }
    setShowImprovePicker(false);
    setImprovingScript(true);
    try {
      const r = await api.post("/nexohub/sounds/improve-script", {
        text: narForm.text,
        duration_seconds: durationSeconds,
      });
      setNF("text", r.data.improved_text);
      toast.success(`Roteiro reescrito para ~${durationSeconds}s!`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao melhorar roteiro.");
    }
    setImprovingScript(false);
  };

  const load = useCallback(() => {
    setLoading(true);
    api
      .get("/nexohub/sounds")
      .then((r) => setSounds(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api]);

  useEffect(() => {
    load();
  }, [load]);

  const generate = async () => {
    if (!form.prompt.trim()) {
      toast.error("Descreva o estilo musical do jingle.");
      return;
    }
    setGenerating(true);
    try {
      const r = await api.post("/nexohub/sounds/generate", form);
      toast.success("Jingle gerado com sucesso!");
      setSounds((s) => [r.data, ...s]);
      setForm((f) => ({ ...f, name: "", prompt: "" }));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao gerar jingle.");
    }
    setGenerating(false);
  };

  const generateNarration = async () => {
    if (!narForm.text.trim()) {
      toast.error("Digite o texto da narração.");
      return;
    }
    setGenerating(true);
    try {
      const payload = {
        name: narForm.name || "Narração PT-BR",
        text: narForm.text,
        voice: narForm.voice,
        music_id: narForm.music_id || null,
        music_volume: narForm.music_volume,
      };
      const r = await api.post("/nexohub/sounds/narration", payload);
      toast.success(
        "🎙 Narração gerada" +
          (narForm.music_id ? " e mixada com a música!" : "!"),
      );
      setSounds((s) => [r.data, ...s]);
      setNarForm((f) => ({ ...f, name: "", text: "" }));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao gerar narração.");
    }
    setGenerating(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Excluir este jingle?")) return;
    setDeleting(id);
    try {
      await api.delete(`/nexohub/sounds/${id}`);
      toast.success("Removido.");
      setSounds((s) => s.filter((x) => x.id !== id));
    } catch {
      toast.error("Erro ao remover.");
    }
    setDeleting(null);
  };

  const getAudioUrl = (sound) => getSoundStreamUrl(api, sound);

  const handleDownloadSound = async (sound) => {
    try {
      await downloadSoundAsset(api, sound);
    } catch (e) {
      toast.error(e?.message || "Erro ao baixar áudio.");
    }
  };

  const togglePlay = (sound) => {
    if (playingId === sound.id) {
      audioRef.current?.pause();
      setPlayingId(null);
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
      }
      const a = new Audio(getAudioUrl(sound));
      audioRef.current = a;
      a.play().catch(() => toast.error("Erro ao reproduzir áudio."));
      setPlayingId(sound.id);
      a.onended = () => setPlayingId(null);
    }
  };

  const DURATIONS = [15, 30, 60];

  const jingleSounds = sounds.filter((s) => s.type !== "narration");

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-violet-600 to-pink-500 rounded-xl flex items-center justify-center shadow-md flex-shrink-0">
            <span className="text-white text-lg">
              {mode === "jingle" ? <><Ico e="🎵" /></> : <><Ico e="🎙" /></>}
            </span>
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">
              {mode === "jingle"
                ? "Gerador de Jingles"
                : "Narração em Português"}
            </h2>
            <p className="text-xs text-gray-400">
              {mode === "jingle"
                ? "IA gera músicas exclusivas para suas campanhas"
                : "Voz PT-BR natural + mix automático com a música"}
            </p>
          </div>
        </div>
        {/* Mode switcher */}
        <div className="flex bg-gray-100 rounded-xl p-1 gap-1">
          <button
            onClick={() => setMode("jingle")}
            className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all ${mode === "jingle" ? "bg-white shadow text-violet-700" : "text-gray-500 hover:text-gray-700"}`}
          >
            <Ico e="🎵" />Jingle
          </button>
          <button
            onClick={() => setMode("narration")}
            className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all ${mode === "narration" ? "bg-white shadow text-violet-700" : "text-gray-500 hover:text-gray-700"}`}
          >
            <Ico e="🎙" />Narração
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-6 items-start">
        {/* ── Formulário */}
        <div className="">
          {mode === "jingle" ? (
            <>
              <div className="bg-white rounded-2xl border border-gray-100 p-5 ">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">
                  Identifique o Jingle
                </p>
                <div>
                  <label className="text-xs font-semibold text-gray-500 block mb-1.5">
                    Nome do jingle
                  </label>
                  <input
                    value={form.name}
                    onChange={(e) => setF("name", e.target.value)}
                    placeholder="Ex.: Jingle Verão 2026"
                    className="w-full text-sm border border-gray-200 rounded-xl px-4 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-violet-400"
                  />
                </div>
              </div>

              <div className="bg-white rounded-2xl border border-gray-100 p-5 ">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">
                  Estilo Musical
                </p>
                <div>
                  <label className="text-xs font-semibold text-gray-500 block mb-1.5">
                    Descreva o ritmo e clima
                  </label>
                  <textarea
                    value={form.prompt}
                    onChange={(e) => setF("prompt", e.target.value)}
                    rows={4}
                    placeholder="Ex.: Jingle animado estilo bossa nova para campanha de verão de academia, ritmo acelerado, piano e percussão, clima motivacional e energético..."
                    className="w-full text-sm border border-gray-200 rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-violet-400 resize-none"
                  />
                </div>

                <div>
                  <label className="text-xs font-semibold text-gray-500 block mb-2">
                    Duração
                  </label>
                  <div className="flex gap-2">
                    {DURATIONS.map((d) => (
                      <button
                        key={d}
                        onClick={() => setF("duration", d)}
                        className={`flex-1 py-2.5 rounded-xl text-sm font-bold border-2 transition-all ${form.duration === d ? "border-violet-500 bg-violet-50 text-violet-700" : "border-gray-200 bg-white text-gray-500 hover:border-gray-300"}`}
                      >
                        {d}s
                      </button>
                    ))}
                  </div>
                </div>

                <div className="flex items-center gap-2 py-2 border-t border-gray-100 text-xs text-gray-400">
                  <span className="text-green-500 font-bold">✓</span>
                  Sempre instrumental — use a aba{" "}
                  <strong className="text-gray-600"><Ico e="🎙" />Narração</strong> para
                  adicionar voz em PT-BR
                </div>
              </div>

              <button
                onClick={generate}
                disabled={generating || !form.prompt.trim()}
                className="w-full py-3.5 bg-gradient-to-r from-violet-600 to-pink-500 text-white font-bold text-sm rounded-xl hover:opacity-90 transition-all shadow-md flex items-center justify-center gap-2 disabled:opacity-60"
              >
                {generating ? (
                  <>
                    <Spinner /> Gerando jingle... aguarde ~30s
                  </>
                ) : (
                  <>
                    <span><Ico e="🎵" bare /></span> Gerar Jingle com IA
                  </>
                )}
              </button>
            </>
          ) : (
            <>
              {/* ── Narração Form */}
              <div className="bg-white rounded-2xl border border-gray-100 p-5 ">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">
                  Narração em Português
                </p>

                <div>
                  <label className="text-xs font-semibold text-gray-500 block mb-1.5">
                    Nome / Título
                  </label>
                  <input
                    value={narForm.name}
                    onChange={(e) => setNF("name", e.target.value)}
                    placeholder="Ex.: Narração Campanha Verão"
                    className="w-full text-sm border border-gray-200 rounded-xl px-4 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-violet-400"
                  />
                </div>

                <div>
                  <div className="flex items-center justify-between mb-1.5">
                    <label className="text-xs font-semibold text-gray-500">
                      Texto da narração (PT-BR)
                    </label>
                    <div className="relative">
                      <button
                        onClick={() => setShowImprovePicker((v) => !v)}
                        disabled={improvingScript || !narForm.text.trim()}
                        className="flex items-center gap-1 px-3 py-1 text-xs font-semibold text-violet-700 bg-violet-50 border border-violet-200 rounded-lg hover:bg-violet-100 transition-all disabled:opacity-40 disabled:cursor-not-allowed"
                      >
                        {improvingScript ? (
                          <>
                            <Spinner /> Melhorando...
                          </>
                        ) : (
                          <>
                            <span><Ico e="✨" bare /></span> Melhorar com IA
                          </>
                        )}
                      </button>
                      {showImprovePicker && (
                        <div className="absolute right-0 top-8 z-20 bg-white border border-violet-200 rounded-xl shadow-xl p-3 w-52">
                          <p className="text-xs font-bold text-gray-600 mb-2">
                            Duração da narração:
                          </p>
                          <div className="grid grid-cols-2 gap-2">
                            {IMPROVE_DURATIONS.map((d) => (
                              <button
                                key={d}
                                onClick={() => improveScript(d)}
                                className="py-2 rounded-lg text-xs font-bold border-2 border-violet-200 text-violet-700 hover:bg-violet-50 hover:border-violet-400 transition-all"
                              >
                                {d}s
                              </button>
                            ))}
                          </div>
                          <button
                            onClick={() => setShowImprovePicker(false)}
                            className="w-full mt-2 text-xs text-gray-400 hover:text-gray-600 py-1"
                          >
                            Cancelar
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <textarea
                    value={narForm.text}
                    onChange={(e) => setNF("text", e.target.value)}
                    rows={5}
                    placeholder="Ex.: Place Logistics — a empresa que cuida da sua carga como se fosse nossa. Atendimento 24 horas, entregas no prazo e segurança garantida. Ligue agora e solicite seu orçamento!"
                    className="w-full text-sm border border-gray-200 rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-violet-400 resize-none"
                  />
                  <p className="text-xs text-gray-400 mt-1">
                    {narForm.text.length} caracteres
                  </p>
                </div>

                <div>
                  <label className="text-xs font-semibold text-gray-500 block mb-2">
                    Voz
                  </label>
                  <select
                    value={narForm.voice}
                    onChange={(e) => setNF("voice", e.target.value)}
                    className="w-full text-sm border border-gray-200 rounded-xl px-4 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-violet-400"
                  >
                    {PTBR_VOICES.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="bg-white rounded-2xl border border-gray-100 p-5 ">
                <div className="flex items-center gap-2">
                  <span className="text-lg"><Ico e="🎵" bare /></span>
                  <div>
                    <p className="text-sm font-semibold text-gray-700">
                      Misturar com música de fundo
                    </p>
                    <p className="text-xs text-gray-400">
                      Opcional — escolha um jingle da biblioteca
                    </p>
                  </div>
                </div>

                <select
                  value={narForm.music_id}
                  onChange={(e) => setNF("music_id", e.target.value)}
                  className="w-full text-sm border border-gray-200 rounded-xl px-4 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-violet-400"
                >
                  <option value="">Sem música de fundo</option>
                  {jingleSounds.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name || "Jingle"} ({s.duration}s)
                    </option>
                  ))}
                </select>

                {narForm.music_id && (
                  <div>
                    <label className="text-xs font-semibold text-gray-500 block mb-2">
                      Volume da música:{" "}
                      <span className="text-violet-600">
                        {Math.round(narForm.music_volume * 100)}%
                      </span>
                    </label>
                    <input
                      type="range"
                      min="0.1"
                      max="0.8"
                      step="0.05"
                      value={narForm.music_volume}
                      onChange={(e) =>
                        setNF("music_volume", parseFloat(e.target.value))
                      }
                      className="w-full accent-violet-600"
                    />
                    <div className="flex justify-between text-xs text-gray-400 mt-1">
                      <span>Mais suave</span>
                      <span>Mais alto</span>
                    </div>
                  </div>
                )}
              </div>

              <button
                onClick={generateNarration}
                disabled={generating || !narForm.text.trim()}
                className="w-full py-3.5 bg-gradient-to-r from-violet-600 to-pink-500 text-white font-bold text-sm rounded-xl hover:opacity-90 transition-all shadow-md flex items-center justify-center gap-2 disabled:opacity-60"
              >
                {generating ? (
                  <>
                    <Spinner /> Gerando narração
                    {narForm.music_id ? " + mix" : ""}...
                  </>
                ) : (
                  <>
                    <span><Ico e="🎙" bare /></span>{" "}
                    {narForm.music_id
                      ? "Gerar Narração + Mix com Música"
                      : "Gerar Narração em PT-BR"}
                  </>
                )}
              </button>
            </>
          )}
        </div>

        {/* ── Biblioteca de sons */}
        <div className="bg-white rounded-2xl border border-gray-100 p-5">
          <div className="flex items-center justify-between mb-4">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">
              <Ico e="🎧" />Biblioteca de Sons
            </p>
            <span className="text-xs text-gray-400">
              {sounds.length} jingle{sounds.length !== 1 ? "s" : ""}
            </span>
          </div>

          {loading ? (
            <div className="py-8 text-center">
              <Spinner />
            </div>
          ) : sounds.length === 0 ? (
            <div className="py-12 text-center">
              <p className="text-4xl mb-3"><Ico e="🎵" bare /></p>
              <p className="text-sm text-gray-400">
                Nenhum jingle gerado ainda.
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Descreva um estilo e clique em Gerar
              </p>
            </div>
          ) : (
            <div className="space-y-3 max-h-[520px] overflow-y-auto pr-1">
              {sounds.map((s) => (
                <div
                  key={s.id}
                  className={`rounded-xl border p-3 transition-all ${playingId === s.id ? "border-violet-300 bg-violet-50" : "border-gray-100 bg-gray-50 hover:border-gray-200"}`}
                >
                  <div className="flex items-start gap-2">
                    <button
                      onClick={() => togglePlay(s)}
                      className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${playingId === s.id ? "bg-violet-600 text-white shadow-md" : "bg-white border border-gray-200 text-gray-600 hover:bg-violet-50 hover:border-violet-300"}`}
                    >
                      {playingId === s.id ? <><Ico e="⏸" /></> : "▶"}
                    </button>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-gray-800 truncate">
                        {s.name || "Jingle"}
                      </p>
                      <p className="text-xs text-gray-400 truncate">
                        {s.prompt}
                      </p>
                      <div className="flex items-center gap-2 mt-1">
                        <span className="text-[10px] font-semibold text-violet-600 bg-violet-100 px-2 py-0.5 rounded-full">
                          {s.duration}s
                        </span>
                        {s.instrumental && (
                          <span className="text-[10px] font-semibold text-gray-500 bg-gray-200 px-2 py-0.5 rounded-full">
                            Instrumental
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex gap-1 flex-shrink-0">
                      <button
                        onClick={() => handleDownloadSound(s)}
                        className="p-1.5 text-gray-400 hover:text-blue-600 transition-colors text-sm"
                        title="Download"
                      >
                        ↓
                      </button>
                      <button
                        onClick={() => handleDelete(s.id)}
                        disabled={deleting === s.id}
                        className="p-1.5 text-gray-400 hover:text-red-500 transition-colors text-sm"
                      >
                        {deleting === s.id ? <Spinner /> : <><Ico e="🗑" /></>}
                      </button>
                    </div>
                  </div>
                  {playingId === s.id && (
                    <div className="mt-2 flex items-center gap-2 px-1">
                      <div className="flex gap-0.5 items-end h-4">
                        {[...Array(8)].map((_, i) => (
                          <div
                            key={i}
                            className="w-1 bg-violet-500 rounded-full animate-pulse"
                            style={{
                              height: `${30 + Math.sin(i * 0.8) * 40}%`,
                              animationDelay: `${i * 0.1}s`,
                            }}
                          />
                        ))}
                      </div>
                      <span className="text-xs text-violet-600 font-semibold">
                        Reproduzindo...
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── TAB: Criar com IA ────────────────────────────────────────────────────────
// ─── Gerador de Criativos (Pexels + Pillow) ────────────────────────────────
const FORMATOS = [
  { id: "feed", label: "Feed", icon: "▦", ratio: "1:1", size: "1080×1080" },
  {
    id: "stories",
    label: "Stories",
    icon: "▯",
    ratio: "9:16",
    size: "1080×1920",
  },
  { id: "reels", label: "Reels", icon: "▶", ratio: "9:16", size: "1080×1920" },
];

function SocialCreativeGenerator({ api, initialBk }) {
  const [brand, setBrand] = useState({
    brand_name: initialBk?.company_name || "",
    primary_color: initialBk?.primary_color || "#2563EB",
    briefing: "",
    formato: "feed",
    logo_base64: initialBk?.logo_base64 || null,
  });
  const [generating, setGenerating] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const logoRef = useRef(null);

  // Jingle state
  const [jingleEnabled, setJingleEnabled] = useState(false);
  const [jinglePrompt, setJinglePrompt] = useState("");
  const [jingleDuration, setJingleDuration] = useState(30);
  const [generatingJingle, setGeneratingJingle] = useState(false);
  const [jingleResult, setJingleResult] = useState(null);
  const [jinglePlaying, setJinglePlaying] = useState(false);
  const jingleAudioRef = useRef(null);

  const getAudioUrl = (sound) => getSoundStreamUrl(api, sound);

  const handleDownloadJingle = async () => {
    try {
      await downloadSoundAsset(api, jingleResult);
    } catch (e) {
      toast.error(e?.message || "Erro ao baixar áudio.");
    }
  };

  const toggleJinglePlay = () => {
    if (!jingleResult?.filename) return;
    if (jinglePlaying) {
      jingleAudioRef.current?.pause();
      setJinglePlaying(false);
    } else {
      if (!jingleAudioRef.current) {
        jingleAudioRef.current = new Audio(getAudioUrl(jingleResult));
        jingleAudioRef.current.onended = () => setJinglePlaying(false);
      }
      jingleAudioRef.current
        .play()
        .catch(() => toast.error("Erro ao reproduzir jingle."));
      setJinglePlaying(true);
    }
  };

  const set = (k, v) => setBrand((b) => ({ ...b, [k]: v }));

  const generate = async () => {
    if (!brand.briefing.trim()) {
      toast.error("Descreva o tema do criativo.");
      return;
    }
    setGenerating(true);
    setError("");
    setResult(null);
    try {
      const r = await api.post("/nexohub/generate-social-creative", brand);
      setResult(r.data);
    } catch (e) {
      setError(e?.response?.data?.detail || "Erro ao gerar criativo.");
    }
    setGenerating(false);

    if (jingleEnabled && jinglePrompt.trim()) {
      setGeneratingJingle(true);
      try {
        const jr = await api.post("/nexohub/sounds/generate", {
          name: `Jingle — ${brand.brand_name || brand.briefing.slice(0, 30)}`,
          prompt: jinglePrompt,
          duration: jingleDuration,
          instrumental: true,
        });
        setJingleResult(jr.data);
        toast.success("Jingle gerado e salvo na biblioteca!");
      } catch (e) {
        toast.error(
          "Criativo gerado, mas erro no jingle: " +
            (e?.response?.data?.detail || ""),
        );
      }
      setGeneratingJingle(false);
    }
  };

  const download = () => {
    if (!result?.image_base64) return;
    const a = document.createElement("a");
    a.href = `data:image/png;base64,${result.image_base64}`;
    a.download = `criativo-${brand.formato}-${Date.now()}.png`;
    a.click();
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 bg-gradient-to-br from-pink-500 to-orange-400 rounded-xl flex items-center justify-center shadow-md flex-shrink-0">
          <span className="text-white text-lg"><Ico e="🎨" bare /></span>
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-900">
            Gerador de Criativos com IA
          </h2>
          <p className="text-xs text-gray-400">
            Pexels + IA → criativo profissional em segundos
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-6 items-start">
        {/* ── Formulário */}
        <div className="">
          {/* Marca */}
          <div className="bg-white rounded-2xl border border-gray-100 p-5 ">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">
              Identidade da Marca
            </p>
            <div>
              <label className="text-xs font-semibold text-gray-500 block mb-1.5">
                Nome da marca
              </label>
              <input
                value={brand.brand_name}
                onChange={(e) => set("brand_name", e.target.value)}
                placeholder="Ex.: Clínica Bem-Estar"
                className="w-full text-sm border border-gray-200 rounded-xl px-4 py-2.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-400"
              />
            </div>
            <div className="flex gap-4 items-end">
              <div className="flex-1">
                <label className="text-xs font-semibold text-gray-500 block mb-1.5">
                  Cor principal
                </label>
                <div className="flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-2 bg-gray-50">
                  <input
                    type="color"
                    value={brand.primary_color}
                    onChange={(e) => set("primary_color", e.target.value)}
                    className="w-8 h-8 rounded-lg border-0 cursor-pointer p-0 bg-transparent"
                  />
                  <span className="text-sm font-mono text-gray-600">
                    {brand.primary_color}
                  </span>
                </div>
              </div>
              <div className="flex flex-col items-center gap-1.5">
                <div
                  className="w-[72px] h-[72px] rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center overflow-hidden cursor-pointer hover:border-pink-400 transition-colors"
                  onClick={() => logoRef.current?.click()}
                >
                  {brand.logo_base64 ? (
                    <img
                      src={brand.logo_base64}
                      alt="Logo"
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <span className="text-2xl"><Ico e="🏷" bare /></span>
                  )}
                </div>
                <span className="text-[10px] text-gray-400 font-semibold">
                  Logo (opcional)
                </span>
                <input
                  ref={logoRef}
                  type="file"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => {
                    const f = e.target.files?.[0];
                    if (!f) return;
                    const rd = new FileReader();
                    rd.onload = (ev) => set("logo_base64", ev.target.result);
                    rd.readAsDataURL(f);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Formato */}
          <div className="bg-white rounded-2xl border border-gray-100 p-5">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">
              Formato
            </p>
            <div className="flex gap-3">
              {FORMATOS.map((f) => (
                <button
                  key={f.id}
                  onClick={() => set("formato", f.id)}
                  className={`flex-1 flex flex-col items-center gap-1.5 py-3 rounded-xl border-2 transition-all ${brand.formato === f.id ? "border-pink-500 bg-pink-50" : "border-gray-200 bg-white hover:border-gray-300"}`}
                >
                  <span
                    className={`text-lg ${brand.formato === f.id ? "text-pink-500" : "text-gray-400"}`}
                  >
                    {f.icon}
                  </span>
                  <span
                    className={`text-xs font-bold ${brand.formato === f.id ? "text-pink-600" : "text-gray-500"}`}
                  >
                    {f.label}
                  </span>
                  <span className="text-[10px] text-gray-400">{f.ratio}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Briefing */}
          <div className="bg-white rounded-2xl border border-gray-100 p-5">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">
              Tema / Briefing
            </p>
            <textarea
              value={brand.briefing}
              onChange={(e) => set("briefing", e.target.value)}
              rows={4}
              placeholder="Ex.: Promoção de verão para academia, foco em musculação feminina, tom motivacional..."
              className="w-full text-sm border border-gray-200 rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-400 resize-none"
            />
          </div>

          {/* ── Seção de Jingle */}
          <div
            className={`rounded-2xl border-2 transition-all p-5  ${jingleEnabled ? "border-violet-300 bg-violet-50/30" : "border-dashed border-gray-200 bg-white"}`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2.5">
                <span className="text-xl"><Ico e="🎵" bare /></span>
                <div>
                  <p className="text-sm font-bold text-gray-800">
                    Gerar Jingle para esta campanha
                  </p>
                  <p className="text-xs text-gray-400">
                    IA cria uma música exclusiva e salva na Biblioteca
                  </p>
                </div>
              </div>
              <Toggle value={jingleEnabled} onChange={setJingleEnabled} />
            </div>

            {jingleEnabled && (
              <div className="space-y-3 pt-1">
                <div>
                  <label className="text-xs font-semibold text-gray-600 block mb-1.5">
                    Estilo musical / ritmo
                  </label>
                  <textarea
                    value={jinglePrompt}
                    onChange={(e) => setJinglePrompt(e.target.value)}
                    rows={3}
                    placeholder="Ex.: Jingle alegre estilo pop para campanha infantil, piano e percussão leve, clima divertido e acolhedor..."
                    className="w-full text-sm border border-violet-200 rounded-xl px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-violet-400 resize-none"
                  />
                </div>
                <div className="flex gap-4 items-center">
                  <div className="flex-1">
                    <label className="text-xs font-semibold text-gray-600 block mb-1.5">
                      Duração
                    </label>
                    <div className="flex gap-2">
                      {[15, 30, 60].map((d) => (
                        <button
                          key={d}
                          onClick={() => setJingleDuration(d)}
                          className={`flex-1 py-2 rounded-lg text-xs font-bold border-2 transition-all ${jingleDuration === d ? "border-violet-500 bg-violet-100 text-violet-700" : "border-gray-200 bg-white text-gray-500 hover:border-violet-200"}`}
                        >
                          {d}s
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="flex flex-col items-center gap-1 pt-4 text-center">
                    <span className="text-green-500 text-base">✓</span>
                    <span className="text-[10px] text-gray-500 font-semibold">
                      Instrumental
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {error && <p className="text-sm text-red-500 font-medium">{error}</p>}

          <button
            onClick={generate}
            disabled={generating || generatingJingle}
            className="w-full py-3.5 bg-gradient-to-r from-pink-500 to-orange-400 text-white font-bold text-sm rounded-xl hover:opacity-90 transition-all shadow-md flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {generating ? (
              <>
                <Spinner /> Gerando criativo... aguarde ~10s
              </>
            ) : generatingJingle ? (
              <>
                <Spinner /> Gerando jingle... aguarde ~30s
              </>
            ) : (
              <>
                <span><Ico e="🎨" bare /></span> Gerar Criativo
                {jingleEnabled ? <> + <Ico e="🎵" />Jingle</> : " com IA"}
              </>
            )}
          </button>
        </div>

        {/* ── Preview */}
        <div className="sticky top-4 ">
          {result ? (
            <div className="space-y-3">
              {/* Imagem gerada */}
              <div
                className={`relative overflow-hidden rounded-2xl shadow-xl bg-gray-900 ${brand.formato === "feed" ? "aspect-square" : "aspect-[9/16]"}`}
              >
                <img
                  src={`data:image/png;base64,${result.image_base64}`}
                  alt="Criativo gerado"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Copy gerado */}
              <div className="bg-white rounded-xl border border-gray-100 p-4 space-y-2">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                  Copy gerado pela IA
                </p>
                <p className="text-sm font-bold text-gray-800">
                  "{result.copy?.headline}"
                </p>
                <p className="text-xs text-gray-500">{result.copy?.subtitle}</p>
                <span className="inline-block text-xs font-bold text-white bg-blue-600 px-3 py-1 rounded-full">
                  {result.copy?.cta}
                </span>
              </div>

              {/* Atribuição Pexels */}
              {result.photo_author && (
                <p className="text-[10px] text-gray-400 text-center">
                  <Ico e="📷" />Foto:{" "}
                  <a
                    href={result.photo_page}
                    target="_blank"
                    rel="noreferrer"
                    className="underline hover:text-gray-600"
                  >
                    {result.photo_author}
                  </a>{" "}
                  via Pexels
                </p>
              )}

              {/* Jingle gerado */}
              {jingleResult && (
                <div className="bg-violet-50 border border-violet-200 rounded-xl p-4 space-y-2">
                  <p className="text-[10px] font-bold text-violet-500 uppercase tracking-widest">
                    <Ico e="🎵" />Jingle Gerado
                  </p>
                  <p className="text-sm font-semibold text-gray-800">
                    {jingleResult.name}
                  </p>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={toggleJinglePlay}
                      className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-all ${jinglePlaying ? "bg-violet-600 text-white" : "bg-white border border-violet-300 text-violet-600 hover:bg-violet-100"}`}
                    >
                      {jinglePlaying ? <><Ico e="⏸" /></> : "▶"}
                    </button>
                    {jinglePlaying && (
                      <div className="flex gap-0.5 items-end h-4">
                        {[...Array(8)].map((_, i) => (
                          <div
                            key={i}
                            className="w-1 bg-violet-500 rounded-full animate-pulse"
                            style={{
                              height: `${30 + Math.sin(i * 0.8) * 40}%`,
                              animationDelay: `${i * 0.1}s`,
                            }}
                          />
                        ))}
                      </div>
                    )}
                    <span className="text-xs text-gray-500">
                      {jingleResult.duration}s •{" "}
                      {jingleResult.instrumental ? "Instrumental" : "Com vocal"}
                    </span>
                    <button
                      onClick={handleDownloadJingle}
                      className="ml-auto text-xs font-bold text-violet-600 hover:text-violet-800"
                    >
                      ↓ Download
                    </button>
                  </div>
                  <p className="text-[10px] text-violet-400">
                    Salvo automaticamente na Biblioteca → Sons
                  </p>
                </div>
              )}
              {generatingJingle && (
                <div className="bg-violet-50 border border-violet-200 rounded-xl p-4 flex items-center gap-3">
                  <Spinner />
                  <div>
                    <p className="text-sm font-semibold text-violet-700">
                      Gerando jingle...
                    </p>
                    <p className="text-xs text-violet-400">
                      IA compondo a trilha sonora da campanha
                    </p>
                  </div>
                </div>
              )}

              {/* Ações */}
              <div className="flex gap-2">
                <button
                  onClick={download}
                  className="flex-1 py-2.5 bg-gray-900 text-white text-sm font-bold rounded-xl hover:bg-gray-700 transition-colors flex items-center justify-center gap-1.5"
                >
                  ↓ Baixar PNG
                </button>
                <button
                  onClick={generate}
                  disabled={generating || generatingJingle}
                  className="px-4 py-2.5 border-2 border-gray-200 text-gray-600 text-sm font-bold rounded-xl hover:border-gray-300 transition-colors disabled:opacity-50"
                >
                  <Ico e="🔄" />Novo
                </button>
              </div>
            </div>
          ) : (
            <div className="aspect-square bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex flex-col items-center justify-center text-center p-8 border-2 border-dashed border-gray-200">
              {generating ? (
                <>
                  <Spinner />
                  <p className="text-sm font-semibold text-gray-500 mt-4">
                    Buscando foto no Pexels...
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    IA gerando copy e montando o criativo
                  </p>
                </>
              ) : (
                <>
                  <span className="text-5xl mb-3"><Ico e="🎨" bare /></span>
                  <p className="text-sm font-semibold text-gray-500">
                    Preview aparece aqui
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    Preencha o briefing e clique em Gerar
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function CriarComIATab({ api }) {
  const [subTab, setSubTab] = useState("campanhas");
  const [bk, setBk] = useState(null);
  const [openCampaign, setOpenCampaign] = useState(null);

  useEffect(() => {
    api
      .get("/nexohub/brand-kit")
      .then((r) => setBk(r.data))
      .catch(() => {});
  }, [api]);

  return (
    <div className="space-y-5">
      {/* Sub-tabs */}
      <div className="flex items-center gap-1 bg-gray-100 rounded-xl p-1 w-fit">
        <button
          onClick={() => setSubTab("campanhas")}
          className={`flex items-center gap-1.5 px-4 py-2 text-xs font-bold rounded-lg transition-all ${subTab === "campanhas" ? "bg-white shadow-sm text-gray-800" : "text-gray-500 hover:text-gray-700"}`}
        >
          <Ico e="✨" />Campanhas
        </button>
        <button
          onClick={() => setSubTab("criativo")}
          className={`flex items-center gap-1.5 px-4 py-2 text-xs font-bold rounded-lg transition-all ${subTab === "criativo" ? "bg-white shadow-sm text-gray-800" : "text-gray-500 hover:text-gray-700"}`}
        >
          <Ico e="🎨" />Criativo com IA
        </button>
      </div>

      {subTab === "campanhas" ? (
        <CampanhasTab api={api} />
      ) : (
        <SocialCreativeGenerator api={api} initialBk={bk} />
      )}
    </div>
  );
}

// ─── Componente principal NexoHub ──────────────────────────────────────────────
export default function NexoHub({ api }) {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [requirements, setRequirements] = useState(null);

  const TABS = [
    { id: "dashboard", label: "Dashboard", icon: <Ico e="📊" bare /> },
    { id: "posts", label: "Posts", icon: <Ico e="📝" bare /> },
    { id: "criarai", label: "Criar com IA", icon: <Ico e="✨" bare /> },
    { id: "sounds", label: "Sounds", icon: <Ico e="🎵" bare /> },
    { id: "meta-ads", label: "Meta Ads", icon: <Ico e="📣" bare /> },
    { id: "contas", label: "Redes Sociais", icon: <Ico e="🔗" bare /> },
    { id: "biblioteca", label: "Biblioteca", icon: "#️⃣" },
  ];

  const renderTab = () => {
    switch (activeTab) {
      case "dashboard":
        return <DashboardTab api={api} onNavigate={setActiveTab} />;
      case "posts":
        return <PostsTab api={api} />;
      case "criarai":
        return <CriarComIATab api={api} />;
      case "sounds":
        return <SoundsTab api={api} />;
      case "videoai":
        return <VideoIATab api={api} />;
      case "meta-ads":
        return <MetaCampaigns api={api} />;
      case "contas":
        return <ContasSociaisTab api={api} />;
      case "biblioteca":
        return <BibliotecaTab api={api} />;
      default:
        return <DashboardTab api={api} onNavigate={setActiveTab} />;
    }
  };

  useEffect(() => {
    api
      .get("/nexohub/requirements")
      .then((r) => setRequirements(r.data))
      .catch(() => setRequirements(null));
  }, [api]);

  const requirementEntries = Object.entries(requirements?.requirements || {});
  const readyCount = requirementEntries.filter(
    ([, item]) => item?.ready,
  ).length;

  return (
    <div className="h-full overflow-auto bg-slate-50">
      <div className="p-6 space-y-6">
        <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-gradient-to-r from-slate-900 via-slate-800 to-blue-900 text-white shadow-lg">
          <div className="flex flex-col gap-6 p-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-semibold text-white/85 backdrop-blur">
                <span><Ico e="⚙" bare /></span>
                Hub de campanhas, posts, criativos e áudio
              </div>
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/12 text-sm font-bold shadow-inner shadow-white/10">
                  NH
                </div>
                <div>
                  <h1 className="text-2xl font-bold tracking-tight text-white">
                    NexoHub
                  </h1>
                  <p className="mt-1 text-sm text-slate-300">
                    Campanhas com IA, geração de posts, criativos e jingles no
                    mesmo fluxo.
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 lg:min-w-[360px]">
              <div className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-300">
                  Status
                </p>
                <p className="mt-2 text-lg font-bold">
                  {requirements?.ready
                    ? "Operacional"
                    : "Configuração pendente"}
                </p>
                <p className="mt-1 text-xs text-slate-300">
                  {requirements?.missing_items?.length
                    ? `${requirements.missing_items.length} item(ns) faltando`
                    : "Nenhuma dependência crítica pendente"}
                </p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-300">
                  Módulos prontos
                </p>
                <p className="mt-2 text-lg font-bold">
                  {requirements
                    ? `${readyCount}/${requirementEntries.length}`
                    : "..."}
                </p>
                <p className="mt-1 text-xs text-slate-300">
                  Campanhas, criativos, jingles e narração
                </p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-300">
                  Fluxo atual
                </p>
                <p className="mt-2 text-lg font-bold">Campanha → Posts</p>
                <p className="mt-1 text-xs text-slate-300">
                  A criação com IA já gera rascunhos automaticamente
                </p>
              </div>
            </div>
          </div>

          {requirementEntries.length > 0 && (
            <div className="grid gap-3 border-t border-white/10 bg-white/5 p-6 md:grid-cols-2 xl:grid-cols-5">
              {requirementEntries.map(([key, item]) => (
                <RequirementStatusCard
                  key={key}
                  title={item.label}
                  item={item}
                />
              ))}
            </div>
          )}
        </div>

        <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white p-1 shadow-sm">
          <div className="flex min-w-max gap-1">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold transition-all whitespace-nowrap ${
                  activeTab === tab.id
                    ? "bg-slate-900 text-white shadow-sm"
                    : "text-slate-500 hover:bg-slate-50 hover:text-slate-800"
                }`}
              >
                <span>{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="min-h-[calc(100vh-20rem)] rounded-[28px] border border-slate-200 bg-gradient-to-b from-white to-slate-50/60 p-6 shadow-sm">
          {renderTab()}
        </div>
      </div>
    </div>
  );
}
